/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 1904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-widget{display:flex;align-items:center}.account-widget__user .v-chip{max-width:220px}@media only screen and (max-width:959.98px){.account-widget__user .v-chip{margin-right:0}}.account-widget__user__logout{margin-left:12px}.account-widget__login{display:flex;align-items:center}.account-widget__login__password,.account-widget__login__username{display:inline-flex;width:200px;margin-right:12px!important}@media only screen and (max-width:959.98px){.account-widget__login__password,.account-widget__login__username{width:160px;margin-right:0!important}.account-widget__login__button,.account-widget__login__password{margin-top:12px!important}.account-widget__login{display:flex;flex-direction:column;justify-content:flex-end;align-items:center}}.account-widget__google-sign-in-button{margin-left:12px!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forgotten-password-form .theme--dark.v-btn:disabled{background-color:#eee!important;color:#bdbdbd!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-form__google-sign-in-button{max-width:-moz-fit-content;max-width:fit-content;margin:auto;padding:4px 48px;cursor:pointer}.login-form__google-sign-in-button .button__icon{display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;background-color:#fff}.login-form__google-sign-in-button:hover{color:#0d47a1}.login-form .theme--dark.v-btn:disabled{background-color:#eee!important;color:#bdbdbd!important}.login-form__decorated{display:grid;grid-template-columns:1fr auto 1fr;gap:16px;align-items:center}.login-form__decorated:after,.login-form__decorated:before{content:\"\";display:block;border-top:1px solid #bdbdbd}.login-form__forgot-password{text-transform:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-widget{display:grid;gap:12px;height:100%;grid-template-rows:auto 1fr;align-items:center}.login-widget__menu{list-style:none;width:100%;max-width:400px;margin:auto}.login-widget__menu li{text-transform:uppercase;font-weight:500;color:#757575;border-bottom:1px solid transparent;cursor:pointer}.login-widget__menu li.active{color:#212121;border-bottom-color:currentColor;pointer-events:none;cursor:none}.login-widget__menu li.active--clickable{pointer-events:auto;cursor:pointer}.login-widget__menu li:hover{color:#bdbdbd;border-bottom-color:currentColor}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-action-form__fieldGroup{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;padding:12px;padding-bottom:unset}@media only screen and (min-width:960px){.vp-mapping-action-form__fieldGroup{grid-template-columns:auto minmax(0,1fr) minmax(0,1.5fr) auto}.vp-mapping-action-form__fieldGroup--actionField{grid-template-columns:auto minmax(0,1fr) minmax(0,2.5fr) auto}}@media only screen and (max-width:959.98px){.vp-mapping-action-form__fieldGroup>section{grid-column:1/-1}.vp-mapping-action-form__fieldGroup__btnGroup,.vp-mapping-action-form__fieldGroup__title{grid-row:1}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-condition-form{position:relative;border:2px solid var(--vp-mt-bck);border-radius:4px}.vp-mapping-condition-form__fieldGroup{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px 16px;min-height:66px;padding:12px;padding-top:24px;padding-bottom:unset;background:var(--vp-mt-bck);border-top-left-radius:2px;border-top-right-radius:2px}@media only screen and (min-width:1264px){.vp-mapping-condition-form__fieldGroup{grid-template-columns:auto auto minmax(0,1fr)}.vp-mapping-condition-form__fieldGroup--showingInputs{grid-template-columns:auto minmax(0,1fr) minmax(0,.5fr) minmax(0,1fr) auto}}@media only screen and (max-width:1263.98px){.vp-mapping-condition-form__fieldGroup>section{grid-column:1/-1}.vp-mapping-condition-form__fieldGroup__btnGroup,.vp-mapping-condition-form__fieldGroup__title{grid-row:1}}.vp-mapping-condition-form__buttons{padding:8px}.vp-mapping-condition-form__else{position:absolute;bottom:-56px;left:50%;transform:translateX(-50%);z-index:1}.vp-mapping-condition-form__else__content{display:flex;place-items:center;padding:4px 12px;background:var(--vp-mt-bck);border:2px solid var(--vp-mt-bck);border-radius:4px}.vp-mapping-condition-form__else__content:after,.vp-mapping-condition-form__else__content:before{content:\"\";display:block;position:absolute;top:-10px;left:50%;width:2px;height:10px;margin-left:-2px;background:var(--vp-mt-bck);z-index:0}.vp-mapping-condition-form__else__content:after{top:unset;bottom:-10px}.vp-mapping-condition-form:last-child .vp-mapping-condition-form__else{display:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-rule{position:relative;display:grid;grid-template-columns:minmax(0,1fr);gap:16px;width:100%}.vp-mapping-rule__header{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px}.vp-mapping-rule__header__btnGroup .vp-rule-dialog{display:contents}.vp-mapping-rule.nested-rule{background:unset!important;box-shadow:unset!important}.vp-mapping-rule.nested-rule .vp-mapping-rule__header__title{padding-top:1px}.vp-mapping-rule:not(.nested-rule){padding:16px}.vp-mapping-rule:not(.nested-rule):after{content:\"\";display:block;position:absolute;bottom:-38px;left:50%;margin-left:-2px;width:2px;height:35px;background:var(--vp-mt-bck);z-index:0}@media only screen and (min-width:600px){.vp-mapping-rule:not(.nested-rule):last-child:after{display:none}}.vp-mapping-rule:not(.nested-rule) .vp-mapping-rule__header__title{display:flex;align-items:center;overflow-wrap:anywhere;font-size:.95rem!important;line-height:1rem}.vp-mapping-rule:not(.nested-rule).theme--light.v-card{background:var(--vp-mt-bck)}.vp-mapping-rule:not(.nested-rule).theme--light.v-card.required-field{background:var(--vp-mt-required)}.vp-mapping-rule:not(.nested-rule).theme--light.v-card.complete{background:var(--vp-mt-complete)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-nested-rule{display:flex;gap:4px;height:100%;padding-top:1px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-reorder-icons{display:contents}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-tool-results{padding:16px}.vp-mapping-tool-results.theme--light .theme--light.v-sheet,.vp-mapping-tool-results.theme--light.v-card{background:var(--vp-mt-bck)}.vp-mapping-tool-results .data-table__table{margin-top:unset!important;margin-bottom:unset!important}.vp-mapping-tool-results .data-table__table__settings{background-color:unset}@media only screen and (min-width:600px){.vp-mapping-tool-results .data-table__table__results .v-data-table__wrapper{overflow:auto;max-height:calc(100vh - 318px)}}@media only screen and (min-width:1264px){.vp-mapping-tool-results .data-table__table__results .v-data-table__wrapper .v-data-table-header{position:sticky;top:0;background-color:var(--vp-mt-table-header-background);z-index:1}}.vp-mapping-tool-results .data-table__table__results .vp-mapping-tool-results__content{display:block;margin:8px 0}.vp-mapping-tool-results .data-table__table__results .vp-mapping-tool-results__content__moreBtn{margin-bottom:8px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mt-dialog>.vp-card{--vp-card__padding--xs:16px 0}.vp-mt-dialog .v-text-field--solo .v-input__slot{border:2px solid var(--vp-mt-bck)}.v-dialog__content--active:has(~.v-dialog__content--active) .vp-mt-dialog,.v-overlay--active:has(~.v-overlay--active){display:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-rule-form .v-tabs-bar{display:none}.vp-mapping-rule-form__conditions{display:grid;grid-template-columns:minmax(0,1fr);gap:64px}.vp-mapping-rule-form__buttons{padding:8px 0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-mapping-tool,.vp-mt-dialog{--vp-mt-light-text-primary:rgba(0,0,0,.87);--vp-mt-dark-text-primary:#fff;--vp-mt-light-background:#fff;--vp-mt-dark-background:#121212;--vp-mt-primary:var(--v-primary-base);--vp-mt-secondary:var(--v-secondary-base);--vp-mt-bck:#f5f5f5;--vp-mt-bck--dark:#e6e7f0;--vp-mt-required:#ffe0b6;--vp-mt-required--dark:#ecc792;--vp-mt-complete:#a8e4d8;--vp-mt-complete--dark:#75bfb0;--vp-mt-table-header-background:#fff}.vp-mapping-tool__content{display:grid;grid-template-columns:minmax(0,1fr);gap:32px}@media only screen and (min-width:600px){.vp-mapping-tool__content{grid-template-columns:250px minmax(0,1fr)}}.vp-mapping-tool__content__legend{grid-column:1/-1}.vp-mapping-tool__content__legend .v-stepper__header{display:flex;flex-wrap:wrap;flex-direction:column;gap:12px;width:-moz-max-content;width:max-content;height:unset;box-shadow:unset}@media only screen and (min-width:360px){.vp-mapping-tool__content__legend .v-stepper__header{flex-direction:unset;width:unset}}@media only screen and (min-width:412px){.vp-mapping-tool__content__legend .v-stepper__header{gap:32px;width:-moz-max-content;width:max-content}}.vp-mapping-tool__content__legend .v-stepper__step{padding:0}.vp-mapping-tool__content__legend .v-stepper__step__step .v-icon{display:none}.vp-mapping-tool__content__legend.theme--light .v-stepper__step .v-stepper__step__step{margin-right:8px;background:var(--vp-mt-bck)!important;border:2px solid var(--vp-mt-bck--dark)!important}.vp-mapping-tool__content__legend.theme--light .v-stepper__step.required-field .v-stepper__step__step{background:var(--vp-mt-required)!important;border-color:var(--vp-mt-required--dark)!important}.vp-mapping-tool__content__legend.theme--light .v-stepper__step.complete .v-stepper__step__step{background:var(--vp-mt-complete)!important;border-color:var(--vp-mt-complete--dark)!important}.vp-mapping-tool__content__legend.theme--light.v-stepper .v-stepper__step .v-stepper__label{display:block;font-weight:700;text-shadow:unset}.vp-mapping-tool__content__tiles{display:grid;grid-template-columns:minmax(0,1fr);grid-auto-rows:max-content;gap:32px}.vp-mapping-tool__content__results .vp-mapping-tool-results{position:sticky;top:80px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-value-settings-editor__fieldGroup--actionField{display:grid;grid-template-columns:minmax(0,1fr);gap:16px}@media only screen and (min-width:600px){.vp-value-settings-editor__fieldGroup--actionField{grid-template-columns:minmax(0,1fr) minmax(0,.6fr)}}.vp-value-settings-editor__fieldGroup__valueTypes{display:grid;grid-template-columns:120px minmax(0,1fr);align-items:flex-start}.vp-value-settings-editor__fieldGroup__valueTypes--rule{gap:16px}.vp-value-settings-editor__fieldGroup__valueTypes__type.v-text-field--solo .v-input__slot{border-color:var(--vp-mt-bck--dark)!important}.vp-value-settings-editor__fieldGroup__valueTypes__type:not(.vp-value-settings-editor__fieldGroup__valueTypes__type--rule){border-top-right-radius:0}.vp-value-settings-editor__fieldGroup__valueTypes__column .v-input__slot,.vp-value-settings-editor__fieldGroup__valueTypes__value .v-input__slot{border-left:none!important;border-top-left-radius:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".password-reset-form .theme--dark.v-btn:disabled{background-color:#eee!important;color:#bdbdbd!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profileForm__oauthLoginMessages{margin-top:24px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-project-selector{--vp-project-selector__shadow:0px 0px 12px 0px rgba(0,0,0,.16);--vp-project-selector__icon--bck:#fafafa;--vp-project-selector__icon--border-radius:50px}.vp-project-selector.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot{box-shadow:var(--vp-project-selector__shadow)}.vp-project-selector .v-icon{border-radius:var(--vp-project-selector__icon--border-radius)}.vp-project-selector.theme--light .v-icon{background:var(--vp-project-selector__icon--bck)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-projectTeams__addTeam{display:flex;align-items:center}.vp-projectTeams__addTeam .v-input__slot{margin:0}.vp-projectTeams__addTeam .v-text-field__details{display:none}.vp-projectTeams__addTeam__btnAdd{margin-left:12px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-form__sign-up-btn.theme--dark.v-btn:disabled{background-color:#eee!important;color:#bdbdbd!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vp-settings__form{--vp-field-group__grid-template-columns--min:550px}.vp-settings__form__fieldset legend{overflow-wrap:break-word}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5500);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2312);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2312:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 5500:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 9924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1904);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("44fd0ae8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("bd2d3eae", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7136);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("9043c2b8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7900:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6240);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("c208957a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4100);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("69239bb8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9276:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1112);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("1a1f96af", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(144);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("0af278aa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5560);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("23d916aa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1876);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("c006fdfe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6996);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("6223254b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8408);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("5835163c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3784);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("91a5958c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9632);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("68430cbe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6404);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("09b829cd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7020);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("5c5d96f8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("a0b94cd0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9468);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("5d2920e4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7640);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("2d276654", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6164);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("11103ca4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4112);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("024fe5ce", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3208);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("7691b378", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2972);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("d4a75614", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4444);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("d97e1708", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5620);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("1fc9ae3a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6304);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("27538a7d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2228);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("1dc32f1e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8072);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("f484e5d6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8268);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("7fff8862", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9420);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("7ac35141", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2252);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("7857f0c7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3144);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("c3f4ce04", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5992);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("678c2e30", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2412);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("6520cdb6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3736);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("32a99718", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2560);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("d146e154", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5384);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(8024)/* ["default"] */ .c)
var update = add("ead79138", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  c: function() { return /* binding */ addStylesClient; }
});

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external "vuetify/lib/components/VAvatar"
var VAvatar_namespaceObject = require("vuetify/lib/components/VAvatar");
;// CONCATENATED MODULE: external "vuetify/lib/components/VBtn"
var VBtn_namespaceObject = require("vuetify/lib/components/VBtn");
;// CONCATENATED MODULE: external "vuetify/lib/components/VChip"
var VChip_namespaceObject = require("vuetify/lib/components/VChip");
;// CONCATENATED MODULE: external "vuetify/lib/components/VDivider"
var VDivider_namespaceObject = require("vuetify/lib/components/VDivider");
;// CONCATENATED MODULE: external "vuetify/lib/components/VIcon"
var VIcon_namespaceObject = require("vuetify/lib/components/VIcon");
;// CONCATENATED MODULE: external "vuetify/lib/components/VList"
var VList_namespaceObject = require("vuetify/lib/components/VList");
;// CONCATENATED MODULE: external "vuetify/lib/components/VMenu"
var VMenu_namespaceObject = require("vuetify/lib/components/VMenu");
;// CONCATENATED MODULE: external "vuetify/lib/components/VTextField"
var VTextField_namespaceObject = require("vuetify/lib/components/VTextField");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/account-widget/_template.html?vue&type=template&id=aaf1c6bc&external














var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "account-widget"
  }, [_vm.$user ? _c('div', {
    staticClass: "account-widget__user"
  }, [_c(VMenu_namespaceObject.VMenu, {
    attrs: {
      "offset-y": "",
      "disabled": _vm.menuItems.length <= 0 && !_vm.logoutInMenu,
      "dark": _vm.dark
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VChip_namespaceObject.VChip, _vm._g(_vm._b({
          staticClass: "account-widget__user__name",
          attrs: {
            "label": "",
            "outlined": !_vm.dark,
            "dark": _vm.dark
          }
        }, 'v-chip', attrs, false), on), [_c(VAvatar_namespaceObject.VAvatar, {
          attrs: {
            "left": ""
          }
        }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-account-circle")])], 1), _c('span', [_vm._v(_vm._s(_vm.$user.fullName))])], 1)];
      }
    }], null, false, 2410246803),
    model: {
      value: _vm.showMenu,
      callback: function ($$v) {
        _vm.showMenu = $$v;
      },
      expression: "showMenu"
    }
  }, [_c(VList_namespaceObject.VList, [_c(VList_namespaceObject.VListItem, {
    attrs: {
      "link": ""
    }
  }, [_c(VList_namespaceObject.VListItemIcon, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-account-circle")])], 1), _c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, {
    staticClass: "text-h6"
  }, [_vm._v(" " + _vm._s(_vm.$user.fullName) + " ")]), _c(VList_namespaceObject.VListItemSubtitle, [_vm._v(_vm._s(_vm.$user.email))])], 1)], 1)], 1), _c(VDivider_namespaceObject.VDivider), _c(VList_namespaceObject.VList, {
    attrs: {
      "nav": ""
    }
  }, [_vm._l(_vm.menuItems, function (item, i) {
    return [_c(VList_namespaceObject.VListItem, {
      key: 'item' + i,
      attrs: {
        "href": item.uri || null,
        "to": item.route || null,
        "link": ""
      },
      model: {
        value: item.active,
        callback: function ($$v) {
          _vm.$set(item, "active", $$v);
        },
        expression: "item.active"
      }
    }, [_c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, [_vm._v(_vm._s(item.title))])], 1)], 1)];
  })], 2), _vm.logoutInMenu ? [_c(VDivider_namespaceObject.VDivider), _c(VList_namespaceObject.VList, {
    attrs: {
      "nav": ""
    }
  }, [_c(VList_namespaceObject.VListItem, {
    on: {
      "click": _vm.onLogout
    }
  }, [_c(VList_namespaceObject.VListItemContent, [_c(VList_namespaceObject.VListItemTitle, [_vm._v(_vm._s(_vm.$t('authentication.action.logout')))])], 1)], 1)], 1)] : _vm._e()], 2), !_vm.logoutInMenu ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "account-widget__user__logout",
    attrs: {
      "icon": _vm.$vuetify.breakpoint.smAndDown,
      "small": _vm.$vuetify.breakpoint.mdAndUp,
      "dark": _vm.dark,
      "text": _vm.text
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-logout-variant")]) : [_vm._v(_vm._s(_vm.$t('authentication.action.logout')))]], 2) : _vm._e()], 1) : _c('div', {
    staticClass: "account-widget__login"
  }, [_c(VTextField_namespaceObject.VTextField, {
    staticClass: "account-widget__login__username",
    attrs: {
      "label": _vm.$t('authentication.field.username'),
      "solo": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.onLogin.apply(null, arguments);
      }
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "account-widget__login__password",
    attrs: {
      "label": _vm.$t('authentication.field.password'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.onLogin.apply(null, arguments);
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "account-widget__login__button",
    attrs: {
      "small": "",
      "dark": _vm.dark,
      "text": _vm.text
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.login')) + " ")])], 1), !_vm.$user ? _c('google-sign-in-button', {
    staticClass: "account-widget__google-sign-in-button",
    attrs: {
      "logo": _vm.googleLogo,
      "config": _vm.googleSignInConfig
    },
    on: {
      "logged-in-code": _vm.onLoginGoogleCode,
      "logged-in-token": _vm.onLoginGoogleToken,
      "logged-out": _vm.onLogout
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/account-widget/_template.html?vue&type=template&id=aaf1c6bc&external

;// CONCATENATED MODULE: external "tslib"
var external_tslib_namespaceObject = require("tslib");
;// CONCATENATED MODULE: external "vue-property-decorator"
var external_vue_property_decorator_namespaceObject = require("vue-property-decorator");
;// CONCATENATED MODULE: ./src/model/event/event.ts
var Event;
(function (Event) {
  Event["SessionExpired"] = "SessionExpired";
})(Event || (Event = {}));
/* harmony default export */ var event_event = (Event);
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/event/event-bus"
var event_bus_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/event/event-bus");
var event_bus_default = /*#__PURE__*/__webpack_require__.n(event_bus_namespaceObject);
;// CONCATENATED MODULE: ./src/model/exception/exception.ts
var Exception;
(function (Exception) {
  Exception["UserNotFound"] = "UserNotFound";
})(Exception || (Exception = {}));
/* harmony default export */ var exception = (Exception);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/account-widget/_logic.ts?vue&type=script&lang=ts&external





let AccountWidgetComponent = class AccountWidgetComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.username = '';
    this.password = '';
    this.showPassword = false;
    this.googleSignIn = false;
    this.showMenu = false;
  }
  created() {
    this.initEvents();
  }
  /**
   * Initialises events
   */
  initEvents() {
    event_bus_default().instance.$on(event_event.SessionExpired, () => this.onSessionExpired());
  }
  /**
   * Handles login
   */
  onLogin() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const user = yield this.$serviceContainer.authenticationService.login(this.username, this.password);
        if (!user) {
          return;
        }
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      }
    });
  }
  /**
   * Handles Google login via auth code
   *
   * @param code
   * @returns
   */
  onLoginGoogleCode(code) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const user = yield this.$serviceContainer.authenticationService.loginGoogle(null, code);
        if (!user) {
          return;
        }
        // Signed in with Google
        this.googleSignIn = true;
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      }
    });
  }
  /**
   * Handles Google login via id token
   *
   * @param token
   * @returns
   */
  onLoginGoogleToken(token) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const user = yield this.$serviceContainer.authenticationService.loginGoogle(token);
        if (!user) {
          return;
        }
        // Signed in with Google
        this.googleSignIn = true;
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      }
    });
  }
  /**
   * Handles login success
   *
   * @param user
   */
  onLoginSuccess(user) {
    // Reset the username and password
    this.username = '';
    this.password = '';
    // Emit an event that can be handled
    this.$emit('logged-in', user);
    // Inform the user they are logged in
    event_bus_default().instance.$emit('notification', this.$t('general.message.welcome_back_name', {
      name: user.firstName
    }), 'success');
  }
  /**
   * Handles login failure
   *
   * @param error
   */
  onLoginFailure(error) {
    // Reset the password
    this.password = '';
    // Emit an event that can be handled
    this.$emit('login-failed');
    // Inform the user of the login error
    switch (error) {
      case exception.UserNotFound:
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.login_failed_invalid_details'), 'error');
        break;
      default:
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.login_failed_server_error'), 'error');
    }
  }
  /**
   * Handles session expiry events
   */
  onSessionExpired() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Log the user out
      this.onLogout();
      // Inform the user of the session expiry
      event_bus_default().instance.$emit('notification', this.$t('authentication.message.session_expired'), 'error');
    });
  }
  /**
   * Handles logout
   */
  onLogout() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Hide the menu
      this.showMenu = false;
      // Sign out of Google
      yield this.logoutGoogle();
      // Logout
      this.$serviceContainer.authenticationService.logout();
      // Emit an event that can be handled
      this.$emit('logged-out');
    });
  }
  /**
   * Logs out of Google
   */
  logoutGoogle() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Mark as signed out
      this.googleSignIn = false;
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], AccountWidgetComponent.prototype, "googleLogo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], AccountWidgetComponent.prototype, "googleSignInConfig", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], AccountWidgetComponent.prototype, "dark", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], AccountWidgetComponent.prototype, "text", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], AccountWidgetComponent.prototype, "menuItems", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], AccountWidgetComponent.prototype, "logoutInMenu", void 0);
AccountWidgetComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], AccountWidgetComponent);
/* harmony default export */ var _logicvue_type_script_lang_ts_external = (AccountWidgetComponent);
;// CONCATENATED MODULE: ./src/components/account-widget/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var account_widget_logicvue_type_script_lang_ts_external = (_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/account-widget/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var _stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(9924);
;// CONCATENATED MODULE: ./src/components/account-widget/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/account-widget/index.vue



;


/* normalize component */

var component = normalizeComponent(
  account_widget_logicvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var account_widget = (component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/login/_template.html?vue&type=template&id=bfdf5b12&external
var _templatevue_type_template_id_bfdf5b12_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-widget"
  }, [!_vm.disableStandardLogin && !_vm.$user ? _c('ul', {
    staticClass: "login-widget__menu d-flex justify-space-around"
  }, [_c('li', {
    class: {
      active: _vm.pageType == 'login-form',
      'active active--clickable': _vm.pageType == 'forgotten-password-form'
    },
    on: {
      "click": function ($event) {
        return _vm.setPageType('login-form');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.login')) + " ")]), _c('li', {
    class: {
      active: _vm.pageType == 'register-form'
    },
    on: {
      "click": function ($event) {
        return _vm.setPageType('register-form');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.new_user')) + " ")])]) : _vm._e(), _vm.pageType == 'login-form' ? _c('vp-login-form', {
    attrs: {
      "googleLogo": _vm.googleLogo,
      "googleSignInConfig": _vm.googleSignInConfig,
      "disableGoogleLogin": _vm.disableGoogleLogin,
      "disableStandardLogin": _vm.disableStandardLogin
    },
    on: {
      "pageType": _vm.setPageType,
      "logged-in": user => _vm.$emit('logged-in', user),
      "logged-out": function ($event) {
        return _vm.$emit('logged-out');
      },
      "forgotten-password": function ($event) {
        return _vm.setPageType('forgotten-password-form');
      }
    }
  }) : _vm.pageType == 'register-form' ? _c('vp-register-form', {
    on: {
      "registration-successful": function ($event) {
        return _vm.setPageType('login-form');
      }
    }
  }) : _vm.pageType == 'forgotten-password-form' ? _c('vp-forgotten-password-form', {
    on: {
      "password-reset-requested": function ($event) {
        return _vm.$emit('password-reset-requested');
      }
    }
  }) : _vm.pageType == 'password-reset-form' ? _c('vp-password-reset-form', {
    attrs: {
      "token": _vm.passwordResetToken
    },
    on: {
      "password-reset": function ($event) {
        return _vm.$emit('password-reset');
      }
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_bfdf5b12_external_staticRenderFns = [];

;// CONCATENATED MODULE: external "vuetify/lib/components/VAlert"
var VAlert_namespaceObject = require("vuetify/lib/components/VAlert");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/forgotten-password-form/_template.html?vue&type=template&id=071a6fd1&external




var _templatevue_type_template_id_071a6fd1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "forgotten-password-form text-center"
  }, [_vm.h1 ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.forgot_password_heading')))]) : _vm._e(), _vm.requestReceived ? [_c(VAlert_namespaceObject.VAlert, {
    staticClass: "d-inline-block mt-6",
    attrs: {
      "dense": "",
      "outlined": "",
      "text": "",
      "type": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.message.password_reset_request_received')) + " ")])] : [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.forgot_password_content')))]), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.$t('authentication.field.email'),
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "block": "",
      "dark": "",
      "loading": _vm.sending,
      "disabled": !_vm.valid || _vm.sending
    },
    on: {
      "click": _vm.onResetPassword
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.reset_password')) + " ")])]], 2);
};
var _templatevue_type_template_id_071a6fd1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/forgotten-password-form/_template.html?vue&type=template&id=071a6fd1&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/forgotten-password-form/_logic.ts?vue&type=script&lang=ts&external



let ForgottenPasswordFormComponent = class ForgottenPasswordFormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.email = '';
    this.sending = false;
    this.requestReceived = false;
  }
  get valid() {
    const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, 'gm');
    return emailRegex.test(this.email);
  }
  onResetPassword() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.valid) {
        return;
      }
      try {
        this.sending = true;
        yield this.$serviceContainer.authenticationService.passwordResetRequest(this.email);
        this.requestReceived = true;
        this.$emit('password-reset-requested');
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.password_reset_failed'), 'error');
      } finally {
        this.sending = false;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: true
})], ForgottenPasswordFormComponent.prototype, "h1", void 0);
ForgottenPasswordFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ForgottenPasswordFormComponent);
/* harmony default export */ var forgotten_password_form_logicvue_type_script_lang_ts_external = (ForgottenPasswordFormComponent);
;// CONCATENATED MODULE: ./src/components/forgotten-password-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_forgotten_password_form_logicvue_type_script_lang_ts_external = (forgotten_password_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/forgotten-password-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var forgotten_password_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(2783);
;// CONCATENATED MODULE: ./src/components/forgotten-password-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/forgotten-password-form/index.vue



;


/* normalize component */

var forgotten_password_form_component = normalizeComponent(
  components_forgotten_password_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_071a6fd1_external_render,
  _templatevue_type_template_id_071a6fd1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var forgotten_password_form = (forgotten_password_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/login-form/_template.html?vue&type=template&id=52b0c866&external




var _templatevue_type_template_id_52b0c866_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-login-form login-form"
  }, [_vm.$user ? _c('div', {
    staticClass: "text-center"
  }, [_c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "icon": _vm.$vuetify.breakpoint.smAndDown,
      "small": _vm.$vuetify.breakpoint.mdAndUp
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-logout-variant")]) : [_vm._v(_vm._s(_vm.$t('authentication.action.logout')))]], 2)], 1) : _c('div', [_vm.h1 ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.message.login_heading')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "text-center"
  }, [!_vm.disableGoogleLogin ? [!_vm.$user ? _c('google-sign-in-button', {
    staticClass: "login-form__google-sign-in-button white elevation-4 rounded-lg d-flex justify-center align-center",
    class: {
      'elevation-2': _vm.signInHover
    },
    attrs: {
      "logo": _vm.googleLogo,
      "config": _vm.googleSignInConfig
    },
    on: {
      "logged-in-code": _vm.onLoginGoogleCode,
      "logged-in-token": _vm.onLoginGoogleToken,
      "logged-out": _vm.onLogout
    },
    nativeOn: {
      "mouseover": function ($event) {
        _vm.signInHover = true;
      },
      "mouseleave": function ($event) {
        _vm.signInHover = false;
      }
    }
  }) : _vm._e()] : _vm._e(), !_vm.disableGoogleLogin && !_vm.disableStandardLogin ? [_vm._m(0)] : _vm._e(), !_vm.disableStandardLogin ? [_c(VTextField_namespaceObject.VTextField, {
    staticClass: "login-form__login__username mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.username'),
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.onLogin.apply(null, arguments);
      }
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "login-form__login__password rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.password'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.onLogin.apply(null, arguments);
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })] : _vm._e()], 2), !_vm.disableStandardLogin ? [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "login-form__forgot-password float-right my-4",
    attrs: {
      "plain": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('forgotten-password');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.forgot_your_password')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "block": "",
      "dark": "",
      "loading": _vm.loggingIn,
      "disabled": !_vm.valid || _vm.loggingIn
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.sign_in')) + " ")])] : _vm._e()], 2)]);
};
var _templatevue_type_template_id_52b0c866_external_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "login-form__decorated my-10"
  }, [_c('strong', [_vm._v("or")])]);
}];

;// CONCATENATED MODULE: ./src/components/login-form/_template.html?vue&type=template&id=52b0c866&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/login-form/_logic.ts?vue&type=script&lang=ts&external





let LoginFormComponent = class LoginFormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.username = '';
    this.password = '';
    this.showPassword = false;
    this.signInHover = false;
    this.googleSignIn = false;
    this.loggingIn = false;
  }
  created() {
    this.initEvents();
  }
  get valid() {
    return !!(this.username && this.password);
  }
  /**
   * Initialises events
   */
  initEvents() {
    event_bus_default().instance.$on(event_event.SessionExpired, () => this.onSessionExpired());
  }
  /**
   * Handles login
   */
  onLogin() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        this.loggingIn = true;
        const user = yield this.$serviceContainer.authenticationService.login(this.username, this.password);
        if (!user) {
          return;
        }
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      } finally {
        this.loggingIn = false;
      }
    });
  }
  /**
   * Handles Google login via auth code
   *
   * @param code
   * @returns
   */
  onLoginGoogleCode(code) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const user = yield this.$serviceContainer.authenticationService.loginGoogle(null, code);
        if (!user) {
          return;
        }
        // Signed in with Google
        this.googleSignIn = true;
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      }
    });
  }
  /**
   * Handles Google login via id token
   *
   * @param token
   * @returns
   */
  onLoginGoogleToken(token) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const user = yield this.$serviceContainer.authenticationService.loginGoogle(token);
        if (!user) {
          return;
        }
        // Signed in with Google
        this.googleSignIn = true;
        this.onLoginSuccess(user);
      } catch (error) {
        this.onLoginFailure(error);
      }
    });
  }
  /**
   * Handles login success
   *
   * @param user
   */
  onLoginSuccess(user) {
    // Reset the username and password
    this.username = '';
    this.password = '';
    // Emit an event that can be handled
    this.$emit('logged-in', user);
    // Inform the user they are logged in
    event_bus_default().instance.$emit('notification', this.$t('general.message.welcome_back_name', {
      name: user.firstName
    }), 'success');
  }
  /**
   * Handles login failure
   *
   * @param error
   */
  onLoginFailure(error) {
    // Reset the password
    this.password = '';
    // Emit an event that can be handled
    this.$emit('login-failed');
    // Inform the user of the login error
    switch (error) {
      case exception.UserNotFound:
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.login_failed_invalid_details'), 'error');
        break;
      default:
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.login_failed_server_error'), 'error');
    }
  }
  /**
   * Handles session expiry events
   */
  onSessionExpired() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Log the user out
      this.onLogout();
      // Inform the user of the session expiry
      event_bus_default().instance.$emit('notification', this.$t('authentication.message.session_expired'), 'error');
    });
  }
  /**
   * Handles logout
   */
  onLogout() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Sign out of Google
      yield this.logoutGoogle();
      // Logout
      this.$serviceContainer.authenticationService.logout();
      // Emit an event that can be handled
      this.$emit('logged-out');
    });
  }
  /**
   * Logs out of Google
   */
  logoutGoogle() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Mark as signed out
      this.googleSignIn = false;
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], LoginFormComponent.prototype, "googleLogo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], LoginFormComponent.prototype, "googleSignInConfig", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: true
})], LoginFormComponent.prototype, "h1", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], LoginFormComponent.prototype, "disableGoogleLogin", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], LoginFormComponent.prototype, "disableStandardLogin", void 0);
LoginFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], LoginFormComponent);
/* harmony default export */ var login_form_logicvue_type_script_lang_ts_external = (LoginFormComponent);
;// CONCATENATED MODULE: ./src/components/login-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_login_form_logicvue_type_script_lang_ts_external = (login_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/login-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var login_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1388);
;// CONCATENATED MODULE: ./src/components/login-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/login-form/index.vue



;


/* normalize component */

var login_form_component = normalizeComponent(
  components_login_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_52b0c866_external_render,
  _templatevue_type_template_id_52b0c866_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var login_form = (login_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/password-reset-form/_template.html?vue&type=template&id=47fef7c2&external




var _templatevue_type_template_id_47fef7c2_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reset-password-form"
  }, [_vm.h1 ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.reset_password_heading')))]) : _vm._e(), _vm.resetSuccessful ? [_c(VAlert_namespaceObject.VAlert, {
    attrs: {
      "dense": "",
      "outlined": "",
      "text": "",
      "type": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.message.password_reset_successful')) + " ")])] : [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.reset_password_content')))]), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "reset-password-form__password mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.password'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "reset-password-form__password mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.password_confirm'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    },
    model: {
      value: _vm.passwordConfirm,
      callback: function ($$v) {
        _vm.passwordConfirm = $$v;
      },
      expression: "passwordConfirm"
    }
  }), _c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "block": "",
      "dark": "",
      "loading": _vm.resetting,
      "disabled": !_vm.valid || _vm.resetting
    },
    on: {
      "click": _vm.onResetPassword
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.reset_password')) + " ")])]], 2);
};
var _templatevue_type_template_id_47fef7c2_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/password-reset-form/_template.html?vue&type=template&id=47fef7c2&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/password-reset-form/_logic.ts?vue&type=script&lang=ts&external



let PasswordResetFormComponent = class PasswordResetFormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.password = '';
    this.passwordConfirm = '';
    this.resetting = false;
    this.resetSuccessful = false;
  }
  get valid() {
    return !!(this.password && this.password === this.passwordConfirm);
  }
  onResetPassword() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.valid) {
        return;
      }
      try {
        this.resetting = true;
        yield this.$serviceContainer.authenticationService.passwordReset(this.token, this.password);
        this.resetSuccessful = true;
        this.$emit('password-reset');
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.password_reset_failed'), 'error');
      } finally {
        this.resetting = false;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], PasswordResetFormComponent.prototype, "token", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: true
})], PasswordResetFormComponent.prototype, "h1", void 0);
PasswordResetFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], PasswordResetFormComponent);
/* harmony default export */ var password_reset_form_logicvue_type_script_lang_ts_external = (PasswordResetFormComponent);
;// CONCATENATED MODULE: ./src/components/password-reset-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_password_reset_form_logicvue_type_script_lang_ts_external = (password_reset_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/password-reset-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var password_reset_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(4228);
;// CONCATENATED MODULE: ./src/components/password-reset-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/password-reset-form/index.vue



;


/* normalize component */

var password_reset_form_component = normalizeComponent(
  components_password_reset_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_47fef7c2_external_render,
  _templatevue_type_template_id_47fef7c2_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var password_reset_form = (password_reset_form_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VCheckbox"
var VCheckbox_namespaceObject = require("vuetify/lib/components/VCheckbox");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/register-form/_template.html?vue&type=template&id=747d86fc&external




var _templatevue_type_template_id_747d86fc_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "register-form"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.register_heading')))]), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('authentication.message.register_content')))]), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "register-form__first-name mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.first_name'),
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    model: {
      value: _vm.firstName,
      callback: function ($$v) {
        _vm.firstName = $$v;
      },
      expression: "firstName"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "register-form__last-name mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.last_name'),
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    model: {
      value: _vm.lastName,
      callback: function ($$v) {
        _vm.lastName = $$v;
      },
      expression: "lastName"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "register-form__email mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.email'),
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "register-form__password mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.password'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "register-form__password mb-5 rounded-lg",
    attrs: {
      "label": _vm.$t('authentication.field.password_confirm'),
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": _vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "solo": "",
      "dense": "",
      "hide-details": "",
      "background-color": "grey lighten-4"
    },
    on: {
      "click:append": function ($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    },
    model: {
      value: _vm.passwordConfirm,
      callback: function ($$v) {
        _vm.passwordConfirm = $$v;
      },
      expression: "passwordConfirm"
    }
  }), _c(VCheckbox_namespaceObject.VCheckbox, {
    attrs: {
      "label": _vm.$t('authentication.field.register_terms')
    },
    model: {
      value: _vm.terms,
      callback: function ($$v) {
        _vm.terms = $$v;
      },
      expression: "terms"
    }
  }), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "register-form__sign-up-btn",
    attrs: {
      "block": "",
      "dark": "",
      "disabled": !_vm.valid || _vm.registering
    },
    on: {
      "click": _vm.onRegister
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('authentication.action.sign_up')) + " ")])], 1);
};
var _templatevue_type_template_id_747d86fc_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/register-form/_template.html?vue&type=template&id=747d86fc&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/register-form/_logic.ts?vue&type=script&lang=ts&external



let RegisterFomComponent = class RegisterFomComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.password = '';
    this.passwordConfirm = '';
    this.showPassword = false;
    this.terms = false;
    this.registering = false;
  }
  /**
   * Whether registration details are valid
   */
  get valid() {
    return !!(this.firstName && this.lastName && this.email && this.password === this.passwordConfirm && this.terms);
  }
  /**
   * Handles login
   */
  onRegister() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        this.registering = true;
        yield this.$serviceContainer.authenticationService.register(this.firstName, this.lastName, this.email, this.password);
        this.onRegisterSuccess();
      } catch (error) {
        this.onRegisterFailure(error);
      } finally {
        this.registering = false;
      }
    });
  }
  /**
   * Handles registration success
   */
  onRegisterSuccess() {
    // Reset the form
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.password = '';
    this.passwordConfirm = '';
    // Emit an event that can be handled
    this.$emit('registration-successful');
    // Inform the user they have registered
    event_bus_default().instance.$emit('notification', this.$t('authentication.message.registration_successful'), 'success');
  }
  /**
   * Handles registration failure
   *
   * @param error
   */
  onRegisterFailure(error) {
    // Reset the password
    this.password = '';
    this.passwordConfirm = '';
    // Emit an event that can be handled
    this.$emit('registration-failed');
    // Inform the user of the login error
    switch (error) {
      default:
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.registration_failed'), 'error');
    }
  }
};
RegisterFomComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], RegisterFomComponent);
/* harmony default export */ var register_form_logicvue_type_script_lang_ts_external = (RegisterFomComponent);
;// CONCATENATED MODULE: ./src/components/register-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_register_form_logicvue_type_script_lang_ts_external = (register_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/register-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var register_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(948);
;// CONCATENATED MODULE: ./src/components/register-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/register-form/index.vue



;


/* normalize component */

var register_form_component = normalizeComponent(
  components_register_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_747d86fc_external_render,
  _templatevue_type_template_id_747d86fc_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var register_form = (register_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/login/_logic.ts?vue&type=script&lang=ts&external






let Login = class Login extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.pageType = 'login-form';
  }
  created() {
    this.onPasswordResetTokenChange();
  }
  onPasswordResetTokenChange() {
    if (this.passwordResetToken) {
      this.setPageType('password-reset-form');
    } else {
      this.setPageType('login-form');
    }
  }
  // Set the page (component) to load
  setPageType(pageType) {
    this.pageType = pageType;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], Login.prototype, "passwordResetToken", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: String
})], Login.prototype, "googleLogo", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], Login.prototype, "googleSignInConfig", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], Login.prototype, "disableGoogleLogin", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], Login.prototype, "disableStandardLogin", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('passwordResetToken')], Login.prototype, "onPasswordResetTokenChange", null);
Login = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-forgotten-password-form': forgotten_password_form,
    'vp-login-form': login_form,
    'vp-register-form': register_form,
    'vp-password-reset-form': password_reset_form
  }
})], Login);
/* harmony default export */ var login_logicvue_type_script_lang_ts_external = (Login);
;// CONCATENATED MODULE: ./src/components/login/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_login_logicvue_type_script_lang_ts_external = (login_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/login/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var login_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(7900);
;// CONCATENATED MODULE: ./src/components/login/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/login/index.vue



;


/* normalize component */

var login_component = normalizeComponent(
  components_login_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_bfdf5b12_external_render,
  _templatevue_type_template_id_bfdf5b12_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var login = (login_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VAutocomplete"
var VAutocomplete_namespaceObject = require("vuetify/lib/components/VAutocomplete");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/mappable-field/_template.html?vue&type=template&id=13d99fc1&external


var _templatevue_type_template_id_13d99fc1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showQuickSelector,
      expression: "showQuickSelector"
    }],
    staticClass: "vp-mappable-field"
  }, [_vm.takeAction ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    attrs: {
      "items": _vm.sourceDataFields,
      "label": _vm.$t('mapping.action.choose_column'),
      "placeholder": _vm.$t('mapping.action.choose_column_placeholder'),
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": "",
      "auto-select-first": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.mappedField,
      callback: function ($$v) {
        _vm.mappedField = $$v;
      },
      expression: "mappedField"
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_13d99fc1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/mappable-field/_template.html?vue&type=template&id=13d99fc1&external

;// CONCATENATED MODULE: external "core-js/modules/es.array.push.js"
var es_array_push_js_namespaceObject = require("core-js/modules/es.array.push.js");
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/content/array-helper"
var array_helper_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/content/array-helper");
var array_helper_default = /*#__PURE__*/__webpack_require__.n(array_helper_namespaceObject);
;// CONCATENATED MODULE: external "core-js/modules/es.array.with.js"
var es_array_with_js_namespaceObject = require("core-js/modules/es.array.with.js");
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/model/validator/abstract-validator"
var abstract_validator_namespaceObject = require("@vertical-plus/vue-js-core/dist/model/validator/abstract-validator");
var abstract_validator_default = /*#__PURE__*/__webpack_require__.n(abstract_validator_namespaceObject);
;// CONCATENATED MODULE: ./src/model/validator/mapping-tool/abstract-mapping-validator.ts


class AbstractMappingValidator extends (abstract_validator_default()) {
  validateValueSettings(valueSettings, validationErrors) {
    const errors = [];
    if (!valueSettings) {
      return errors;
    }
    if ('value' in valueSettings && typeof valueSettings.value !== 'string') {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    } else if ('valueRuleId' in valueSettings && !valueSettings.valueRuleId) {
      errors.push(this.i18n.t('mapping.validation.please_add_rule').toString());
    } else if ('valueColumn' in valueSettings && !valueSettings.valueColumn) {
      errors.push(this.i18n.t('mapping.validation.please_select_column').toString());
    }
    return errors;
  }
}
;// CONCATENATED MODULE: ./src/model/service/abstract-service.ts
class AbstractService {
  /**
   * Constructor
   */
  constructor(store) {
    this.store = store;
  }
  /**
   * Returns the current user's id
   */
  get userId() {
    const user = this.store.getters['authentication/user'];
    return user ? user.id : null;
  }
  /**
   * Returns the authentication token for authenticated tasks
   */
  get token() {
    return this.store.getters['authentication/token'];
  }
}
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-api-platform/dist/model/exception/exception"
var exception_exception_namespaceObject = require("@vertical-plus/vue-js-api-platform/dist/model/exception/exception");
var exception_default = /*#__PURE__*/__webpack_require__.n(exception_exception_namespaceObject);
;// CONCATENATED MODULE: ./src/model/service/abstract-authenticated-service.ts



class AbstractAuthenticatedService extends AbstractService {
  /**
   * Constructor
   */
  constructor(store, authenticationService) {
    super(store);
    this.authenticationService = authenticationService;
  }
  /**
   * Runs a task, refreshing the token as appropriate
   *
   * @param task
   * @returns
   */
  runTask(task) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        return yield task.run();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catch (error) {
        switch (error.message) {
          case (exception_default()).TokenExpired:
            // Refresh the token
            yield this.authenticationService.refreshToken();
            // Re-try the request with the new token
            task.token = this.token;
            return task.run();
          default:
            throw error;
        }
      }
    });
  }
}
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-api-platform/dist/model/task/abstract-delete-task"
var abstract_delete_task_namespaceObject = require("@vertical-plus/vue-js-api-platform/dist/model/task/abstract-delete-task");
var abstract_delete_task_default = /*#__PURE__*/__webpack_require__.n(abstract_delete_task_namespaceObject);
;// CONCATENATED MODULE: ./src/model/task/mapping/action/delete-action-task.ts



class DeleteActionTask extends (abstract_delete_task_default()) {
  constructor() {
    super(...arguments);
    this.id = '';
  }
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return;
      }
      switch (response.status) {
        case 404:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return `/actions/${this.id}`;
  }
}
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-api-platform/dist/model/task/abstract-get-task"
var abstract_get_task_namespaceObject = require("@vertical-plus/vue-js-api-platform/dist/model/task/abstract-get-task");
var abstract_get_task_default = /*#__PURE__*/__webpack_require__.n(abstract_get_task_namespaceObject);
;// CONCATENATED MODULE: ./src/model/task/mapping/action/get-action-task.ts




class GetActionTask extends (abstract_get_task_default()) {
  constructor() {
    super(...arguments);
    this.id = '';
  }
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return new Action(response.data);
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return `/actions/${this.id}`;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/action/get-actions-task.ts





class GetActionsTask extends (abstract_get_task_default()) {
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        const searchResults = this.parseSearchResults(response);
        const actions = [];
        for (const actionDto of searchResults.results) {
          actions.push(new Action(actionDto));
        }
        searchResults.results = actions;
        return searchResults;
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return '/actions';
  }
  get params() {
    if (!this.searchConditions) {
      return null;
    }
    return this.generateParamsFromData(this.searchConditions);
  }
}
;// CONCATENATED MODULE: external "@vertical-plus/vue-js-api-platform/dist/model/task/abstract-post-task"
var abstract_post_task_namespaceObject = require("@vertical-plus/vue-js-api-platform/dist/model/task/abstract-post-task");
var abstract_post_task_default = /*#__PURE__*/__webpack_require__.n(abstract_post_task_namespaceObject);
;// CONCATENATED MODULE: ./src/model/task/mapping/action/post-action-task.ts




class PostActionTask extends (abstract_post_task_default()) {
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return new Action(response.data);
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return '/actions';
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get data() {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = Object.assign({}, this.action.dto);
    delete data.id;
    data.condition = `/conditions/${(_a = this.action.dto.condition) === null || _a === void 0 ? void 0 : _a.id}`;
    return data;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/action/put-action-task.ts

class PutActionTask extends PostActionTask {
  get url() {
    return `/actions/${this.action.id}`;
  }
  get method() {
    return 'PUT';
  }
  get successCode() {
    return 200;
  }
}
;// CONCATENATED MODULE: ./src/model/service/mapping/action-service.ts







class ActionService extends AbstractAuthenticatedService {
  /**
   * Find actions using search conditions
   * @param searchConditions
   * @returns
   */
  findActions(searchConditions) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new GetActionsTask();
      task.token = this.token;
      task.searchConditions = searchConditions;
      return this.runTask(task);
    });
  }
  /**
   * Load a single action
   * @param id
   * @returns
   */
  loadAction(id) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new GetActionTask();
      task.token = this.token;
      task.id = id;
      return this.runTask(task);
    });
  }
  /**
   * Create a new action
   *
   * @param action
   * @returns
   */
  createAction(action) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new PostActionTask();
      task.token = this.token;
      task.action = action;
      return this.runTask(task);
    });
  }
  /**
   * Update an action
   *
   * @param action
   * @returns
   */
  updateAction(action) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new PutActionTask();
      task.token = this.token;
      task.action = action;
      return this.runTask(task);
    });
  }
  /**
   * Delete an action
   *
   * @param id
   * @returns
   */
  deleteAction(id) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new DeleteActionTask();
      task.token = this.token;
      task.id = id;
      return this.runTask(task);
    });
  }
  /**
   * Return the types as an array
   */
  static get TYPES() {
    return [ActionService.TYPE_TAKE, ActionService.TYPE_ADD, ActionService.TYPE_SUBTRACT, ActionService.TYPE_MULTIPLY, ActionService.TYPE_DIVIDE, ActionService.TYPE_APPEND, ActionService.TYPE_PREPEND, ActionService.TYPE_TRIM, ActionService.TYPE_TRIM_START, ActionService.TYPE_TRIM_END, ActionService.TYPE_TRUNCATE, ActionService.TYPE_ROUND, ActionService.TYPE_ROUND_HALF_DOWN, ActionService.TYPE_CEIL, ActionService.TYPE_FLOOR, ActionService.TYPE_CASE_UPPER, ActionService.TYPE_CASE_LOWER, ActionService.TYPE_CASE_TITLE, ActionService.TYPE_CASE_SENTENCE, ActionService.TYPE_REPLACE, ActionService.TYPE_REPLACE_CI, ActionService.TYPE_PAD_START, ActionService.TYPE_PAD_END, ActionService.TYPE_SLUG, ActionService.TYPE_SPLIT, ActionService.TYPE_JOIN, ActionService.TYPE_ARRAY_CREATE, ActionService.TYPE_ARRAY_APPEND, ActionService.TYPE_ARRAY_PREPEND, ActionService.TYPE_ARRAY_FILTER, ActionService.TYPE_ARRAY_EXTRACT, ActionService.TYPE_HTML_STRIP_IMAGES, ActionService.TYPE_HTML_STRIP_STYLING, ActionService.TYPE_HTML_FROM_MARKDOWN, ActionService.TYPE_HTML_TO_MARKDOWN, ActionService.TYPE_URLENCODE];
  }
  /**
   * Return the type options for a select
   *
   * TODO update to use translations if possible
   */
  static get TYPE_OPTIONS() {
    return [{
      text: 'Take',
      value: ActionService.TYPE_TAKE
    }, {
      text: '',
      value: '',
      header: 'Maths'
    }, {
      text: 'Add',
      value: ActionService.TYPE_ADD
    }, {
      text: 'Subtract',
      value: ActionService.TYPE_SUBTRACT
    }, {
      text: 'Multiply',
      value: ActionService.TYPE_MULTIPLY
    }, {
      text: 'Divide',
      value: ActionService.TYPE_DIVIDE
    }, {
      text: 'Round',
      value: ActionService.TYPE_ROUND
    }, {
      text: 'Round (half down)',
      value: ActionService.TYPE_ROUND_HALF_DOWN
    }, {
      text: 'Ceil',
      value: ActionService.TYPE_CEIL
    }, {
      text: 'Floor',
      value: ActionService.TYPE_FLOOR
    }, {
      text: '',
      value: '',
      header: 'String'
    }, {
      text: 'Append',
      value: ActionService.TYPE_APPEND
    }, {
      text: 'Prepend',
      value: ActionService.TYPE_PREPEND
    }, {
      text: 'Trim',
      value: ActionService.TYPE_TRIM
    }, {
      text: 'Trim (start)',
      value: ActionService.TYPE_TRIM_START
    }, {
      text: 'Trim (end)',
      value: ActionService.TYPE_TRIM_END
    }, {
      text: 'Truncate',
      value: ActionService.TYPE_TRUNCATE
    }, {
      text: 'Upper case',
      value: ActionService.TYPE_CASE_UPPER
    }, {
      text: 'Lower case',
      value: ActionService.TYPE_CASE_LOWER
    }, {
      text: 'Title case',
      value: ActionService.TYPE_CASE_TITLE
    }, {
      text: 'Replace',
      value: ActionService.TYPE_REPLACE
    }, {
      text: 'Replace (ignore case)',
      value: ActionService.TYPE_REPLACE_CI
    }, {
      text: 'Pad (start)',
      value: ActionService.TYPE_PAD_START
    }, {
      text: 'Pad (end)',
      value: ActionService.TYPE_PAD_END
    }, {
      text: 'Slugify',
      value: ActionService.TYPE_SLUG
    }, {
      text: 'Split',
      value: ActionService.TYPE_SPLIT
    }, {
      text: 'Join',
      value: ActionService.TYPE_JOIN
    }, {
      text: 'URL Encode',
      value: ActionService.TYPE_URLENCODE
    }, {
      text: '',
      value: '',
      header: 'Array'
    }, {
      text: 'Create Array',
      value: ActionService.TYPE_ARRAY_CREATE
    }, {
      text: 'Append',
      value: ActionService.TYPE_ARRAY_APPEND
    }, {
      text: 'Prepend',
      value: ActionService.TYPE_ARRAY_PREPEND
    }, {
      text: 'Filter',
      value: ActionService.TYPE_ARRAY_FILTER
    }, {
      text: 'Extract',
      value: ActionService.TYPE_ARRAY_EXTRACT
    }, {
      text: '',
      value: '',
      header: 'HTML'
    }, {
      text: 'Strip Images',
      value: ActionService.TYPE_HTML_STRIP_IMAGES
    }, {
      text: 'Strip Styling',
      value: ActionService.TYPE_HTML_STRIP_STYLING
    }, {
      text: 'To Markdown',
      value: ActionService.TYPE_HTML_TO_MARKDOWN
    }, {
      text: 'From Markdown',
      value: ActionService.TYPE_HTML_FROM_MARKDOWN
    }];
  }
  /**
   * Return an array of types that should show the with option
   */
  static get WITH_TYPES() {
    return [ActionService.TYPE_REPLACE, ActionService.TYPE_REPLACE_CI, ActionService.TYPE_PAD_START, ActionService.TYPE_PAD_END];
  }
  /**
   * Return an array of types that should show the separator option
   */
  static get SEPARATOR_TYPES() {
    return [ActionService.TYPE_APPEND, ActionService.TYPE_PREPEND, ActionService.TYPE_SPLIT, ActionService.TYPE_JOIN];
  }
  /**
   * Return an array of types that should not have a value
   */
  static get STANDALONE_TYPES() {
    return [ActionService.TYPE_CEIL, ActionService.TYPE_FLOOR, ActionService.TYPE_CASE_UPPER, ActionService.TYPE_CASE_LOWER, ActionService.TYPE_CASE_SENTENCE, ActionService.TYPE_CASE_TITLE, ActionService.TYPE_SLUG, ActionService.TYPE_ARRAY_CREATE, ActionService.TYPE_ARRAY_FILTER, ActionService.TYPE_HTML_STRIP_IMAGES, ActionService.TYPE_HTML_STRIP_STYLING, ActionService.TYPE_HTML_FROM_MARKDOWN, ActionService.TYPE_HTML_TO_MARKDOWN, ActionService.TYPE_URLENCODE];
  }
}
ActionService.TYPE_TAKE = 'take';
ActionService.TYPE_SET = 'set';
ActionService.TYPE_ADD = 'add';
ActionService.TYPE_SUBTRACT = 'subtract';
ActionService.TYPE_MULTIPLY = 'multiply';
ActionService.TYPE_DIVIDE = 'divide';
ActionService.TYPE_APPEND = 'append';
ActionService.TYPE_PREPEND = 'prepend';
ActionService.TYPE_TRIM = 'trim';
ActionService.TYPE_TRIM_START = 'trim_start';
ActionService.TYPE_TRIM_END = 'trim_end';
ActionService.TYPE_TRUNCATE = 'truncate';
ActionService.TYPE_ROUND = 'round';
ActionService.TYPE_ROUND_HALF_DOWN = 'round_half_down';
ActionService.TYPE_CEIL = 'ceil';
ActionService.TYPE_FLOOR = 'floor';
ActionService.TYPE_CASE_UPPER = 'upper_case';
ActionService.TYPE_CASE_LOWER = 'lower_case';
ActionService.TYPE_CASE_TITLE = 'title_case';
ActionService.TYPE_CASE_SENTENCE = 'sentence_case';
ActionService.TYPE_REPLACE = 'replace';
ActionService.TYPE_REPLACE_CI = 'replace_ci';
ActionService.TYPE_PAD_START = 'pad_start';
ActionService.TYPE_PAD_END = 'pad_end';
ActionService.TYPE_SLUG = 'slug';
ActionService.TYPE_SPLIT = 'split';
ActionService.TYPE_JOIN = 'join';
ActionService.TYPE_ARRAY_CREATE = 'array_convert';
ActionService.TYPE_ARRAY_APPEND = 'array_append';
ActionService.TYPE_ARRAY_PREPEND = 'array_prepend';
ActionService.TYPE_ARRAY_FILTER = 'array_filter';
ActionService.TYPE_ARRAY_EXTRACT = 'array_extract';
ActionService.TYPE_HTML_STRIP_IMAGES = 'strip_images';
ActionService.TYPE_HTML_STRIP_STYLING = 'strip_styling';
ActionService.TYPE_HTML_FROM_MARKDOWN = 'from_markdown';
ActionService.TYPE_HTML_TO_MARKDOWN = 'to_markdown';
ActionService.TYPE_URLENCODE = 'urlencode';
;// CONCATENATED MODULE: ./src/model/validator/mapping-tool/action-validator.ts




class ActionValidator extends AbstractMappingValidator {
  constructor() {
    super(...arguments);
    this.index = null;
  }
  validate(action) {
    this.errors = {};
    if (!action) {
      return this.errors;
    }
    this.validateType(action, this.errors);
    this.validateValue(action, this.errors);
    this.validateSeparator(action, this.errors);
    this.validateWith(action, this.errors);
    return this.errors;
  }
  validateType(action, validationErrors) {
    if (!action) {
      return;
    }
    const errors = [];
    if (!ActionService.TYPES.includes(action.type)) {
      errors.push(this.i18n.t('mapping.validation.please_select_type').toString());
    } else if (this.index === 0 && action.type !== 'take') {
      errors.push(this.i18n.t('mapping.validation.first_action_type').toString());
    }
    if (errors.length > 0) {
      validationErrors.type = errors;
    }
  }
  validateValue(action, validationErrors) {
    if (!action || !action.type) {
      return;
    }
    if (ActionService.STANDALONE_TYPES.includes(action.type)) {
      return;
    }
    let errors = [];
    if (action.valueSettings && Object.keys(action.valueSettings).length) {
      errors = this.validateValueSettings(action.valueSettings, validationErrors);
    } else {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    }
    if (errors.length > 0) {
      validationErrors.valueSettings = errors;
    }
  }
  validateWith(action, validationErrors) {
    if (!action || !action.type) {
      return;
    }
    if (!ActionService.WITH_TYPES.includes(action.type)) {
      return;
    }
    const errors = [];
    if (!action.valueSettings || !('with' in action.valueSettings) || action.valueSettings.with === null) {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    }
    if (errors.length > 0) {
      validationErrors.with = errors;
    }
  }
  validateSeparator(action, validationErrors) {
    if (!action || !action.type) {
      return;
    }
    if (!ActionService.SEPARATOR_TYPES.includes(action.type)) {
      return;
    }
    const errors = [];
    if (!action.valueSettings || !('separator' in action.valueSettings) || action.valueSettings.separator === null) {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    }
    if (errors.length > 0) {
      validationErrors.with = errors;
    }
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/action/action.ts


class Action {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get condition() {
    if (!this.dto.condition) {
      return null;
    }
    return new Condition(this.dto.condition);
  }
  set condition(condition) {
    if (condition) {
      this.dto.condition = condition.dto;
    } else {
      this.dto.condition = null;
    }
  }
  get type() {
    return this.dto.type;
  }
  set type(type) {
    this.dto.type = type;
  }
  get valueSettings() {
    return this.dto.valueSettings;
  }
  set valueSettings(valueSettings) {
    this.dto.valueSettings = valueSettings;
  }
  get position() {
    return this.dto.position;
  }
  set position(position) {
    this.dto.position = position;
  }
  /**
   * Return the parameters to create/update this action
   * @returns ActionParamsInterface
   */
  get params() {
    const params = {
      type: this.type,
      valueSettings: this.valueSettings,
      position: this.position
    };
    return params;
  }
  /**
   * Return the object to validate this entity
   *
   * @returns ActionValidator
   */
  get validator() {
    return new ActionValidator();
  }
  /**
   * Returns the validation errors from the form
   */
  get validationErrors() {
    return this.validator.validate(this);
  }
  /**
   * Returns whether the form is valid
   */
  get valid() {
    return Object.keys(this.validationErrors).length === 0;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/action/action-dto.ts
class ActionDto {
  constructor() {
    this.id = 0;
    this.condition = null;
    this.type = '';
    this.valueSettings = {};
    this.position = 1;
    this._valueRule = null;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/condition/delete-condition-task.ts



class DeleteConditionTask extends (abstract_delete_task_default()) {
  constructor() {
    super(...arguments);
    this.id = '';
  }
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return;
      }
      switch (response.status) {
        case 404:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return `/conditions/${this.id}`;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/condition/get-condition-task.ts




class GetConditionTask extends (abstract_get_task_default()) {
  constructor() {
    super(...arguments);
    this.id = '';
  }
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return new Condition(response.data);
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return `/conditions/${this.id}`;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/condition/get-conditions-task.ts





class GetConditionsTask extends (abstract_get_task_default()) {
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        const searchResults = this.parseSearchResults(response);
        const conditions = [];
        for (const conditionDto of searchResults.results) {
          conditions.push(new Condition(conditionDto));
        }
        searchResults.results = conditions;
        return searchResults;
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return '/conditions';
  }
  get params() {
    if (!this.searchConditions) {
      return null;
    }
    return this.generateParamsFromData(this.searchConditions);
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/condition/post-condition-task.ts




class PostConditionTask extends (abstract_post_task_default()) {
  run() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const response = yield this.execute();
      if (response.status === this.successCode) {
        return new Condition(response.data);
      }
      switch (response.status) {
        case 401:
          throw new Error((exception_default()).InvalidDetails);
        default:
          throw new Error((exception_default()).UnknownError);
      }
    });
  }
  get url() {
    return '/conditions';
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get data() {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = Object.assign({}, this.condition.dto);
    delete data.id;
    delete data.actions;
    data.rule = `/rules/${(_a = this.condition.dto.rule) === null || _a === void 0 ? void 0 : _a.id}`;
    return data;
  }
}
;// CONCATENATED MODULE: ./src/model/task/mapping/condition/put-condition-task.ts

class PutConditionTask extends PostConditionTask {
  get url() {
    return `/conditions/${this.condition.id}`;
  }
  get method() {
    return 'PUT';
  }
  get successCode() {
    return 200;
  }
}
;// CONCATENATED MODULE: ./src/model/service/mapping/condition-service.ts







class ConditionService extends AbstractAuthenticatedService {
  /**
   * Find conditions using search conditions
   * @param searchConditions
   * @returns
   */
  findConditions(searchConditions) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new GetConditionsTask();
      task.token = this.token;
      task.searchConditions = searchConditions;
      return this.runTask(task);
    });
  }
  /**
   * Load a single condition
   * @param id
   * @returns
   */
  loadCondition(id) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new GetConditionTask();
      task.token = this.token;
      task.id = id;
      return this.runTask(task);
    });
  }
  /**
   * Create a new condition
   *
   * @param condition
   * @returns
   */
  createCondition(condition) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new PostConditionTask();
      task.token = this.token;
      task.condition = condition;
      return this.runTask(task);
    });
  }
  /**
   * Update a condition
   *
   * @param condition
   * @returns
   */
  updateCondition(condition) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new PutConditionTask();
      task.token = this.token;
      task.condition = condition;
      return this.runTask(task);
    });
  }
  /**
   * Delete a condition
   *
   * @param id
   * @returns
   */
  deleteCondition(id) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const task = new DeleteConditionTask();
      task.token = this.token;
      task.id = id;
      return this.runTask(task);
    });
  }
  /**
   * Return the types as an array
   */
  static get OPERATORS() {
    return [ConditionService.OPERATOR_EQUAL, ConditionService.OPERATOR_EQUAL_CI, ConditionService.OPERATOR_GREATER_THAN, ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL, ConditionService.OPERATOR_LESS_THAN, ConditionService.OPERATOR_LESS_THAN_OR_EQUAL, ConditionService.OPERATOR_CONTAINS, ConditionService.OPERATOR_DOES_NOT_CONTAIN, ConditionService.OPERATOR_EMPTY, ConditionService.OPERATOR_NOT_EMPTY, ConditionService.OPERATOR_STARTS_WITH, ConditionService.OPERATOR_ENDS_WITH, ConditionService.OPERATOR_LONGER_THAN, ConditionService.OPERATOR_SHORTER_THAN];
  }
  /**
   * Return the operator options for a select
   *
   * TODO update to use translations if possible
   */
  static get OPERATOR_OPTIONS() {
    return [{
      text: 'Equal',
      value: ConditionService.OPERATOR_EQUAL
    }, {
      text: 'Equal (Ignore case)',
      value: ConditionService.OPERATOR_EQUAL_CI
    }, {
      text: 'Greater than',
      value: ConditionService.OPERATOR_GREATER_THAN
    }, {
      text: 'Greater than or equal',
      value: ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL
    }, {
      text: 'Less than',
      value: ConditionService.OPERATOR_LESS_THAN
    }, {
      text: 'Less than or equal',
      value: ConditionService.OPERATOR_LESS_THAN_OR_EQUAL
    }, {
      text: 'Contains',
      value: ConditionService.OPERATOR_CONTAINS
    }, {
      text: 'Does not contain',
      value: ConditionService.OPERATOR_DOES_NOT_CONTAIN
    }, {
      text: 'Empty',
      value: ConditionService.OPERATOR_EMPTY
    }, {
      text: 'Not empty',
      value: ConditionService.OPERATOR_NOT_EMPTY
    }, {
      text: 'Starts with',
      value: ConditionService.OPERATOR_STARTS_WITH
    }, {
      text: 'Ends with',
      value: ConditionService.OPERATOR_ENDS_WITH
    }, {
      text: 'Longer than',
      value: ConditionService.OPERATOR_LONGER_THAN
    }, {
      text: 'Shorter than',
      value: ConditionService.OPERATOR_SHORTER_THAN
    }];
  }
  /**
   * Return an array of the operators that don't require a value
   */
  static get NO_VALUE_OPERATORS() {
    return [ConditionService.OPERATOR_EMPTY, ConditionService.OPERATOR_NOT_EMPTY];
  }
}
ConditionService.OPERATOR_EQUAL = 'equal';
ConditionService.OPERATOR_EQUAL_CI = 'equal_ci';
ConditionService.OPERATOR_GREATER_THAN = 'greater_than';
ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL = 'greater_than_or_equal';
ConditionService.OPERATOR_LESS_THAN = 'less_than';
ConditionService.OPERATOR_LESS_THAN_OR_EQUAL = 'less_than_or_equal';
ConditionService.OPERATOR_CONTAINS = 'contains';
ConditionService.OPERATOR_DOES_NOT_CONTAIN = 'does_not_contain';
ConditionService.OPERATOR_EMPTY = 'empty';
ConditionService.OPERATOR_NOT_EMPTY = 'not_empty';
ConditionService.OPERATOR_STARTS_WITH = 'starts_with';
ConditionService.OPERATOR_ENDS_WITH = 'ends_with';
ConditionService.OPERATOR_LONGER_THAN = 'longer_than';
ConditionService.OPERATOR_SHORTER_THAN = 'shorter_than';
;// CONCATENATED MODULE: ./src/model/validator/mapping-tool/condition-validator.ts



class ConditionValidator extends AbstractMappingValidator {
  constructor() {
    super(...arguments);
    this.index = null;
    this.conditionCount = 1;
  }
  validate(condition) {
    this.errors = {};
    if (!condition) {
      return this.errors;
    }
    this.validateActions(condition, this.errors);
    if (!condition.hasValue() && !this.requiresValue()) {
      return this.errors;
    }
    this.validateValue(condition, this.errors);
    this.validateOperator(condition, this.errors);
    this.validateExpectedValue(condition, this.errors);
    return this.errors;
  }
  requiresValue() {
    if (this.conditionCount <= 1) {
      return false;
    }
    const lastIndex = this.conditionCount - 1;
    if (this.index === lastIndex) {
      return false;
    }
    return true;
  }
  validateValue(condition, validationErrors) {
    if (!condition) {
      return;
    }
    let errors = [];
    if (condition.valueSettings && Object.keys(condition.valueSettings).length) {
      errors = this.validateValueSettings(condition.valueSettings, validationErrors);
    } else {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    }
    if (errors.length > 0) {
      validationErrors.valueSettings = errors;
    }
  }
  validateOperator(condition, validationErrors) {
    if (!condition) {
      return;
    }
    const errors = [];
    if (!condition.operator || !ConditionService.OPERATORS.includes(condition.operator)) {
      errors.push(this.i18n.t('mapping.validation.please_select_operator').toString());
    }
    if (errors.length > 0) {
      validationErrors.operator = errors;
    }
  }
  validateExpectedValue(condition, validationErrors) {
    if (!condition) {
      return;
    }
    if (!condition.operator) {
      return;
    }
    if (ConditionService.NO_VALUE_OPERATORS.includes(condition.operator)) {
      return;
    }
    let errors = [];
    if (condition.expectedValueSettings && Object.keys(condition.expectedValueSettings).length) {
      errors = this.validateValueSettings(condition.expectedValueSettings, validationErrors);
    } else {
      errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
    }
    if (errors.length > 0) {
      validationErrors.expectedValueSettings = errors;
    }
  }
  validateActions(condition, validationErrors) {
    if (!condition) {
      return;
    }
    const errors = [];
    if (condition.actions.length) {
      for (const index in condition.actions) {
        const action = condition.actions[index];
        const actionValidator = action.validator;
        actionValidator.index = parseInt(index);
        if (Object.keys(actionValidator.validate(action)).length) {
          errors.push(this.i18n.t('mapping.validation.action_invalid', {
            index
          }).toString());
        }
      }
    } else {
      errors.push(this.i18n.t('mapping.validation.action_required').toString());
    }
    if (errors.length > 0) {
      validationErrors.actions = errors;
    }
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/condition/condition.ts






class Condition {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get rule() {
    if (!this.dto.rule) {
      return null;
    }
    return new Rule(this.dto.rule);
  }
  set rule(rule) {
    if (rule) {
      this.dto.rule = rule.dto;
    } else {
      this.dto.rule = null;
    }
  }
  get valueSettings() {
    return this.dto.valueSettings;
  }
  set valueSettings(valueSettings) {
    this.dto.valueSettings = valueSettings;
  }
  get operator() {
    return this.dto.operator;
  }
  set operator(operator) {
    this.dto.operator = operator;
  }
  get expectedValueSettings() {
    return this.dto.expectedValueSettings;
  }
  set expectedValueSettings(expectedValueSettings) {
    this.dto.expectedValueSettings = expectedValueSettings;
  }
  get position() {
    return this.dto.position;
  }
  set position(position) {
    this.dto.position = position;
  }
  get actions() {
    const actions = [];
    for (const actionDto of this.dto.actions) {
      actions.push(new Action(actionDto));
    }
    return actions;
  }
  set actions(actions) {
    this.dto.actions = [];
    for (const action of actions) {
      this.dto.actions.push(action.dto);
    }
  }
  addAction(action) {
    this.dto.actions.push(action.dto);
    this.setActionPositions();
  }
  updateAction(action, key) {
    this.dto.actions.splice(key, 1, action.dto);
  }
  removeAction(key) {
    this.dto.actions.splice(key, 1);
  }
  moveAction(fromIndex, toIndex) {
    // Make sure the indexes are valid
    if (typeof this.dto.actions[fromIndex] === 'undefined' || typeof this.dto.actions[toIndex] === 'undefined') {
      return;
    }
    // Move the action
    array_helper_default().move(this.dto.actions, fromIndex, toIndex);
    // Reset the position values
    this.setActionPositions();
  }
  setActionPositions() {
    for (const key in this.dto.actions) {
      this.dto.actions[key].position = parseInt(key) + 1;
    }
  }
  /**
   * Return the parameters to create/update this condition
   * @returns ConditionParamsInterface
   */
  get params() {
    const params = {
      valueSettings: this.valueSettings,
      operator: this.operator,
      expectedValueSettings: this.expectedValueSettings,
      position: this.position,
      actions: []
    };
    for (const action of this.actions) {
      params.actions.push(action.params);
    }
    return params;
  }
  addBlankAction() {
    const action = new Action(new ActionDto());
    action.condition = this;
    action.type = 'take';
    action.valueSettings = {
      valueColumn: ''
    };
    this.addAction(action);
  }
  hasValue() {
    return this.valueSettingsHasValue(this.valueSettings);
  }
  hasExpectedValue() {
    return this.valueSettingsHasValue(this.expectedValueSettings);
  }
  valueSettingsHasValue(valueSettings) {
    if (!valueSettings) {
      return false;
    }
    let value = null;
    switch (true) {
      case 'value' in valueSettings:
        value = valueSettings.value;
        break;
      case 'valueRuleId' in valueSettings:
        value = valueSettings.valueRuleId;
        break;
      case 'valueColumn' in valueSettings:
        value = valueSettings.valueColumn;
        break;
    }
    if (value === null) {
      return false;
    }
    return true;
  }
  /**
   * Return the object to validate this entity
   *
   * @returns ConditionValidator
   */
  get validator() {
    return new ConditionValidator();
  }
  /**
   * Returns the validation errors from the form
   */
  get validationErrors() {
    return this.validator.validate(this);
  }
  /**
   * Returns whether the form is valid
   */
  get valid() {
    return Object.keys(this.validationErrors).length === 0;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/condition/condition-dto.ts
class ConditionDto {
  constructor() {
    this.id = 0;
    this.rule = null;
    this.valueSettings = null;
    this.operator = null;
    this.expectedValueSettings = null;
    this.position = 1;
    this.actions = [];
  }
}
;// CONCATENATED MODULE: ./src/model/validator/mapping-tool/rule-validator.ts


class RuleValidator extends AbstractMappingValidator {
  validate(rule) {
    this.errors = {};
    if (!rule) {
      return this.errors;
    }
    this.validateTitle(rule, this.errors);
    this.validateConditions(rule, this.errors);
    return this.errors;
  }
  validateTitle(rule, validationErrors) {
    if (!rule) {
      return;
    }
    const errors = [];
    if (!this.isValidString(rule.title)) {
      errors.push(this.i18n.t('general.validation.please_enter_title').toString());
    }
    if (errors.length > 0) {
      validationErrors.title = errors;
    }
  }
  validateConditions(rule, validationErrors) {
    if (!rule) {
      return;
    }
    const errors = [];
    const conditionCount = rule.conditions.length;
    if (conditionCount) {
      for (const index in rule.conditions) {
        const condition = rule.conditions[index];
        const conditionValidator = condition.validator;
        conditionValidator.index = parseInt(index);
        conditionValidator.conditionCount = conditionCount;
        if (Object.keys(conditionValidator.validate(condition)).length) {
          errors.push(this.i18n.t('mapping.validation.condition_invalid', {
            index
          }).toString());
        }
      }
    } else {
      errors.push(this.i18n.t('mapping.validation.condition_required').toString());
    }
    if (errors.length > 0) {
      validationErrors.conditions = errors;
    }
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/rule/rule.ts





class Rule {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get dataSourceId() {
    return this.dto.dataSourceId;
  }
  set dataSourceId(dataSourceId) {
    this.dto.dataSourceId = dataSourceId;
  }
  get property() {
    return this.dto.property;
  }
  set property(property) {
    this.dto.property = property;
  }
  get metadata() {
    return this.dto.metadata;
  }
  set metadata(metadata) {
    this.dto.metadata = metadata;
  }
  get title() {
    return this.dto.title;
  }
  set title(title) {
    this.dto.title = title;
  }
  get position() {
    return this.dto.position;
  }
  set position(position) {
    this.dto.position = position;
  }
  get conditions() {
    const conditions = [];
    if (this.dto.conditions) {
      for (const conditionDto of this.dto.conditions) {
        conditions.push(new Condition(conditionDto));
      }
    }
    return conditions;
  }
  set conditions(conditions) {
    this.dto.conditions = [];
    for (const condition of conditions) {
      this.dto.conditions.push(condition.dto);
    }
  }
  addCondition(condition) {
    var _a;
    (_a = this.dto.conditions) === null || _a === void 0 ? void 0 : _a.push(condition.dto);
    this.setConditionPositions();
  }
  addBlankCondition() {
    const condition = new Condition(new ConditionDto());
    condition.rule = this;
    condition.addBlankAction();
    this.addCondition(condition);
  }
  updateCondition(condition, key) {
    this.dto.conditions.splice(key, 1, condition.dto);
  }
  removeCondition(key) {
    this.dto.conditions.splice(key, 1);
  }
  moveCondition(fromIndex, toIndex) {
    // Make sure the indexes are valid
    if (typeof this.dto.conditions[fromIndex] === 'undefined' || typeof this.dto.conditions[toIndex] === 'undefined') {
      return;
    }
    // Move the condition
    array_helper_default().move(this.dto.conditions, fromIndex, toIndex);
    // Reset the position values
    this.setConditionPositions();
  }
  setConditionPositions() {
    for (const key in this.dto.conditions) {
      const position = parseInt(key) + 1;
      this.dto.conditions[key].position = position;
    }
  }
  /**
   * Return the parameters to create/update this rule
   * @returns RuleParamsInterface
   */
  get params() {
    var _a;
    const params = {
      dataSourceId: this.dataSourceId,
      property: this.property,
      metadata: this.metadata,
      title: this.title,
      position: this.position,
      conditions: []
    };
    for (const condition of this.conditions) {
      (_a = params.conditions) === null || _a === void 0 ? void 0 : _a.push(condition.params);
    }
    return params;
  }
  /**
   * Return the object to validate this entity
   *
   * @returns RuleValidator
   */
  get validator() {
    return new RuleValidator();
  }
  /**
   * Returns the validation errors from the form
   */
  get validationErrors() {
    return this.validator.validate(this);
  }
  /**
   * Returns whether the form is valid
   */
  get valid() {
    return Object.keys(this.validationErrors).length === 0;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/mapping/rule/rule-dto.ts
class RuleDto {
  constructor() {
    this.id = '';
    this.dataSourceId = null;
    this.property = null;
    this.metadata = false;
    this.title = '';
    this.position = 1;
    this.conditions = [];
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/mappable-field/_logic.ts?vue&type=script&lang=ts&external




let MappableFieldComponent = class MappableFieldComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.rule = null;
  }
  created() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  get displayName() {
    if (this.field.displayName) {
      return this.field.displayName;
    } else {
      return this.field.name;
    }
  }
  get isRequired() {
    return this.field.required;
  }
  get isComplete() {
    if (this.rule && this.rule.id) {
      return true;
    } else {
      return false;
    }
  }
  get takeAction() {
    if (!this.rule) {
      return null;
    }
    if (!this.rule.conditions) {
      return null;
    }
    for (const condition of this.rule.conditions) {
      if (!condition.actions) {
        continue;
      }
      for (const action of condition.actions) {
        if (action.type === 'take') {
          return action;
        }
      }
    }
    return null;
  }
  get mappedField() {
    if (!this.takeAction) {
      return null;
    }
    if (!this.takeAction.valueSettings.valueColumn) {
      return null;
    }
    return this.takeAction.valueSettings.valueColumn;
  }
  set mappedField(field) {
    if (field && this.takeAction) {
      this.takeAction.valueSettings.valueColumn = field;
      this.onUpdate();
      this.onSave();
    }
  }
  onUpdate() {
    this.$emit('input', this.rule);
  }
  onSave() {
    this.$emit('save', this.rule);
  }
  get showQuickSelector() {
    var _a;
    if ((_a = this.rule) === null || _a === void 0 ? void 0 : _a.conditions.length) {
      const conditions = this.rule.conditions;
      if (conditions.length > 1) {
        return false;
      }
      const condition = conditions[0];
      if (condition.actions.length > 1) {
        return false;
      }
    }
    return true;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappableFieldComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappableFieldComponent.prototype, "field", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappableFieldComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappableFieldComponent.prototype, "ruleKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappableFieldComponent.prototype, "onValueUpdated", null);
MappableFieldComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], MappableFieldComponent);
/* harmony default export */ var mappable_field_logicvue_type_script_lang_ts_external = (MappableFieldComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/mappable-field/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_mappable_field_logicvue_type_script_lang_ts_external = (mappable_field_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/mappable-field/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var mappable_field_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(5064);
;// CONCATENATED MODULE: ./src/components/mapping-tool/mappable-field/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/mappable-field/index.vue



;


/* normalize component */

var mappable_field_component = normalizeComponent(
  mapping_tool_mappable_field_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_13d99fc1_external_render,
  _templatevue_type_template_id_13d99fc1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mappable_field = (mappable_field_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/action-form/_template.html?vue&type=template&id=5218f6a1&external




var _templatevue_type_template_id_5218f6a1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-action-form"
  }, [_c('div', {
    staticClass: "vp-mapping-action-form__fieldGroup",
    class: _vm.actionField
  }, [_c('section', {
    staticClass: "vp-mapping-action-form__fieldGroup__title"
  }, [_c('h3', {
    staticClass: "text-h6 mt-1"
  }, [_vm._v(_vm._s(_vm.$t('mapping.action.then')))])]), _c('section', [_c(VAutocomplete_namespaceObject.VAutocomplete, {
    attrs: {
      "items": _vm.typeOptions,
      "label": _vm.$t('mapping.field.type'),
      "placeholder": _vm.$t('mapping.field.type'),
      "error": _vm.hasError('type'),
      "error-messages": _vm.errorMessages('type'),
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": "",
      "auto-select-first": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.action.type,
      callback: function ($$v) {
        _vm.$set(_vm.action, "type", $$v);
      },
      expression: "action.type"
    }
  })], 1), _c('section', {
    staticClass: "vp-mapping-action-form__fieldGroup__valueTypes"
  }, [_vm.action.valueSettings ? _c('vp-value-settings-editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showValueSettings,
      expression: "showValueSettings"
    }],
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "show-separator": _vm.showSeparator,
      "show-with": _vm.showWith,
      "error": _vm.hasError('valueSettings'),
      "error-messages": _vm.errorMessages('valueSettings')
    },
    on: {
      "input": _vm.onValueSettingsChanged
    },
    model: {
      value: _vm.action.valueSettings,
      callback: function ($$v) {
        _vm.$set(_vm.action, "valueSettings", $$v);
      },
      expression: "action.valueSettings"
    }
  }) : _vm._e()], 1), _c('section', {
    staticClass: "vp-mapping-action-form__fieldGroup__btnGroup vp-btn-group vp-btn-group--right"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "disabled": !_vm.canBeDeleted,
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.remove
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-trash-can-outline")])], 1), _c('vp-reorder-icons', {
    on: {
      "move-up": _vm.onMoveUp,
      "move-down": _vm.onMoveDown
    }
  })], 1)])]);
};
var _templatevue_type_template_id_5218f6a1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/action-form/_template.html?vue&type=template&id=5218f6a1&external

;// CONCATENATED MODULE: external "vue-class-component"
var external_vue_class_component_namespaceObject = require("vue-class-component");
var external_vue_class_component_default = /*#__PURE__*/__webpack_require__.n(external_vue_class_component_namespaceObject);
;// CONCATENATED MODULE: ./src/mixins/entity-form-mixin.ts



let EntityFormMixin = class EntityFormMixin extends external_vue_property_decorator_namespaceObject.Vue {
  /**
   * Returns the form item
   */
  get item() {
    // Should be overridden in the concrete instance
    return null;
  }
  /**
   * Returns whether the form is valid
   */
  get valid() {
    return Object.keys(this.validationErrors).length === 0;
  }
  /**
   * Returns the validation errors from the form
   */
  get validationErrors() {
    return this.validator.validate(this.item);
  }
  /**
   * Returns the validator for the form
   */
  get validator() {
    // Should be overridden in the concrete instance
    throw new Error('Not implemented');
  }
  /**
   * Returns whether the field is in an error state
   *
   * @param property
   * @returns
   */
  hasError(property) {
    return property in this.validationErrors;
  }
  /**
   * Returns the error message for a field
   *
   * @param property
   */
  errorMessages(property) {
    return property in this.validationErrors ? this.validationErrors[property] : [];
  }
  /**
   * Handles saves
   */
  save() {
    if (!this.valid) {
      return;
    }
    this.$emit('save', this.item);
  }
};
EntityFormMixin = (0,external_tslib_namespaceObject.__decorate)([(external_vue_class_component_default())], EntityFormMixin);
/* harmony default export */ var entity_form_mixin = (EntityFormMixin);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/action-form/_logic.ts?vue&type=script&lang=ts&external








let MappingActionFormComponent = class MappingActionFormComponent extends (0,external_vue_class_component_namespaceObject.mixins)(entity_form_mixin) {
  constructor() {
    super(...arguments);
    this.action = null;
    this.valueType = 'column';
  }
  created() {
    if (this.value) {
      this.action = Object.assign(new Action(new ActionDto()), this.value);
      this.readValueType();
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.action = Object.assign(new Action(new ActionDto()), this.value);
    }
  }
  onUpdate() {
    if (this.action) {
      this.$emit('input', this.action, this.actionKey);
    }
  }
  get showValueColumn() {
    return this.valueType === 'column';
  }
  get showValue() {
    return this.valueType === 'value';
  }
  get showValueRule() {
    return this.valueType === 'rule';
  }
  get showSeparator() {
    if (!this.action || !this.action.type) {
      return false;
    }
    return ActionService.SEPARATOR_TYPES.includes(this.action.type);
  }
  get showWith() {
    if (!this.action || !this.action.type) {
      return false;
    }
    return ActionService.WITH_TYPES.includes(this.action.type);
  }
  get actionField() {
    if (this.showSeparator || this.showWith) {
      return 'vp-mapping-action-form__fieldGroup--actionField';
    } else {
      return '';
    }
  }
  get showAdditionalColumn() {
    if (this.showSeparator || this.showWith) {
      return true;
    } else {
      return false;
    }
  }
  remove() {
    this.$emit('remove', this.actionKey);
  }
  readValueType() {
    var _a, _b, _c;
    if ((_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.valueSettings) === null || _b === void 0 ? void 0 : _b.value) {
      this.valueType = 'value';
    } else if ((_c = this.action) === null || _c === void 0 ? void 0 : _c.valueSettings.valueRuleId) {
      this.valueType = 'rule';
    }
  }
  get canBeDeleted() {
    if (this.actionKey === 0) {
      return false;
    }
    return true;
  }
  onValueSettingsChanged(valueSettings) {
    if (!this.action) {
      return;
    }
    this.action.valueSettings = valueSettings;
    this.onUpdate();
  }
  get showValueSettings() {
    if (!this.action) {
      return false;
    }
    if (ActionService.STANDALONE_TYPES.includes(this.action.type)) {
      return false;
    }
    return true;
  }
  onMoveUp() {
    this.$emit('move-action', this.actionKey, 'up');
  }
  onMoveDown() {
    this.$emit('move-action', this.actionKey, 'down');
  }
  get item() {
    if (this.action) {
      return this.action;
    }
    return new Action(new ActionDto());
  }
  get validator() {
    const validator = new ActionValidator();
    validator.index = this.actionKey;
    return validator;
  }
  get typeOptions() {
    return ActionService.TYPE_OPTIONS;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingActionFormComponent.prototype, "actionKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappingActionFormComponent.prototype, "onValueUpdated", null);
MappingActionFormComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], MappingActionFormComponent);
/* harmony default export */ var action_form_logicvue_type_script_lang_ts_external = (MappingActionFormComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/action-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_action_form_logicvue_type_script_lang_ts_external = (action_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/action-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var action_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1952);
;// CONCATENATED MODULE: ./src/components/mapping-tool/action-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/action-form/index.vue



;


/* normalize component */

var action_form_component = normalizeComponent(
  mapping_tool_action_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_5218f6a1_external_render,
  _templatevue_type_template_id_5218f6a1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var action_form = (action_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/condition-form/_template.html?vue&type=template&id=3828c75c&external




var _templatevue_type_template_id_3828c75c_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-condition-form"
  }, [_c('div', {
    staticClass: "vp-mapping-condition-form__fieldGroup",
    class: {
      'vp-mapping-condition-form__fieldGroup--showingInputs': _vm.showConditionInputs
    }
  }, [_c('section', {
    staticClass: "vp-mapping-condition-form__fieldGroup__title"
  }, [_c('h3', {
    staticClass: "text-h6 mt-1"
  }, [_vm._v(_vm._s(_vm.$t('mapping.action.if')))])]), _c('section', [_c('vp-value-settings-editor', {
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "error": _vm.hasError('valueSettings'),
      "error-messages": _vm.errorMessages('valueSettings')
    },
    on: {
      "input": _vm.onValueSettingsChanged
    },
    model: {
      value: _vm.condition.valueSettings,
      callback: function ($$v) {
        _vm.$set(_vm.condition, "valueSettings", $$v);
      },
      expression: "condition.valueSettings"
    }
  })], 1), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showConditionInputs,
      expression: "showConditionInputs"
    }]
  }, [_c(VAutocomplete_namespaceObject.VAutocomplete, {
    attrs: {
      "items": _vm.operatorOptions,
      "label": _vm.$t('mapping.field.operator'),
      "placeholder": _vm.$t('mapping.field.operator'),
      "error": _vm.hasError('operator'),
      "error-messages": _vm.errorMessages('operator'),
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": "",
      "auto-select-first": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.condition.operator,
      callback: function ($$v) {
        _vm.$set(_vm.condition, "operator", $$v);
      },
      expression: "condition.operator"
    }
  })], 1), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showConditionInputs,
      expression: "showConditionInputs"
    }]
  }, [_c('vp-value-settings-editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showExpectedValue,
      expression: "showExpectedValue"
    }],
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "error": _vm.hasError('expectedValueSettings'),
      "error-messages": _vm.errorMessages('expectedValueSettings')
    },
    on: {
      "input": _vm.onExpectedValueSettingsChanged,
      "change": _vm.onExpectedValueSettingsChanged
    },
    model: {
      value: _vm.condition.expectedValueSettings,
      callback: function ($$v) {
        _vm.$set(_vm.condition, "expectedValueSettings", $$v);
      },
      expression: "condition.expectedValueSettings"
    }
  })], 1), _c('section', {
    staticClass: "vp-mapping-condition-form__fieldGroup__btnGroup vp-btn-group vp-btn-group--right"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "disabled": !_vm.canBeDeleted,
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.remove
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-trash-can-outline")])], 1), _c('vp-reorder-icons', {
    on: {
      "move-up": _vm.onMoveUp,
      "move-down": _vm.onMoveDown
    }
  })], 1)]), _vm._l(_vm.condition.actions, function (action, index) {
    return _c('vp-action-form', {
      key: index,
      attrs: {
        "action-key": index,
        "data-source-id": _vm.dataSourceId,
        "source-data-fields": _vm.sourceDataFields,
        "data-source-rules": _vm.dataSourceRules
      },
      on: {
        "input": _vm.onActionChanged,
        "remove": _vm.removeAction,
        "move-action": _vm.onMoveAction
      },
      model: {
        value: _vm.condition.actions[index],
        callback: function ($$v) {
          _vm.$set(_vm.condition.actions, index, $$v);
        },
        expression: "condition.actions[index]"
      }
    });
  }), _c('div', {
    staticClass: "vp-mapping-condition-form__buttons"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "plain": "",
      "small": ""
    },
    on: {
      "click": _vm.addAction
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    staticClass: "mr-1",
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus ")]), _vm._v(" " + _vm._s(_vm.$t('general.action.add')) + " " + _vm._s(_vm.$t('mapping.type.action')) + " ")], 1)], 1), _vm._m(0)], 2);
};
var _templatevue_type_template_id_3828c75c_external_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-condition-form__else"
  }, [_c('div', {
    staticClass: "vp-mapping-condition-form__else__content"
  }, [_c('span', {
    staticClass: "text-h6"
  }, [_vm._v("Else")])])]);
}];

;// CONCATENATED MODULE: ./src/components/mapping-tool/condition-form/_template.html?vue&type=template&id=3828c75c&external

;// CONCATENATED MODULE: external "vuetify/lib/components/VCard"
var VCard_namespaceObject = require("vuetify/lib/components/VCard");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/mapping-rule/_template.html?vue&type=template&id=29cb07fe&external





var _templatevue_type_template_id_29cb07fe_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-mapping-rule",
    class: {
      'required-field': _vm.isRequired,
      'complete': _vm.isComplete,
      'nested-rule': _vm.nested
    },
    attrs: {
      "elevation": "2"
    }
  }, [_c('div', {
    staticClass: "vp-mapping-rule__header"
  }, [_vm.field ? _c('h3', {
    staticClass: "vp-mapping-rule__header__title text-h6",
    class: {
      'text-truncate': _vm.nested
    }
  }, [_vm._v(" " + _vm._s(_vm.displayName) + " ")]) : _vm._e(), !_vm.field ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    attrs: {
      "label": _vm.$t('mapping.rules.select'),
      "placeholder": _vm.$t('mapping.rules.select'),
      "value-comparator": _vm.valueComparator,
      "items": _vm.dataSourceRuleOptions,
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.selectRule
    },
    model: {
      value: _vm.rule,
      callback: function ($$v) {
        _vm.rule = $$v;
      },
      expression: "rule"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "vp-mapping-rule__header__btnGroup vp-btn-group"
  }, [_vm.rule && _vm.rule.id && !_vm.nested ? _c(VBtn_namespaceObject.VBtn, {
    attrs: {
      "fab": "",
      "small": "",
      "text": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.onClearField
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm.rule ? _c('vp-rule-dialog', {
    attrs: {
      "rule-key": _vm.ruleKey,
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "nested": _vm.nested
    },
    on: {
      "input": _vm.onUpdate,
      "save": _vm.onSave
    },
    model: {
      value: _vm.rule,
      callback: function ($$v) {
        _vm.rule = $$v;
      },
      expression: "rule"
    }
  }) : _vm._e()], 1)], 1), _vm.field ? _c('vp-mappable-field', {
    attrs: {
      "rule-key": _vm.ruleKey,
      "source-data-fields": _vm.sourceDataFields,
      "field": _vm.field
    },
    on: {
      "input": _vm.onUpdate,
      "save": _vm.onSave
    },
    model: {
      value: _vm.rule,
      callback: function ($$v) {
        _vm.rule = $$v;
      },
      expression: "rule"
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_29cb07fe_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/mapping-rule/_template.html?vue&type=template&id=29cb07fe&external

;// CONCATENATED MODULE: external "vuetify/lib/components/VGrid"
var VGrid_namespaceObject = require("vuetify/lib/components/VGrid");
;// CONCATENATED MODULE: external "vuetify/lib/components/VDialog"
var VDialog_namespaceObject = require("vuetify/lib/components/VDialog");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/rule-dialog/_template.html?vue&type=template&id=3f65e142&external











var _templatevue_type_template_id_3f65e142_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-rule-dialog"
  }, [_c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "content-class": "vp-dialog vp-mt-dialog",
      "persistent": "",
      "scrollable": "",
      "max-width": _vm.$vuetify.breakpoint.mdAndDown ? 912 : 1216,
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
          staticClass: "vp-btn",
          attrs: {
            "fab": "",
            "small": "",
            "text": "",
            "depressed": ""
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-cog-outline")])], 1)];
      }
    }]),
    model: {
      value: _vm.showing,
      callback: function ($$v) {
        _vm.showing = $$v;
      },
      expression: "showing"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, [_c('div', {
    staticClass: "text-truncate flex-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.$t('mapping.rules.editing')) + ": " + _vm._s(_vm.rule.property) + " ")])]), _c(VCard_namespaceObject.VCardText, [_c(VGrid_namespaceObject.VContainer, [_c('vp-mapping-rule-form', {
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.rule,
      callback: function ($$v) {
        _vm.rule = $$v;
      },
      expression: "rule"
    }
  })], 1)], 1), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.close')) + " ")]), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "secondary",
      "depressed": "",
      "disabled": _vm.disableSave
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")])], 1)], 1)], 1)], 1);
};
var _templatevue_type_template_id_3f65e142_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-dialog/_template.html?vue&type=template&id=3f65e142&external

;// CONCATENATED MODULE: external "vuetify/lib/components/VTabs"
var VTabs_namespaceObject = require("vuetify/lib/components/VTabs");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/rule-form/_template.html?vue&type=template&id=2e5a1a1b&external







var _templatevue_type_template_id_2e5a1a1b_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-rule-form"
  }, [_c(VTabs_namespaceObject.VTabs, {
    staticClass: "vp-tabs-bar vp-mt-tabs",
    attrs: {
      "hide-slider": ""
    }
  }, [_c(VTabs_namespaceObject.VTab, [_vm._v(" " + _vm._s(_vm.$t('mapping.rules.conditions_actions')) + " ")]), _c(VTabs_namespaceObject.VTabItem, [_c('div', {
    staticClass: "vp-mapping-rule-form__fieldGroup vp-field-group"
  }, [_c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.title'),
      "placeholder": _vm.$t('general.field.title'),
      "error": _vm.hasError('title'),
      "error-messages": _vm.errorMessages('title'),
      "solo": "",
      "dense": "",
      "flat": ""
    },
    model: {
      value: _vm.rule.title,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "title", $$v);
      },
      expression: "rule.title"
    }
  })], 1), _c('div', {
    staticClass: "vp-mapping-rule-form__conditions"
  }, _vm._l(_vm.rule.conditions, function (condition, index) {
    return _c('vp-condition-form', {
      key: index,
      attrs: {
        "condition-key": index,
        "condition-count": _vm.conditionCount,
        "data-source-id": _vm.dataSourceId,
        "mappable-fields": _vm.mappableFields,
        "data-source-rules": _vm.dataSourceRules,
        "source-data-fields": _vm.sourceDataFields
      },
      on: {
        "input": _vm.onConditionChange,
        "remove": _vm.removeCondition,
        "move-condition": _vm.onMoveCondition
      },
      model: {
        value: _vm.rule.conditions[index],
        callback: function ($$v) {
          _vm.$set(_vm.rule.conditions, index, $$v);
        },
        expression: "rule.conditions[index]"
      }
    });
  }), 1), _c('div', {
    staticClass: "vp-mapping-rule-form__buttons"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "primary",
      "plain": "",
      "small": ""
    },
    on: {
      "click": _vm.addCondition
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    staticClass: "mr-1",
    attrs: {
      "left": ""
    }
  }, [_vm._v(" mdi-plus ")]), _vm._v(" " + _vm._s(_vm.$t('general.action.add')) + " " + _vm._s(_vm.$t('mapping.type.condition')) + " ")], 1)], 1)])], 1)], 1);
};
var _templatevue_type_template_id_2e5a1a1b_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-form/_template.html?vue&type=template&id=2e5a1a1b&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/rule-form/_logic.ts?vue&type=script&lang=ts&external













let MappingRuleFormComponent = class MappingRuleFormComponent extends (0,external_vue_class_component_namespaceObject.mixins)(entity_form_mixin) {
  constructor() {
    super(...arguments);
    this.rule = null;
  }
  created() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onUpdate() {
    if (this.rule) {
      this.$emit('input', this.rule);
    }
  }
  onConditionChange(condition, key) {
    if (!this.rule) {
      return;
    }
    this.rule.updateCondition(condition, key);
    this.onUpdate();
  }
  addCondition() {
    if (!this.rule) {
      return;
    }
    const condition = new Condition(new ConditionDto());
    condition.addAction(this.createBlankAction(condition));
    this.rule.addCondition(condition);
  }
  removeCondition(key) {
    if (!this.rule) {
      return;
    }
    if (this.rule.conditions.length === 1) {
      event_bus_default().instance.$emit('notification', this.$t('mapping.error.delete_single_condition'), 'error');
      return;
    }
    if (!confirm(this.$t('mapping.action.confirm').toString())) {
      return;
    }
    this.rule.removeCondition(key);
    this.onUpdate();
  }
  createBlankAction(condition) {
    const action = new Action(new ActionDto());
    action.condition = condition;
    return action;
  }
  onMoveCondition(key, direction) {
    if (!this.rule) {
      return;
    }
    const newKey = direction === 'up' ? key - 1 : key + 1;
    this.rule.moveCondition(key, newKey);
    this.onUpdate();
  }
  get item() {
    if (this.rule) {
      return this.rule;
    }
    return new Rule(new RuleDto());
  }
  get validator() {
    return new RuleValidator();
  }
  get conditionCount() {
    if (!this.rule) {
      return 0;
    }
    return this.rule.conditions.length;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleFormComponent.prototype, "ruleKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappingRuleFormComponent.prototype, "onValueUpdated", null);
MappingRuleFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappingConditionFormComponent: condition_form
  }
})], MappingRuleFormComponent);
/* harmony default export */ var rule_form_logicvue_type_script_lang_ts_external = (MappingRuleFormComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_rule_form_logicvue_type_script_lang_ts_external = (rule_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/rule-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var rule_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(4152);
;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-form/index.vue



;


/* normalize component */

var rule_form_component = normalizeComponent(
  mapping_tool_rule_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_2e5a1a1b_external_render,
  _templatevue_type_template_id_2e5a1a1b_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var rule_form = (rule_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/rule-dialog/_logic.ts?vue&type=script&lang=ts&external





let MappingRuleDialogComponent = class MappingRuleDialogComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.rule = null;
    this.showing = false;
  }
  created() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
      if (this.nested && !this.rule.id) {
        this.showing = true;
      }
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
      if (this.nested && !this.rule.id) {
        this.showing = true;
      }
    }
  }
  hide() {
    this.showing = false;
  }
  show() {
    this.showing = true;
  }
  onSave() {
    this.hide();
    this.$emit('save');
  }
  onUpdate() {
    this.$emit('input', this.rule);
  }
  get disableSave() {
    if (!this.rule) {
      return true;
    }
    if (!this.rule.valid) {
      return true;
    }
    return false;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleDialogComponent.prototype, "ruleKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], MappingRuleDialogComponent.prototype, "nested", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappingRuleDialogComponent.prototype, "onValueUpdated", null);
MappingRuleDialogComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappingRuleFormComponent: rule_form
  }
})], MappingRuleDialogComponent);
/* harmony default export */ var rule_dialog_logicvue_type_script_lang_ts_external = (MappingRuleDialogComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-dialog/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_rule_dialog_logicvue_type_script_lang_ts_external = (rule_dialog_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/rule-dialog/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var rule_dialog_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(7968);
;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-dialog/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/rule-dialog/index.vue



;


/* normalize component */

var rule_dialog_component = normalizeComponent(
  mapping_tool_rule_dialog_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_3f65e142_external_render,
  _templatevue_type_template_id_3f65e142_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var rule_dialog = (rule_dialog_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/mapping-rule/_logic.ts?vue&type=script&lang=ts&external







let MappingRuleComponent = class MappingRuleComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.rule = null;
  }
  created() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    } else {
      this.rule = null;
    }
  }
  onUpdate() {
    this.$emit('changed', this.rule, this.ruleKey);
  }
  onSave() {
    this.$emit('save-rule', this.rule, this.ruleKey);
  }
  onClearField() {
    this.$emit('clear-field-rule', this.rule, this.ruleKey, this.field);
  }
  get displayName() {
    var _a;
    if (!this.field) {
      if ((_a = this.rule) === null || _a === void 0 ? void 0 : _a.title) {
        return this.rule.title;
      }
      return 'Rule';
    }
    if (this.field.displayName) {
      return this.field.displayName;
    } else {
      return this.field.name;
    }
  }
  get isRequired() {
    if (!this.field) {
      return false;
    }
    return this.field.required;
  }
  get isComplete() {
    var _a;
    if (this.rule && ((_a = this.rule) === null || _a === void 0 ? void 0 : _a.id)) {
      return true;
    } else {
      return false;
    }
  }
  selectRule() {
    if (!this.rule) {
      this.createDefaultRule();
    }
    this.onUpdate();
  }
  createDefaultRule() {
    const rule = new Rule(new RuleDto());
    rule.dataSourceId = this.dataSourceId;
    rule.addBlankCondition();
    this.rule = rule;
  }
  get dataSourceRuleOptions() {
    const options = [];
    for (const rule of this.dataSourceRules) {
      options.push({
        value: rule,
        text: rule.title
      });
    }
    options.push({
      value: null,
      text: 'Create new rule'
    });
    return options;
  }
  valueComparator(a, b) {
    if (a && b) {
      return a.id === b.id;
    }
    if (!a && !b) {
      return false;
    }
    return a === b;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "field", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingRuleComponent.prototype, "ruleKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], MappingRuleComponent.prototype, "nested", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappingRuleComponent.prototype, "onValueUpdated", null);
MappingRuleComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappableFieldComponent: mappable_field,
    MappingRuleDialogComponent: rule_dialog
  }
})], MappingRuleComponent);
/* harmony default export */ var mapping_rule_logicvue_type_script_lang_ts_external = (MappingRuleComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/mapping-rule/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_mapping_rule_logicvue_type_script_lang_ts_external = (mapping_rule_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/mapping-rule/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var mapping_rule_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(6380);
;// CONCATENATED MODULE: ./src/components/mapping-tool/mapping-rule/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/mapping-rule/index.vue



;


/* normalize component */

var mapping_rule_component = normalizeComponent(
  mapping_tool_mapping_rule_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_29cb07fe_external_render,
  _templatevue_type_template_id_29cb07fe_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mapping_rule = (mapping_rule_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/condition-form/_logic.ts?vue&type=script&lang=ts&external













let MappingConditionFormComponent = class MappingConditionFormComponent extends (0,external_vue_class_component_namespaceObject.mixins)(entity_form_mixin) {
  constructor() {
    super(...arguments);
    this.condition = null;
  }
  created() {
    if (this.value) {
      this.condition = Object.assign(new Condition(new ConditionDto()), this.value);
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.condition = Object.assign(new Condition(new ConditionDto()), this.value);
    }
  }
  onUpdate() {
    if (this.condition) {
      this.$emit('input', this.condition, this.conditionKey);
    }
  }
  remove() {
    this.$emit('remove', this.conditionKey);
  }
  onActionChanged(action, key) {
    if (!this.condition) {
      return;
    }
    this.condition.updateAction(action, key);
    this.onUpdate();
  }
  addAction() {
    if (!this.condition) {
      return;
    }
    const action = new Action(new ActionDto());
    action.condition = this.condition;
    this.condition.addAction(action);
  }
  removeAction(key) {
    if (!this.condition) {
      return;
    }
    if (this.condition.actions.length === 1) {
      event_bus_default().instance.$emit('notification', this.$t('mapping.error.delete_single_condition'), 'error');
      return;
    }
    if (!confirm(this.$t('mapping.action.confirm').toString())) {
      return;
    }
    this.condition.removeAction(key);
    this.onUpdate();
  }
  onValueSettingsChanged(valueSettings) {
    if (!this.condition) {
      return;
    }
    this.condition.valueSettings = valueSettings;
    this.onUpdate();
  }
  onExpectedValueSettingsChanged(expectedValueSettings) {
    if (!this.condition) {
      return;
    }
    this.condition.expectedValueSettings = expectedValueSettings;
    this.onUpdate();
  }
  get showConditionInputs() {
    if (!this.condition) {
      return false;
    }
    if (this.condition.valueSettings) {
      return true;
    }
    return false;
  }
  get showExpectedValue() {
    if (!this.showConditionInputs) {
      return false;
    }
    if (!this.condition || !this.condition.operator) {
      return false;
    }
    if (ConditionService.NO_VALUE_OPERATORS.includes(this.condition.operator)) {
      return false;
    }
    return true;
  }
  get canBeDeleted() {
    if (this.conditionKey === 0) {
      return false;
    }
    return true;
  }
  onMoveUp() {
    this.$emit('move-condition', this.conditionKey, 'up');
  }
  onMoveDown() {
    this.$emit('move-condition', this.conditionKey, 'down');
  }
  onMoveAction(key, direction) {
    if (!this.condition) {
      return;
    }
    const newKey = direction === 'up' ? key - 1 : key + 1;
    this.condition.moveAction(key, newKey);
  }
  get item() {
    if (this.condition) {
      return this.condition;
    }
    return new Condition(new ConditionDto());
  }
  get validator() {
    const validator = new ConditionValidator();
    validator.index = this.conditionKey;
    validator.conditionCount = this.conditionCount;
    return validator;
  }
  get operatorOptions() {
    return ConditionService.OPERATOR_OPTIONS;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "conditionKey", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingConditionFormComponent.prototype, "conditionCount", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], MappingConditionFormComponent.prototype, "onValueUpdated", null);
MappingConditionFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappingRuleComponent: mapping_rule,
    MappingActionFormComponent: action_form
  }
})], MappingConditionFormComponent);
/* harmony default export */ var condition_form_logicvue_type_script_lang_ts_external = (MappingConditionFormComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/condition-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_condition_form_logicvue_type_script_lang_ts_external = (condition_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/condition-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var condition_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(9276);
;// CONCATENATED MODULE: ./src/components/mapping-tool/condition-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/condition-form/index.vue



;


/* normalize component */

var condition_form_component = normalizeComponent(
  mapping_tool_condition_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_3828c75c_external_render,
  _templatevue_type_template_id_3828c75c_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var condition_form = (condition_form_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VStepper"
var VStepper_namespaceObject = require("vuetify/lib/components/VStepper");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/tool/_template.html?vue&type=template&id=3fa8f93e&external







var _templatevue_type_template_id_3fa8f93e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-tool"
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card vp-card--primary"
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('mapping.message.mapping_rules')) + " ")]), _c(VCard_namespaceObject.VCardText, {
    staticClass: "vp-mapping-tool__content"
  }, [_c(VStepper_namespaceObject.VStepper, {
    staticClass: "vp-mapping-tool__content__legend",
    attrs: {
      "value": "1",
      "elevation": "0"
    }
  }, [_c(VStepper_namespaceObject.VStepperHeader, [_c(VStepper_namespaceObject.VStepperStep, {
    staticClass: "complete",
    attrs: {
      "step": "1",
      "complete": ""
    }
  }, [_vm._v("Complete")]), _c(VStepper_namespaceObject.VStepperStep, {
    staticClass: "required-field",
    attrs: {
      "step": "2",
      "complete": ""
    }
  }, [_vm._v("Required")]), _c(VStepper_namespaceObject.VStepperStep, {
    attrs: {
      "step": "3",
      "complete": ""
    }
  }, [_vm._v("Optional")])], 1)], 1), _c('div', {
    staticClass: "vp-mapping-tool__content__tiles"
  }, _vm._l(_vm.rules, function (rule, index) {
    return rule.property ? _c('vp-mapping-rule', {
      key: index,
      attrs: {
        "rule-key": index,
        "data-source-id": _vm.dataSourceId,
        "mappable-fields": _vm.mappableFields,
        "data-source-rules": _vm.dataSourceRules,
        "source-data-fields": _vm.sourceDataFields,
        "field": _vm.getFieldFor(rule.property)
      },
      on: {
        "changed": _vm.onRuleChanged,
        "save-rule": _vm.saveRule,
        "clear-field-rule": _vm.clearFieldRule
      },
      model: {
        value: _vm.rules[index],
        callback: function ($$v) {
          _vm.$set(_vm.rules, index, $$v);
        },
        expression: "rules[index]"
      }
    }) : _vm._e();
  }), 1), _c('div', {
    staticClass: "vp-mapping-tool__content__results"
  }, [_c('vp-mapping-results-table', {
    attrs: {
      "sample-data": _vm.sampleData,
      "mapped-data": _vm.mappedData,
      "mappable-fields": _vm.mappableFields
    }
  })], 1)], 1)], 1)], 1);
};
var _templatevue_type_template_id_3fa8f93e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/tool/_template.html?vue&type=template&id=3fa8f93e&external

;// CONCATENATED MODULE: external "lodash"
var external_lodash_namespaceObject = require("lodash");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/results-table/_template.html?vue&type=template&id=0dc952dd&external













var _templatevue_type_template_id_0dc952dd_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-mapping-tool-results vp-card"
  }, [_c(VTabs_namespaceObject.VTabs, {
    staticClass: "vp-tabs-bar vp-mt-tabs",
    attrs: {
      "hide-slider": ""
    }
  }, [_c(VTabs_namespaceObject.VTab, [_vm._v(" " + _vm._s(_vm.$t('mapping.message.raw_data')) + " ")]), _c(VTabs_namespaceObject.VTab, [_vm._v(" " + _vm._s(_vm.$t('mapping.message.mapped_data')) + " ")]), _c(VTabs_namespaceObject.VTabItem, [_c('vp-data-table', {
    attrs: {
      "report": _vm.rawDataReport,
      "disable-search": "",
      "disable-pagination": "",
      "mobile-breakpoint": 1264
    },
    scopedSlots: _vm._u([_vm._l(_vm.rawDataReport.columns, function (column) {
      return {
        key: `item.${column.key}`,
        fn: function ({
          item
        }) {
          return [_c('span', {
            staticClass: "vp-mapping-tool-results__content"
          }, [_vm._v(_vm._s(_vm._f("str_limit")(item[column.key], 300)))]), _vm.isItemColumnLimited(item[column.key], 300) ? _c(VBtn_namespaceObject.VBtn, {
            staticClass: "vp-btn vp-mapping-tool-results__content__moreBtn",
            attrs: {
              "color": "primary",
              "plain": "",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.onViewMoreClicked(column.key, item[column.key]);
              }
            }
          }, [_c(VIcon_namespaceObject.VIcon, {
            staticClass: "mr-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(" mdi-text-box-multiple-outline ")]), _vm._v(" " + _vm._s(_vm.$t('mapping.action.view_more')) + " ")], 1) : _vm._e()];
        }
      };
    })], null, true)
  })], 1), _c(VTabs_namespaceObject.VTabItem, [_c('vp-data-table', {
    attrs: {
      "report": _vm.mappedDataReport,
      "disable-search": "",
      "disable-pagination": "",
      "mobile-breakpoint": 1264
    },
    scopedSlots: _vm._u([_vm._l(_vm.mappedDataReport.columns, function (column) {
      return {
        key: `item.${column.key}`,
        fn: function ({
          item
        }) {
          return [_c('span', {
            staticClass: "vp-mapping-tool-results__content"
          }, [_vm._v(_vm._s(_vm._f("str_limit")(item[column.key], 300)))]), _vm.isItemColumnLimited(item[column.key], 300) ? _c(VBtn_namespaceObject.VBtn, {
            staticClass: "vp-btn vp-mapping-tool-results__content__moreBtn",
            attrs: {
              "color": "primary",
              "plain": "",
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.onViewMoreClicked(column.key, item[column.key]);
              }
            }
          }, [_c(VIcon_namespaceObject.VIcon, {
            staticClass: "mr-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(" mdi-text-box-multiple-outline ")]), _vm._v(" " + _vm._s(_vm.$t('mapping.action.view_more')) + " ")], 1) : _vm._e()];
        }
      };
    })], null, true)
  })], 1)], 1), _c(VDialog_namespaceObject.VDialog, {
    attrs: {
      "content-class": "vp-dialog vp-mt-dialog",
      "scrollable": "",
      "max-width": "912",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: _vm.viewMoreVisible,
      callback: function ($$v) {
        _vm.viewMoreVisible = $$v;
      },
      expression: "viewMoreVisible"
    }
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card"
  }, [_c(VCard_namespaceObject.VCardTitle, [_c('div', {
    staticClass: "text-truncate flex-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.$t('mapping.message.viewing')) + ": " + _vm._s(_vm.viewMoreTitle) + " ")])]), _c(VCard_namespaceObject.VCardText, [_c(VGrid_namespaceObject.VContainer, [_vm._v(" " + _vm._s(_vm.viewMoreText) + " ")])], 1), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "secondary",
      "depressed": ""
    },
    on: {
      "click": _vm.hideViewMore
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.close')) + " ")])], 1)], 1)], 1)], 1);
};
var _templatevue_type_template_id_0dc952dd_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/results-table/_template.html?vue&type=template&id=0dc952dd&external

;// CONCATENATED MODULE: external "@vertical-plus/vue-js-core/dist/util/i18n/locale-helper"
var locale_helper_namespaceObject = require("@vertical-plus/vue-js-core/dist/util/i18n/locale-helper");
var locale_helper_default = /*#__PURE__*/__webpack_require__.n(locale_helper_namespaceObject);
;// CONCATENATED MODULE: ./src/model/service/report/abstract-data-table-report.ts


class AbstractDataTableReport {
  get widgets() {
    return [];
  }
  get filters() {
    return [];
  }
  get defaultFilters() {
    return {};
  }
  get settings() {
    return [];
  }
  get defaultSettings() {
    return {};
  }
  get columns() {
    return [];
  }
  get defaultColumns() {
    return [];
  }
  get sortBys() {
    return [];
  }
  constructor(serviceContainer) {
    this.defaultItemsPerPage = 20;
    this.defaultSortBy = '';
    this.prepared = false;
    this.serviceContainer = serviceContainer;
  }
  prepare() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.prepared = true;
    });
  }
  loadResults(conditions) {
    throw new Error('Method not implemented.');
  }
  downloadResults(conditions, format) {
    throw new Error('Method not implemented.');
  }
  loadSavedSearches() {
    throw new Error('Method not implemented.');
  }
  saveSearch(search) {
    throw new Error('Method not implemented.');
  }
  deleteSavedSearch(id) {
    throw new Error('Method not implemented.');
  }
  pinSavedSearch(id) {
    throw new Error('Method not implemented.');
  }
  unpinSavedSearch(id) {
    throw new Error('Method not implemented.');
  }
  saveDefaultColumns(columns, global) {
    throw new Error('Method not implemented.');
  }
  /**
   * Returns the translation for an i18n key
   *
   * @param key
   * @param params
   * @returns
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  i18n(key, params = {}) {
    return locale_helper_default().getI18n().t(key, params).toString();
  }
}
;// CONCATENATED MODULE: ./src/model/service/mapping/report/results-table-data-report.ts


class ResultsTableDataReport extends AbstractDataTableReport {
  constructor(serviceContainer, sampleData, columns, defaultColumns) {
    super(serviceContainer);
    this.defaultItemsPerPage = 50;
    this.sampleData = sampleData;
    this._columns = columns;
    this._defaultColumns = defaultColumns;
  }
  get columns() {
    return this._columns;
  }
  get defaultColumns() {
    return this._defaultColumns;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  loadResults(conditions) {
    var _a, _b, _c;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      return {
        results: (_a = this.sampleData) !== null && _a !== void 0 ? _a : [],
        totalResults: (_c = (_b = this.sampleData) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0,
        totalPages: 1,
        page: 1,
        firstPage: null,
        lastPage: null,
        previousPage: null,
        nextPage: null
      };
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/results-table/_logic.ts?vue&type=script&lang=ts&external




let MappingToolResultsTableComponent = class MappingToolResultsTableComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.mappedDataOrdered = [];
    this.viewMoreVisible = false;
    this.viewMoreTitle = '';
    this.viewMoreText = '';
  }
  onMappedDataUpdated() {
    this.mappedDataOrdered = [];
    for (const row of this.mappedData) {
      const orderedRow = {};
      for (const field of this.mappableFields) {
        if (row[field.name] !== undefined) {
          orderedRow[field.name] = row[field.name];
        }
      }
      this.mappedDataOrdered.push(orderedRow);
    }
  }
  onViewMoreClicked(title, description) {
    this.viewMoreTitle = title;
    this.viewMoreText = description;
    this.viewMoreVisible = true;
  }
  isItemColumnLimited(value, limit) {
    if (!value) {
      return false;
    }
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    return value.length > limit;
  }
  get rawDataReport() {
    const columns = [];
    const defaultColumns = [];
    if (this.sampleData.length) {
      const firstRow = this.sampleData[0];
      for (const key of Object.keys(firstRow)) {
        columns.push({
          key,
          title: key
        });
        defaultColumns.push(key);
      }
    }
    return new ResultsTableDataReport(this.$serviceContainer, this.sampleData, columns, defaultColumns);
  }
  get mappedDataReport() {
    const columns = [];
    const defaultColumns = [];
    if (this.mappedDataOrdered.length) {
      const firstRow = this.mappedDataOrdered[0];
      for (const key of Object.keys(firstRow)) {
        columns.push({
          key,
          title: key
        });
        defaultColumns.push(key);
      }
    }
    return new ResultsTableDataReport(this.$serviceContainer, this.mappedDataOrdered, columns, defaultColumns);
  }
  hideViewMore() {
    this.viewMoreVisible = false;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolResultsTableComponent.prototype, "sampleData", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolResultsTableComponent.prototype, "mappedData", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolResultsTableComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('mappedData', {
  immediate: true
})], MappingToolResultsTableComponent.prototype, "onMappedDataUpdated", null);
MappingToolResultsTableComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], MappingToolResultsTableComponent);
/* harmony default export */ var results_table_logicvue_type_script_lang_ts_external = (MappingToolResultsTableComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/results-table/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_results_table_logicvue_type_script_lang_ts_external = (results_table_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/results-table/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var results_table_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(8796);
;// CONCATENATED MODULE: ./src/components/mapping-tool/results-table/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/results-table/index.vue



;


/* normalize component */

var results_table_component = normalizeComponent(
  mapping_tool_results_table_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_0dc952dd_external_render,
  _templatevue_type_template_id_0dc952dd_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var results_table = (results_table_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/tool/_logic.ts?vue&type=script&lang=ts&external








let MappingToolComponent = class MappingToolComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.dataSourceRules = [];
    this.rules = [];
    this.sourceDataFields = [];
  }
  created() {
    this.loadRules();
    this.readSampleDataFields();
  }
  loadRules() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Keep track of which fields already have rules
      const fieldsWithRules = [];
      // Load existing rules
      const results = yield this.$serviceContainer.mappingService.ruleService.findRulesUsingDataSourceId(this.dataSourceId);
      if (results.totalResults > 0) {
        for (const rule of results.results) {
          this.rules.push(rule);
          if (rule.property) {
            fieldsWithRules.push(rule.property);
          } else {
            this.dataSourceRules.push(rule);
          }
        }
      }
      // Create blank rules for any fields without rules
      for (const mappableField of this.mappableFields) {
        const fieldName = mappableField.name;
        if (fieldsWithRules.includes(fieldName)) {
          continue;
        }
        const blankRule = this.createBlankRule(mappableField);
        this.rules.push(blankRule);
      }
      // Order the rules
      this.orderRules();
    });
  }
  /**
   * Orders the rules by completed -> required -> optional
   */
  orderRules() {
    // Order the rules in field order
    this.rules.sort((a, b) => {
      var _a, _b;
      const aIndex = (0,external_lodash_namespaceObject.findIndex)(this.mappableFields, {
        name: (_a = a.property) !== null && _a !== void 0 ? _a : ''
      });
      const bIndex = (0,external_lodash_namespaceObject.findIndex)(this.mappableFields, {
        name: (_b = b.property) !== null && _b !== void 0 ? _b : ''
      });
      return aIndex - bIndex;
    });
    // Order the rules by completed -> required -> optional
    this.rules = [
    // Completed
    ...this.rules.filter(rule => !!rule.id),
    // Required
    ...this.rules.filter(rule => {
      const field = (0,external_lodash_namespaceObject.find)(this.mappableFields, {
        name: rule.property
      });
      if (!field) {
        return false;
      }
      return !rule.id && field.required;
    }),
    // Optional
    ...this.rules.filter(rule => {
      const field = (0,external_lodash_namespaceObject.find)(this.mappableFields, {
        name: rule.property
      });
      if (!field) {
        return true;
      }
      return !rule.id && !field.required;
    })];
  }
  readSampleDataFields() {
    if (this.sampleData.length) {
      const firstRow = this.sampleData[0];
      for (const key of Object.keys(firstRow)) {
        this.sourceDataFields.push(key);
      }
    }
  }
  getFieldFor(property) {
    for (const mappableField of this.mappableFields) {
      if (mappableField.name === property) {
        return mappableField;
      }
    }
    return null;
  }
  saveRule(rule, key) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const savedRule = yield this.$serviceContainer.mappingService.ruleService.saveRule(rule);
      this.onRuleChanged(savedRule, key);
      this.$emit('rules-changed');
    });
  }
  clearFieldRule(rule, key, field) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!confirm(this.$t('mapping.action.confirm').toString())) {
        return;
      }
      this.rules.splice(key, 1, this.createBlankRule(field));
      if (rule.id) {
        yield this.$serviceContainer.mappingService.ruleService.deleteRule(rule.id);
      }
    });
  }
  onRuleChanged(rule, key) {
    this.rules.splice(key, 1, rule);
  }
  createBlankRule(field) {
    const rule = new Rule(new RuleDto());
    rule.dataSourceId = this.dataSourceId;
    rule.property = field.name;
    rule.title = `Set ${field.name}`;
    rule.addBlankCondition();
    return rule;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolComponent.prototype, "sampleData", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], MappingToolComponent.prototype, "mappedData", void 0);
MappingToolComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappingRuleComponent: mapping_rule,
    'vp-mapping-results-table': results_table
  }
})], MappingToolComponent);
/* harmony default export */ var tool_logicvue_type_script_lang_ts_external = (MappingToolComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/tool/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_tool_logicvue_type_script_lang_ts_external = (tool_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/tool/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var tool_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(2956);
;// CONCATENATED MODULE: ./src/components/mapping-tool/tool/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/tool/index.vue



;


/* normalize component */

var tool_component = normalizeComponent(
  mapping_tool_tool_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_3fa8f93e_external_render,
  _templatevue_type_template_id_3fa8f93e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tool = (tool_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VTooltip"
var VTooltip_namespaceObject = require("vuetify/lib/components/VTooltip");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/my-teams/_template.html?vue&type=template&id=4c0bf255&external





var _templatevue_type_template_id_4c0bf255_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-myTeams"
  }, [_c('vp-data-table', {
    ref: "dataTable",
    staticClass: "vp-myTeams__table",
    attrs: {
      "report": _vm.report,
      "disable-search": "",
      "disable-sort-by-selector": "",
      "disable-column-selector": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dateCreated",
      fn: function ({
        item
      }) {
        return [_c('vp-date', {
          attrs: {
            "date": item.dateCreated,
            "is-day": ""
          }
        })];
      }
    }, {
      key: "item.options",
      fn: function ({
        item
      }) {
        return [_c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onEditTeam(item.id, !item.editable);
                  }
                }
              }, 'v-btn', attrs, false), on), [item.editable ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-pencil")]) : _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-eye")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(item.editable ? _vm.$t('team.action.edit') : _vm.$t('team.action.view')))])]), item.deletable ? _c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onDeleteTeam(item.id);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-delete")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(item.deletable ? _vm.$t('team.action.delete') : _vm.$t('team.message.only_owners_can_delete')))])]) : _vm._e(), _c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onLeaveTeam(item.id);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-exit-run")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('team.action.leave_team')))])])];
      }
    }])
  }), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-myTeams__btnCreate",
    on: {
      "click": _vm.onNewTeam
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('team.action.create')) + " ")]), _c('vp-dialog', {
    attrs: {
      "title": _vm.formTitle,
      "max-width": "800",
      "corner-close": ""
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formMode === 'create' ? _c('vp-team-create', {
    attrs: {
      "value": _vm.formTeam
    },
    on: {
      "cancel": _vm.onCancel,
      "saved": _vm.onSaved
    }
  }) : _vm.formMode === 'edit' || _vm.formMode === 'view' ? _c('vp-team-edit', {
    attrs: {
      "value": _vm.formTeam,
      "readonly": _vm.formReadonly
    },
    on: {
      "cancel": _vm.onCancel,
      "saved": _vm.onSaved,
      "edit-sub-team": _vm.onEditSubTeam
    }
  }) : _vm._e()], 1), _c('vp-dialog', {
    attrs: {
      "title": _vm.$t('team.action.delete'),
      "max-width": "800",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = false;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "color": "error"
          },
          on: {
            "click": _vm.onConfirmDelete
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.delete')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('team.message.delete_confirmation'))
    }
  })]), _c('vp-dialog', {
    attrs: {
      "title": _vm.$t('team.action.leave_team'),
      "max-width": "800",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.leaveDialog = false;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "color": "error"
          },
          on: {
            "click": _vm.onConfirmLeaveTeam
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('team.action.leave_team')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.leaveDialog,
      callback: function ($$v) {
        _vm.leaveDialog = $$v;
      },
      expression: "leaveDialog"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('team.message.leave_team_confirmation'))
    }
  })])], 1);
};
var _templatevue_type_template_id_4c0bf255_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/team/my-teams/_template.html?vue&type=template&id=4c0bf255&external

;// CONCATENATED MODULE: external "core-js/modules/web.dom-exception.stack.js"
var web_dom_exception_stack_js_namespaceObject = require("core-js/modules/web.dom-exception.stack.js");
;// CONCATENATED MODULE: external "core-js/modules/web.structured-clone.js"
var web_structured_clone_js_namespaceObject = require("core-js/modules/web.structured-clone.js");
;// CONCATENATED MODULE: ./src/model/service/organisation/report/my-teams-report.ts


class MyTeamsReport extends AbstractDataTableReport {
  constructor(serviceContainer) {
    super(serviceContainer);
    this.title = 'My Teams';
    this.serviceContainer = serviceContainer;
  }
  get columns() {
    return [{
      key: 'title',
      title: this.i18n('general.field.title')
    }, {
      key: 'memberCount',
      title: this.i18n('team.field.members'),
      width: 100,
      align: 'center'
    }, {
      key: 'childCount',
      title: this.i18n('team.field.sub_teams'),
      width: 100,
      align: 'center'
    }, {
      key: 'dateCreated',
      title: this.i18n('general.field.date_created'),
      width: 150,
      align: 'center'
    }, {
      key: 'options',
      title: this.i18n('general.field.options'),
      width: 150
    }];
  }
  get defaultColumns() {
    return ['title', 'memberCount', 'childCount', 'dateCreated', 'options'];
  }
  get sortBys() {
    return [{
      key: 'title',
      title: this.i18n('general.field.title'),
      order: [{
        key: 'title',
        descending: false
      }]
    }, {
      key: 'dateCreated',
      title: this.i18n('general.field.date_created'),
      order: [{
        key: 'dateCreated',
        descending: true
      }]
    }];
  }
  loadResults(conditions) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Only show directly assigned teams
      conditions.direct = true;
      const results = yield this.serviceContainer.teamService.findTeams(conditions);
      return results;
    });
  }
}
;// CONCATENATED MODULE: external "date-fns"
var external_date_fns_namespaceObject = require("date-fns");
;// CONCATENATED MODULE: ./src/model/entity/organisation/user.ts
class User {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get email() {
    return this.dto.email;
  }
  set email(email) {
    this.dto.email = email;
  }
  get firstName() {
    return this.dto.firstName;
  }
  set firstName(firstName) {
    this.dto.firstName = firstName;
  }
  get lastName() {
    return this.dto.lastName;
  }
  set lastName(lastName) {
    this.dto.lastName = lastName;
  }
  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
  get disabled() {
    return this.dto.disabled;
  }
  set disabled(disabled) {
    this.dto.disabled = disabled;
  }
  get roles() {
    return this.dto.roles;
  }
  set roles(roles) {
    this.dto.roles = roles;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/organisation/team-user.ts



class TeamUser {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get teamId() {
    return this.dto.team.substring('/teams/'.length);
  }
  set teamId(teamId) {
    this.dto.team = `/teams/${teamId}`;
  }
  get user() {
    return new User(this.dto.user);
  }
  set user(user) {
    this.dto.user = structuredClone(user.dto);
  }
  get userId() {
    return this.dto.user.id;
  }
  set userId(userId) {
    this.dto.user.id = userId;
  }
  get owner() {
    return this.dto.owner;
  }
  set owner(owner) {
    this.dto.owner = owner;
  }
  get admin() {
    return this.dto.admin;
  }
  set admin(admin) {
    this.dto.admin = admin;
  }
  get params() {
    const data = {
      team: this.dto.team,
      user: `/users/${this.userId}`,
      owner: this.dto.owner,
      admin: this.dto.admin
    };
    return data;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/organisation/team.ts



class Team {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get parentId() {
    var _a, _b;
    return (_b = (_a = this.dto.parent) === null || _a === void 0 ? void 0 : _a.substring('/teams/'.length)) !== null && _b !== void 0 ? _b : null;
  }
  set parentId(parentId) {
    this.dto.parent = parentId ? `/teams/${parentId}` : null;
  }
  get title() {
    return this.dto.title;
  }
  set title(title) {
    this.dto.title = title;
  }
  get description() {
    return this.dto.description;
  }
  set description(description) {
    this.dto.description = description;
  }
  get dateCreated() {
    return (0,external_date_fns_namespaceObject.parseISO)(this.dto.dateCreated);
  }
  set dateCreated(dateCreated) {
    this.dto.dateCreated = (0,external_date_fns_namespaceObject.formatISO)(dateCreated);
  }
  get dateUpdated() {
    return (0,external_date_fns_namespaceObject.parseISO)(this.dto.dateUpdated);
  }
  set dateUpdated(dateUpdated) {
    this.dto.dateUpdated = (0,external_date_fns_namespaceObject.formatISO)(dateUpdated);
  }
  get teamUsers() {
    return this.dto.teamUsers.map(teamUserDto => new TeamUser(teamUserDto));
  }
  set teamUsers(teamUsers) {
    this.dto.teamUsers = teamUsers.map(teamUser => teamUser.dto);
  }
  get memberCount() {
    return this.dto.memberCount;
  }
  set memberCount(memberCount) {
    this.dto.memberCount = memberCount;
  }
  get childCount() {
    return this.dto.childCount;
  }
  set childCount(childCount) {
    this.dto.childCount = childCount;
  }
  get readable() {
    return this.dto.readable;
  }
  get editable() {
    return this.dto.editable;
  }
  get deletable() {
    return this.dto.deletable;
  }
  get childHierarchy() {
    return this.dto.childHierarchy;
  }
  get params() {
    const teamMembers = [];
    for (const teamMember of this.teamUsers) {
      teamMembers.push({
        team: `/teams/${this.dto.id}`,
        user: `/users/${teamMember.userId}`,
        owner: teamMember.owner,
        admin: teamMember.admin
      });
    }
    const data = {
      parent: this.dto.parent,
      title: this.title,
      description: this.description,
      teamUsers: teamMembers
    };
    return data;
  }
}
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/create/_template.html?vue&type=template&id=12ab783c&external
var _templatevue_type_template_id_12ab783c_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-teamCreate"
  }, [_vm.team ? _c('vp-team-form', {
    attrs: {
      "team": _vm.team,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": _vm.onSave
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_12ab783c_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/form/_template.html?vue&type=template&id=d0a4d6f8&external
var _templatevue_type_template_id_d0a4d6f8_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.form ? _c('vp-form', {
    ref: "form",
    staticClass: "form form--team",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": _vm.onSave,
      "change:values": _vm.onFieldValuesChanged
    },
    scopedSlots: _vm._u([{
      key: "members",
      fn: function () {
        return [_c('vp-team-members', {
          attrs: {
            "team": _vm.team,
            "readonly": _vm.readonly
          },
          model: {
            value: _vm.teamMembers,
            callback: function ($$v) {
              _vm.teamMembers = $$v;
            },
            expression: "teamMembers"
          }
        })];
      },
      proxy: true
    }, {
      key: "subTeams",
      fn: function () {
        return [_vm.team.id ? _c('vp-sub-teams', {
          attrs: {
            "team": _vm.team,
            "readonly": _vm.readonly
          },
          on: {
            "edit-sub-team": teamId => _vm.$emit('edit-sub-team', teamId)
          }
        }) : _c('p', [_vm._v(_vm._s(_vm.$t('team.message.please_create_team_first')))])];
      },
      proxy: true
    }], null, false, 508393695),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e();
};
var _templatevue_type_template_id_d0a4d6f8_external_staticRenderFns = [];

;// CONCATENATED MODULE: external "vuetify/lib/components/VTreeview"
var VTreeview_namespaceObject = require("vuetify/lib/components/VTreeview");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/sub-teams/_template.html?vue&type=template&id=12dbfd96&external





var _templatevue_type_template_id_12dbfd96_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.team.childHierarchy.length > 0 ? _c(VTreeview_namespaceObject.VTreeview, {
    staticClass: "vp-subTeams",
    attrs: {
      "items": _vm.team.childHierarchy,
      "item-text": "title",
      "open-all": "",
      "hoverable": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v(_vm._s(item.title))]), _c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                staticClass: "ml-1",
                attrs: {
                  "icon": "",
                  "small": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.$emit('edit-sub-team', item.id);
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm.readonly ? _c(VIcon_namespaceObject.VIcon, {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-eye")]) : _c(VIcon_namespaceObject.VIcon, {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-pencil")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.readonly ? _vm.$t('team.action.view_sub_team') : _vm.$t('team.action.edit_sub_team')))])])];
      }
    }], null, false, 3660644513)
  }) : _c('p', [_vm._v(" " + _vm._s(_vm.$t('team.message.no_sub_teams')) + " ")]);
};
var _templatevue_type_template_id_12dbfd96_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/team/sub-teams/_template.html?vue&type=template&id=12dbfd96&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/sub-teams/_logic.ts?vue&type=script&lang=ts&external


let SubTeamsComponent = class SubTeamsComponent extends external_vue_property_decorator_namespaceObject.Vue {};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SubTeamsComponent.prototype, "team", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], SubTeamsComponent.prototype, "readonly", void 0);
SubTeamsComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], SubTeamsComponent);
/* harmony default export */ var sub_teams_logicvue_type_script_lang_ts_external = (SubTeamsComponent);
;// CONCATENATED MODULE: ./src/components/team/sub-teams/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_sub_teams_logicvue_type_script_lang_ts_external = (sub_teams_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/sub-teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var sub_teams_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(4384);
;// CONCATENATED MODULE: ./src/components/team/sub-teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/sub-teams/index.vue



;


/* normalize component */

var sub_teams_component = normalizeComponent(
  team_sub_teams_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_12dbfd96_external_render,
  _templatevue_type_template_id_12dbfd96_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var sub_teams = (sub_teams_component.exports);
;// CONCATENATED MODULE: ./src/model/entity/organisation/team-dto.ts
class TeamDto {
  constructor() {
    this.id = '';
    this.parent = null;
    this.children = [];
    this.title = '';
    this.description = null;
    this.teamUsers = [];
    this.dateCreated = '';
    this.dateUpdated = '';
    this.memberCount = 0;
    this.childCount = 0;
    this.readable = false;
    this.editable = false;
    this.deletable = false;
    this.childHierarchy = [];
  }
}
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/members/_template.html?vue&type=template&id=7aaf5836&external





var _templatevue_type_template_id_7aaf5836_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-teamMembers"
  }, [_c('vp-data-table', {
    ref: "dataTable",
    staticClass: "vp-teamMembers__table",
    attrs: {
      "report": _vm.report,
      "disable-search": "",
      "disable-sort-by-selector": "",
      "disable-column-selector": ""
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function ({
        item
      }) {
        return [_vm._v(" " + _vm._s(item.user.fullName) + " ")];
      }
    }, {
      key: "item.owner",
      fn: function ({
        item
      }) {
        return [item.owner ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-check")]) : _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-close")])];
      }
    }, {
      key: "item.admin",
      fn: function ({
        item
      }) {
        return [item.admin ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-check")]) : _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-close")])];
      }
    }, {
      key: "item.options",
      fn: function ({
        item
      }) {
        return [_c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onEditTeamMember(item);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-pencil")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('team.action.edit_member')))])]), _c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onDeleteTeamMember(item);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-delete")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('team.action.delete_member')))])])];
      }
    }])
  }), !this.readonly ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-teamMembers__btnCreate",
    on: {
      "click": _vm.onNewTeamMember
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('team.action.create_member')) + " ")]) : _vm._e(), _c('vp-dialog', {
    attrs: {
      "title": _vm.formTitle,
      "max-width": "600",
      "corner-close": ""
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formMode === 'create' ? _c('vp-team-member-create', {
    attrs: {
      "value": _vm.formTeamMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": _vm.onCancel,
      "save": _vm.onAddTeamMember
    }
  }) : _vm.formMode === 'edit' ? _c('vp-team-member-edit', {
    attrs: {
      "value": _vm.formTeamMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": _vm.onCancel,
      "save": _vm.onUpdateTeamMember
    }
  }) : _vm._e()], 1), _c('vp-dialog', {
    attrs: {
      "title": _vm.$t('team.action.delete_member'),
      "max-width": "600",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = false;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "color": "error"
          },
          on: {
            "click": _vm.onConfirmDelete
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.delete')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('team.message.delete_member_confirmation'))
    }
  })])], 1);
};
var _templatevue_type_template_id_7aaf5836_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/team/members/_template.html?vue&type=template&id=7aaf5836&external

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/member-create/_template.html?vue&type=template&id=fee0fd4a&external
var _templatevue_type_template_id_fee0fd4a_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-teamMemberCreate"
  }, [_vm.teamMember ? _c('vp-team-member-form', {
    attrs: {
      "teamMember": _vm.teamMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": teamMember => _vm.$emit('save', teamMember)
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_fee0fd4a_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/member-form/_template.html?vue&type=template&id=62214d3a&external
var _templatevue_type_template_id_62214d3a_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.form ? _c('vp-form', {
    staticClass: "form form--teamMember",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": _vm.onSave,
      "change:values": _vm.onFieldValuesChanged
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e();
};
var _templatevue_type_template_id_62214d3a_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/model/entity/organisation/user-dto.ts
class UserDto {
  constructor() {
    this.id = '';
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.disabled = false;
    this.roles = [];
  }
}
;// CONCATENATED MODULE: ./src/model/entity/organisation/team-user-dto.ts

class TeamUserDto {
  constructor() {
    this.team = '';
    this.user = new UserDto();
    this.owner = false;
    this.admin = false;
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/member-form/_logic.ts?vue&type=script&lang=ts&external






let TeamMemberForm = class TeamMemberForm extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.form = null;
    this.fieldValues = {};
  }
  created() {
    this.onTeamMemberChanged();
  }
  onTeamMemberChanged() {
    this.generateForm();
  }
  /**
   * Handles form saves
   *
   * @param form
   */
  onSave(form) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.teamMember) {
        return;
      }
      // Generate a team member from the form data
      const teamMember = this.generateTeamMember(form);
      // Load the user and add it to the entity
      const user = yield this.$serviceContainer.userService.loadUser(teamMember.userId);
      if (!user) {
        return;
      }
      teamMember.user = user;
      // Emit a save event with the team member
      this.$emit('save', teamMember);
    });
  }
  /**
   * Generates the form from the team member
   */
  generateForm() {
    if (!this.teamMember) {
      this.form = null;
      return;
    }
    const form = {
      items: [{
        title: this.$t('general.field.details').toString(),
        fields: [{
          key: 'user',
          type: 'string',
          title: this.$t('general.field.user').toString(),
          value: this.teamMember.userId,
          required: false,
          optionsCallback: search => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.userService.formOptionsCallback(search);
          }),
          titlesCallback: values => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.userService.formTitlesCallback(values);
          })
        }, {
          key: 'owner',
          type: 'boolean',
          title: this.$t('general.field.owner').toString(),
          value: this.teamMember.owner,
          required: true
        }, {
          key: 'admin',
          type: 'boolean',
          title: this.$t('general.field.admin').toString(),
          value: this.teamMember.admin,
          required: true
        }],
        required: true
      }],
      stepper: true,
      saveButton: true,
      cancelButton: true
    };
    this.form = Object.assign({}, form);
  }
  /**
   * Generates the team member from the form
   */
  generateTeamMember(form) {
    if (!this.teamMember) {
      return new TeamUser(new TeamUserDto());
    }
    const teamMember = new TeamUser(structuredClone(this.teamMember.dto));
    this.addFieldValues(teamMember, form.items);
    return teamMember;
  }
  /**
   * Adds field values from form items to the passed team member
   *
   * @param teamMember
   * @param items
   */
  addFieldValues(teamMember, items) {
    for (const item of items) {
      if (!('key' in item)) {
        this.addFieldValues(teamMember, item.fields);
        continue;
      }
      switch (item.key) {
        case 'user':
          teamMember.userId = item.value;
          break;
        case 'owner':
          teamMember.owner = item.value;
          break;
        case 'admin':
          teamMember.admin = item.value;
          break;
      }
    }
  }
  /**
   * Handles field value changes from the form
   *
   * @param fieldValues
   */
  onFieldValuesChanged(fieldValues) {
    this.fieldValues = Object.assign({}, structuredClone(fieldValues));
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamMemberForm.prototype, "teamMember", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamMemberForm.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('teamMember')], TeamMemberForm.prototype, "onTeamMemberChanged", null);
TeamMemberForm = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], TeamMemberForm);
/* harmony default export */ var member_form_logicvue_type_script_lang_ts_external = (TeamMemberForm);
;// CONCATENATED MODULE: ./src/components/team/member-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_member_form_logicvue_type_script_lang_ts_external = (member_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/member-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var member_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1120);
;// CONCATENATED MODULE: ./src/components/team/member-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/member-form/index.vue



;


/* normalize component */

var member_form_component = normalizeComponent(
  team_member_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_62214d3a_external_render,
  _templatevue_type_template_id_62214d3a_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var member_form = (member_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/member-create/_logic.ts?vue&type=script&lang=ts&external






let TeamMemberCreateComponent = class TeamMemberCreateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.teamMember = null;
  }
  get title() {
    return this.$t('team.action.create_member').toString();
  }
  created() {
    this.onTeamMemberChanged();
  }
  onTeamMemberChanged() {
    if (this.value) {
      this.teamMember = new TeamUser(structuredClone(this.value.dto));
    } else {
      this.teamMember = null;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamMemberCreateComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamMemberCreateComponent.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], TeamMemberCreateComponent.prototype, "onTeamMemberChanged", null);
TeamMemberCreateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-member-form': member_form
  }
})], TeamMemberCreateComponent);
/* harmony default export */ var member_create_logicvue_type_script_lang_ts_external = (TeamMemberCreateComponent);
;// CONCATENATED MODULE: ./src/components/team/member-create/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_member_create_logicvue_type_script_lang_ts_external = (member_create_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/member-create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var member_create_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1020);
;// CONCATENATED MODULE: ./src/components/team/member-create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/member-create/index.vue



;


/* normalize component */

var member_create_component = normalizeComponent(
  team_member_create_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_fee0fd4a_external_render,
  _templatevue_type_template_id_fee0fd4a_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var member_create = (member_create_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/member-edit/_template.html?vue&type=template&id=4104fbae&external
var _templatevue_type_template_id_4104fbae_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-teamMemberEdit"
  }, [_vm.teamMember ? _c('vp-team-member-form', {
    attrs: {
      "teamMember": _vm.teamMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": teamMember => _vm.$emit('save', teamMember)
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_4104fbae_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/member-edit/_logic.ts?vue&type=script&lang=ts&external






let _logicvue_type_script_lang_ts_external_TeamMemberCreateComponent = class TeamMemberCreateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.teamMember = null;
  }
  get title() {
    return this.$t('team.action.edit_member').toString();
  }
  created() {
    this.onTeamMemberChanged();
  }
  onTeamMemberChanged() {
    if (this.value) {
      this.teamMember = new TeamUser(structuredClone(this.value.dto));
    } else {
      this.teamMember = null;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], _logicvue_type_script_lang_ts_external_TeamMemberCreateComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], _logicvue_type_script_lang_ts_external_TeamMemberCreateComponent.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], _logicvue_type_script_lang_ts_external_TeamMemberCreateComponent.prototype, "onTeamMemberChanged", null);
_logicvue_type_script_lang_ts_external_TeamMemberCreateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-member-form': member_form
  }
})], _logicvue_type_script_lang_ts_external_TeamMemberCreateComponent);
/* harmony default export */ var member_edit_logicvue_type_script_lang_ts_external = (_logicvue_type_script_lang_ts_external_TeamMemberCreateComponent);
;// CONCATENATED MODULE: ./src/components/team/member-edit/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_member_edit_logicvue_type_script_lang_ts_external = (member_edit_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/member-edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var member_edit_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(2112);
;// CONCATENATED MODULE: ./src/components/team/member-edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/member-edit/index.vue



;


/* normalize component */

var member_edit_component = normalizeComponent(
  team_member_edit_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_4104fbae_external_render,
  _templatevue_type_template_id_4104fbae_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var member_edit = (member_edit_component.exports);
;// CONCATENATED MODULE: ./src/model/service/organisation/report/team-members-report.ts



class TeamMembersReport extends AbstractDataTableReport {
  constructor(serviceContainer, teamMembers, readonly = false) {
    super(serviceContainer);
    this.title = 'My Teams';
    this.teamMembers = [];
    this.readonly = false;
    this.serviceContainer = serviceContainer;
    this.teamMembers = teamMembers;
    this.readonly = readonly;
  }
  setTeamMembers(teamMembers) {
    this.teamMembers = teamMembers;
  }
  get columns() {
    const columns = [{
      key: 'name',
      title: this.i18n('general.field.name')
    }, {
      key: 'owner',
      title: this.i18n('general.field.owner'),
      width: 100,
      align: 'center'
    }, {
      key: 'admin',
      title: this.i18n('general.field.admin'),
      width: 100,
      align: 'center'
    }];
    if (!this.readonly) {
      columns.push({
        key: 'options',
        title: this.i18n('general.field.options'),
        width: 150
      });
    }
    return columns;
  }
  get defaultColumns() {
    const columns = ['name', 'owner', 'admin'];
    if (!this.readonly) {
      columns.push('options');
    }
    return columns;
  }
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Sort the team members
      this.teamMembers.sort((a, b) => a.user.fullName.localeCompare(b.user.fullName));
      // Return the results
      return {
        results: this.teamMembers,
        totalResults: this.teamMembers.length,
        page: 1,
        totalPages: 1,
        firstPage: null,
        lastPage: null,
        nextPage: null,
        previousPage: null
      };
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/members/_logic.ts?vue&type=script&lang=ts&external










let TeamMembersComponent = class TeamMembersComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.teamMembers = [];
    this.saving = false;
    this.formDialog = false;
    this.formMode = 'create';
    this.formTeamMember = null;
    this.deleteDialog = false;
    this.deleteTeamMember = null;
  }
  get formTitle() {
    return this.$t(`team.action.${this.formMode}_member`).toString();
  }
  created() {
    this.onTeamMembersChanged();
    this.report = new TeamMembersReport(this.$serviceContainer, this.teamMembers, this.readonly);
  }
  onTeamMembersChanged() {
    // Update the team members
    this.teamMembers = [...this.value];
    // Update the report
    if (this.report) {
      this.report.setTeamMembers(this.teamMembers);
    }
    // Reload the data table
    if (this.$refs.dataTable) {
      this.$refs.dataTable.reload();
    }
  }
  /**
   * Handles requests to create a new team member
   */
  onNewTeamMember() {
    this.formMode = 'create';
    this.formTeamMember = new TeamUser(new TeamUserDto());
    this.formTeamMember.teamId = this.team.id;
    this.formDialog = true;
  }
  /**
   * Handles adding a new team member
   *
   * @param teamMember
   */
  onAddTeamMember(teamMember) {
    this.saving = true;
    // Check for an existing member
    const existingMemberIndex = this.teamMembers.findIndex(member => member.userId === teamMember.userId);
    if (existingMemberIndex > -1) {
      // Update the existing team member
      this.teamMembers.splice(existingMemberIndex, 1, teamMember);
    } else {
      // Add the new team member
      this.teamMembers.push(teamMember);
    }
    // Notify the parent component of the change
    this.$emit('input', this.teamMembers);
    // Close the dialog
    this.formDialog = false;
    this.saving = false;
  }
  /**
   * Handles requests to edit a team member
   *
   * @param teamMember
   */
  onEditTeamMember(teamMember) {
    this.formMode = 'edit';
    this.formTeamMember = new TeamUser(structuredClone(teamMember.dto));
    this.formDialog = true;
  }
  /**
   * Handles updating a team member
   *
   * @param teamMember
   */
  onUpdateTeamMember(teamMember) {
    this.saving = true;
    // Find the existing team member in the array
    const existingIndex = this.teamMembers.findIndex(x => x.userId === teamMember.userId);
    if (existingIndex === -1) {
      return;
    }
    // Replace the team member in the array
    const teamMembers = [...this.teamMembers];
    teamMembers.splice(existingIndex, 1, teamMember);
    // Notify the parent component of the change
    this.$emit('input', teamMembers);
    // Close the dialog
    this.formDialog = false;
    this.saving = false;
  }
  /**
   * Handles requests to delete a team member
   *
   * @param teamMember
   */
  onDeleteTeamMember(teamMember) {
    this.deleteTeamMember = teamMember;
    this.deleteDialog = true;
  }
  /**
   * Handles team deletion confirmation
   *
   * @returns
   */
  onConfirmDelete() {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!((_a = this.deleteTeamMember) === null || _a === void 0 ? void 0 : _a.userId)) {
        this.deleteDialog = false;
        return;
      }
      // Delete the team member
      const teamMembers = [...this.teamMembers];
      const index = teamMembers.findIndex(x => {
        var _a;
        return x.userId === ((_a = this.deleteTeamMember) === null || _a === void 0 ? void 0 : _a.userId);
      });
      if (index === -1) {
        return;
      }
      teamMembers.splice(index, 1);
      // Notify the parent component of the change
      this.$emit('input', teamMembers);
      this.deleteDialog = false;
      this.$refs.dataTable.reload();
    });
  }
  /**
   * Handles dialog cancel events
   */
  onCancel() {
    this.formDialog = false;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], TeamMembersComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamMembersComponent.prototype, "team", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamMembersComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], TeamMembersComponent.prototype, "onTeamMembersChanged", null);
TeamMembersComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-member-create': member_create,
    'vp-team-member-edit': member_edit
  }
})], TeamMembersComponent);
/* harmony default export */ var members_logicvue_type_script_lang_ts_external = (TeamMembersComponent);
;// CONCATENATED MODULE: ./src/components/team/members/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_members_logicvue_type_script_lang_ts_external = (members_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/members/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var members_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1140);
;// CONCATENATED MODULE: ./src/components/team/members/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/members/index.vue



;


/* normalize component */

var members_component = normalizeComponent(
  team_members_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_7aaf5836_external_render,
  _templatevue_type_template_id_7aaf5836_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var members = (members_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/form/_logic.ts?vue&type=script&lang=ts&external








let TeamForm = class TeamForm extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.form = null;
    this.fieldValues = {};
    this.teamMembers = [];
  }
  created() {
    this.onTeamChanged();
  }
  onTeamChanged() {
    this.teamMembers = [...this.team.teamUsers];
    this.generateForm();
    if (this.$refs.form) {
      this.$refs.form.setStep(1);
    }
  }
  /**
   * Returns the total number of sub teams
   */
  get totalSubTeams() {
    return this.countChildren(this.team.childHierarchy);
  }
  /**
   * Counts the total number of sub teams
   */
  countChildren(parent) {
    let count = 0;
    for (const child of parent) {
      count++;
      count += this.countChildren(child.children);
    }
    return count;
  }
  /**
   * Handles form saves
   *
   * @param form
   */
  onSave(form) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.team) {
        return;
      }
      // Generate a team from the form data
      const team = this.generateTeam(form);
      // Apply the team members
      team.teamUsers = [...this.teamMembers];
      // Emit a save event with the team
      this.$emit('save', team);
    });
  }
  /**
   * Generates the form from the team
   */
  generateForm() {
    if (!this.team) {
      this.form = null;
      return;
    }
    const form = {
      items: [{
        title: this.$t('general.field.details').toString(),
        fields: [{
          key: 'title',
          type: 'string',
          title: this.$t('general.field.title').toString(),
          value: this.team.title,
          required: true,
          readonly: this.readonly
        }, {
          key: 'description',
          type: 'string',
          title: this.$t('general.field.description').toString(),
          value: this.team.description,
          required: false,
          multiline: true,
          readonly: this.readonly
        }, {
          key: 'parentTeam',
          type: 'string',
          title: this.$t('team.field.parent_team').toString(),
          value: this.team.parentId,
          required: false,
          clearable: true,
          optionsCallback: search => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.teamService.formOptionsCallback(search);
          }),
          titlesCallback: values => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.teamService.formTitlesCallback(values);
          }),
          readonly: this.readonly
        }],
        required: true
      }, {
        title: this.$t('team.field.members_count', {
          count: this.team.teamUsers.length
        }).toString(),
        fields: [],
        slotName: 'members'
      }, {
        title: this.$t('team.field.sub_teams_count', {
          count: this.totalSubTeams
        }).toString(),
        fields: [],
        slotName: 'subTeams'
      }],
      stepper: true,
      saveButton: !this.readonly,
      cancelButton: !this.readonly
    };
    this.form = Object.assign({}, form);
  }
  /**
   * Generates the team from the form
   */
  generateTeam(form) {
    if (!this.team) {
      return new Team(new TeamDto());
    }
    const team = new Team(structuredClone(this.team.dto));
    this.addFieldValues(team, form.items);
    return team;
  }
  /**
   * Adds field values from form items to the passed team
   *
   * @param team
   * @param items
   */
  addFieldValues(team, items) {
    for (const item of items) {
      if (!('key' in item)) {
        this.addFieldValues(team, item.fields);
        continue;
      }
      switch (item.key) {
        case 'parentTeam':
          team.parentId = item.value;
          break;
        case 'title':
          team.title = item.value;
          break;
        case 'description':
          team.description = item.value;
          break;
      }
    }
  }
  /**
   * Handles field value changes from the form
   *
   * @param fieldValues
   */
  onFieldValuesChanged(fieldValues) {
    this.fieldValues = Object.assign({}, structuredClone(fieldValues));
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamForm.prototype, "team", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamForm.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamForm.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('team')], TeamForm.prototype, "onTeamChanged", null);
TeamForm = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-sub-teams': sub_teams,
    'vp-team-members': members
  }
})], TeamForm);
/* harmony default export */ var form_logicvue_type_script_lang_ts_external = (TeamForm);
;// CONCATENATED MODULE: ./src/components/team/form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_form_logicvue_type_script_lang_ts_external = (form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(6824);
;// CONCATENATED MODULE: ./src/components/team/form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/form/index.vue



;


/* normalize component */

var form_component = normalizeComponent(
  team_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_d0a4d6f8_external_render,
  _templatevue_type_template_id_d0a4d6f8_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var team_form = (form_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/create/_logic.ts?vue&type=script&lang=ts&external







let TeamCreateComponent = class TeamCreateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.team = null;
    this.saving = false;
  }
  get title() {
    return this.$t('team.action.create').toString();
  }
  created() {
    this.onTeamChanged();
  }
  onTeamChanged() {
    if (this.value) {
      this.team = new Team(structuredClone(this.value.dto));
    } else {
      this.team = null;
    }
  }
  /**
   * Handles form saves
   *
   * @param team
   */
  onSave(team) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        this.saving = true;
        yield this.$serviceContainer.teamService.createTeam(team);
        event_bus_default().instance.$emit('notification', this.$t('general.message.saved_successfully'), 'success');
        this.$emit('saved');
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('general.error.failed_saving_server_error'), 'error');
      } finally {
        this.saving = false;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamCreateComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], TeamCreateComponent.prototype, "onTeamChanged", null);
TeamCreateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-form': team_form
  }
})], TeamCreateComponent);
/* harmony default export */ var create_logicvue_type_script_lang_ts_external = (TeamCreateComponent);
;// CONCATENATED MODULE: ./src/components/team/create/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_create_logicvue_type_script_lang_ts_external = (create_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var create_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(9368);
;// CONCATENATED MODULE: ./src/components/team/create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/create/index.vue



;


/* normalize component */

var create_component = normalizeComponent(
  team_create_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_12ab783c_external_render,
  _templatevue_type_template_id_12ab783c_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var create = (create_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/team/edit/_template.html?vue&type=template&id=af88856c&external
var _templatevue_type_template_id_af88856c_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-teamEdit"
  }, [_vm.team ? _c('vp-team-form', {
    attrs: {
      "team": _vm.team,
      "readonly": _vm.readonly,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": _vm.onSave,
      "edit-sub-team": teamId => _vm.$emit('edit-sub-team', teamId)
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_af88856c_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/edit/_logic.ts?vue&type=script&lang=ts&external







let TeamEditComponent = class TeamEditComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.team = null;
    this.saving = false;
  }
  get title() {
    return this.readonly ? this.$t('team.action.view').toString() : this.$t('team.action.edit').toString();
  }
  created() {
    this.onTeamChanged();
  }
  onTeamChanged() {
    if (this.value) {
      this.team = new Team(structuredClone(this.value.dto));
    } else {
      this.team = null;
    }
  }
  /**
   * Handles form saves
   *
   * @param team
   */
  onSave(team) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        this.saving = true;
        yield this.$serviceContainer.teamService.updateTeam(team);
        event_bus_default().instance.$emit('notification', this.$t('general.message.saved_successfully'), 'success');
        this.$emit('saved');
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('general.error.failed_saving_server_error'), 'error');
      } finally {
        this.saving = false;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], TeamEditComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], TeamEditComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], TeamEditComponent.prototype, "onTeamChanged", null);
TeamEditComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-form': team_form
  }
})], TeamEditComponent);
/* harmony default export */ var edit_logicvue_type_script_lang_ts_external = (TeamEditComponent);
;// CONCATENATED MODULE: ./src/components/team/edit/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_edit_logicvue_type_script_lang_ts_external = (edit_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var edit_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(9776);
;// CONCATENATED MODULE: ./src/components/team/edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/edit/index.vue



;


/* normalize component */

var edit_component = normalizeComponent(
  team_edit_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_af88856c_external_render,
  _templatevue_type_template_id_af88856c_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var edit = (edit_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/team/my-teams/_logic.ts?vue&type=script&lang=ts&external










let MyTeamsComponent = class MyTeamsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.formDialog = false;
    this.formMode = 'create';
    this.formTeam = null;
    this.formReadonly = false;
    this.deleteDialog = false;
    this.deleteTeam = null;
    this.leaveDialog = false;
    this.leaveTeam = null;
  }
  get formTitle() {
    return this.$t(`team.action.${this.formMode}`).toString();
  }
  created() {
    this.report = new MyTeamsReport(this.$serviceContainer);
  }
  /**
   * Handles requests to create a new team
   */
  onNewTeam() {
    this.formMode = 'create';
    this.formTeam = new Team(new TeamDto());
    this.formDialog = true;
  }
  /**
   * Handles requests to edit a team
   *
   * @param teamId
   * @param readonly
   */
  onEditTeam(teamId, readonly = false) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.formMode = readonly ? 'view' : 'edit';
      this.formReadonly = readonly;
      try {
        const team = yield this.$serviceContainer.teamService.loadTeam(teamId);
        this.formTeam = new Team(structuredClone(team.dto));
        this.formDialog = true;
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('general.error.error_loading'), 'error');
      }
    });
  }
  /**
   * Handles requests to edit a sub team
   *
   * @param teamId
   */
  onEditSubTeam(teamId) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.onEditTeam(teamId, this.formReadonly);
    });
  }
  /**
   * Handles requests to delete a team
   *
   * @param teamId
   */
  onDeleteTeam(teamId) {
    this.deleteTeam = teamId;
    this.deleteDialog = true;
  }
  /**
   * Handles team deletion confirmation
   *
   * @returns
   */
  onConfirmDelete() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.deleteTeam) {
        this.deleteDialog = false;
        return;
      }
      try {
        yield this.$serviceContainer.teamService.deleteTeam(this.deleteTeam);
        this.deleteDialog = false;
        event_bus_default().instance.$emit('notification', this.$t('general.message.deleted_successfully'), 'success');
        this.$refs.dataTable.reload();
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('general.error.error_deleting'), 'error');
      }
    });
  }
  onLeaveTeam(teamId) {
    this.leaveTeam = teamId;
    this.leaveDialog = true;
  }
  onConfirmLeaveTeam() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.leaveTeam) {
        this.leaveDialog = false;
        return;
      }
      try {
        yield this.$serviceContainer.teamService.leaveTeam(this.leaveTeam);
        this.leaveDialog = false;
        event_bus_default().instance.$emit('notification', this.$t('team.message.left_team_successfully'), 'success');
        this.$refs.dataTable.reload();
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('team.error.error_leaving_team'), 'error');
      }
    });
  }
  /**
   * Handles dialog cancel events
   */
  onCancel() {
    this.formDialog = false;
  }
  /**
   * Handles dialog save events
   */
  onSaved() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Close the dialog
      this.formDialog = false;
      // Reload the results
      this.$refs.dataTable.reload();
    });
  }
};
MyTeamsComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-team-create': create,
    'vp-team-edit': edit
  }
})], MyTeamsComponent);
/* harmony default export */ var my_teams_logicvue_type_script_lang_ts_external = (MyTeamsComponent);
;// CONCATENATED MODULE: ./src/components/team/my-teams/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var team_my_teams_logicvue_type_script_lang_ts_external = (my_teams_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/team/my-teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var my_teams_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(5628);
;// CONCATENATED MODULE: ./src/components/team/my-teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/team/my-teams/index.vue



;


/* normalize component */

var my_teams_component = normalizeComponent(
  team_my_teams_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_4c0bf255_external_render,
  _templatevue_type_template_id_4c0bf255_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var my_teams = (my_teams_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/nested-rule/_template.html?vue&type=template&id=52fe8378&external



var _templatevue_type_template_id_52fe8378_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-mapping-nested-rule"
  }, [_c('vp-mapping-rule', {
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "field": null,
      "nested": ""
    },
    on: {
      "changed": _vm.onChange,
      "save-rule": _vm.saveRule
    },
    model: {
      value: _vm.rule,
      callback: function ($$v) {
        _vm.rule = $$v;
      },
      expression: "rule"
    }
  }), _vm.rule ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "fab": "",
      "small": "",
      "text": "",
      "depressed": ""
    },
    on: {
      "click": _vm.removeRule
    }
  }, [_c(VIcon_namespaceObject.VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1) : _vm._e()], 1);
};
var _templatevue_type_template_id_52fe8378_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/nested-rule/_template.html?vue&type=template&id=52fe8378&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/nested-rule/_logic.ts?vue&type=script&lang=ts&external





let NestedRuleComponent = class NestedRuleComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.rule = null;
  }
  created() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.rule = Object.assign(new Rule(new RuleDto()), this.value);
    }
  }
  onUpdate() {
    this.$emit('changed', this.rule);
  }
  createDefaultRule() {
    const rule = new Rule(new RuleDto());
    rule.dataSourceId = this.dataSourceId;
    rule.addBlankCondition();
    this.rule = rule;
  }
  onChange(rule) {
    this.rule = rule;
    this.onUpdate();
  }
  removeRule() {
    this.rule = null;
  }
  saveRule() {
    this.$emit('save-nested-rule', this.rule);
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], NestedRuleComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], NestedRuleComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], NestedRuleComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], NestedRuleComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], NestedRuleComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], NestedRuleComponent.prototype, "onValueUpdated", null);
NestedRuleComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    MappingRuleComponent: mapping_rule
  }
})], NestedRuleComponent);
/* harmony default export */ var nested_rule_logicvue_type_script_lang_ts_external = (NestedRuleComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/nested-rule/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_nested_rule_logicvue_type_script_lang_ts_external = (nested_rule_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/nested-rule/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var nested_rule_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(980);
;// CONCATENATED MODULE: ./src/components/mapping-tool/nested-rule/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/nested-rule/index.vue



;


/* normalize component */

var nested_rule_component = normalizeComponent(
  mapping_tool_nested_rule_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_52fe8378_external_render,
  _templatevue_type_template_id_52fe8378_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var nested_rule = (nested_rule_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/profile-form/_template.html?vue&type=template&id=a16f6fb4&external


var _templatevue_type_template_id_a16f6fb4_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "profileForm",
    class: {
      'profileForm--oauthLogin': _vm.$oauthLogin
    }
  }, [_c('vp-form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": _vm.onSave
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _vm.$oauthLogin ? _c('div', {
    staticClass: "profileForm__oauthLoginMessages"
  }, [_c(VAlert_namespaceObject.VAlert, {
    attrs: {
      "type": "info"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.message.oauth_login_active')) + " ")]), _c(VAlert_namespaceObject.VAlert, {
    attrs: {
      "type": "info"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.message.oauth_login_synced')) + " ")])], 1) : _vm._e()], 1);
};
var _templatevue_type_template_id_a16f6fb4_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/profile-form/_template.html?vue&type=template&id=a16f6fb4&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/profile-form/_logic.ts?vue&type=script&lang=ts&external




let ProfileFormComponent = class ProfileFormComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.form = null;
    this.saving = false;
  }
  created() {
    this.onUserChange();
  }
  onUserChange() {
    this.generateForm();
  }
  /**
   * Generates the form
   */
  generateForm() {
    var _a, _b, _c, _d, _e, _f;
    const fields = [{
      key: 'firstName',
      type: 'string',
      title: this.$t('authentication.field.first_name').toString(),
      value: (_b = (_a = this.$user) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : '',
      required: true,
      readonly: this.$oauthLogin
    }, {
      key: 'lastName',
      type: 'string',
      title: this.$t('authentication.field.last_name').toString(),
      value: (_d = (_c = this.$user) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : '',
      required: true,
      readonly: this.$oauthLogin
    }, {
      key: 'email',
      type: 'string',
      title: this.$t('authentication.field.email').toString(),
      value: (_f = (_e = this.$user) === null || _e === void 0 ? void 0 : _e.email) !== null && _f !== void 0 ? _f : '',
      required: true,
      readonly: this.$oauthLogin
    }];
    if (!this.$oauthLogin) {
      fields.push(...[{
        key: 'currentPassword',
        type: 'string',
        discreet: true,
        discreetToggle: true,
        title: this.$t('authentication.field.password_current').toString(),
        value: null,
        required: true
      }, {
        key: 'newPassword',
        type: 'string',
        discreet: true,
        discreetToggle: true,
        title: this.$t('authentication.field.password_new').toString(),
        value: null,
        required: false,
        validator: (field, fieldValues) => {
          const errors = [];
          if (field.value && field.value.length > 0 && field.value.length < 8) {
            errors.push(this.$t('general.validation.value_min_value', {
              length: 8
            }).toString());
          }
          return errors;
        }
      }, {
        key: 'newPasswordConfirmation',
        type: 'string',
        discreet: true,
        discreetToggle: true,
        title: this.$t('authentication.field.password_confirm').toString(),
        value: null,
        required: false,
        validator: (field, fieldValues) => {
          const errors = [];
          if (field.value !== fieldValues.newPassword) {
            errors.push(this.$t('authentication.validation.password_mismatch').toString());
          }
          return errors;
        }
      }]);
    }
    const form = {
      items: [{
        title: this.$t('general.field.basic_details').toString(),
        required: true,
        fields
      }],
      stepper: true,
      nonLinear: false,
      cancelButton: false,
      saveButton: !this.$oauthLogin
    };
    this.form = Object.assign({}, form);
  }
  /**
   * Generates the user from the form
   */
  generateUserProfileFromForm(form) {
    if (!this.$user) {
      throw new Error('No user is logged in');
    }
    const profile = {
      firstName: '',
      lastName: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    };
    this.addProfileFieldValues(profile, form.items);
    return profile;
  }
  /**
   * Adds field values from form items to the passed user
   *
   * @param user
   * @param items
   */
  addProfileFieldValues(user, items) {
    for (const item of items) {
      if (!('key' in item)) {
        this.addProfileFieldValues(user, item.fields);
        continue;
      }
      switch (item.key) {
        case 'firstName':
          user.firstName = item.value;
          break;
        case 'lastName':
          user.lastName = item.value;
          break;
        case 'email':
          user.email = item.value;
          break;
        case 'currentPassword':
          user.currentPassword = item.value;
          break;
        case 'newPassword':
          user.newPassword = item.value;
          break;
        case 'newPasswordConfirmation':
          user.newPasswordConfirmation = item.value;
          break;
      }
    }
  }
  /**
   * Handles form saves
   *
   * @param form
   * @returns
   */
  onSave(form) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.$user) {
        return;
      }
      this.saving = true;
      try {
        // Generate a user profile from the form data
        const userProfile = this.generateUserProfileFromForm(form);
        // Update the user's profile
        const user = yield this.$serviceContainer.userService.updateUserProfile(userProfile);
        // Update the current user's details
        this.$store.commit('authentication/user', user);
        // Inform the user their profile has been successfully updated
        event_bus_default().instance.$emit('notification', this.$t('authentication.message.profile_updated_successfully'), 'success');
        // Emit a save event
        this.$emit('saved');
      } catch (error) {
        event_bus_default().instance.$emit('notification', this.$t('authentication.error.profile_update_failed'), 'error');
      } finally {
        this.saving = false;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('$user')], ProfileFormComponent.prototype, "onUserChange", null);
ProfileFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ProfileFormComponent);
/* harmony default export */ var profile_form_logicvue_type_script_lang_ts_external = (ProfileFormComponent);
;// CONCATENATED MODULE: ./src/components/profile-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_profile_form_logicvue_type_script_lang_ts_external = (profile_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/profile-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var profile_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(3840);
;// CONCATENATED MODULE: ./src/components/profile-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/profile-form/index.vue



;


/* normalize component */

var profile_form_component = normalizeComponent(
  components_profile_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_a16f6fb4_external_render,
  _templatevue_type_template_id_a16f6fb4_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var profile_form = (profile_form_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VForm"
var VForm_namespaceObject = require("vuetify/lib/components/VForm");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project-form/_template.html?vue&type=template&id=42dfbe94&external










var _templatevue_type_template_id_42dfbe94_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-projectForm"
  }, [_vm.project ? _c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card vp-card--primary"
  }, [_c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.$t('project.message.project')) + " ")]), _c(VCard_namespaceObject.VCardText, [_c(VForm_namespaceObject.VForm, {
    attrs: {
      "value": _vm.valid
    }
  }, [_c('div', {
    staticClass: "vp-projectForm__fieldGroup vp-field-group"
  }, [_c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.title'),
      "placeholder": _vm.$t('general.field.title'),
      "filled": "",
      "required": "",
      "error": _vm.hasError('title'),
      "error-messages": _vm.errorMessages('title')
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.project.title,
      callback: function ($$v) {
        _vm.$set(_vm.project, "title", $$v);
      },
      expression: "project.title"
    }
  }), _c(VTextField_namespaceObject.VTextField, {
    staticClass: "vp-form-control",
    attrs: {
      "label": _vm.$t('project.field.api_key'),
      "placeholder": _vm.$t('project.field.api_key'),
      "filled": "",
      "error": _vm.hasError('apiKey'),
      "error-messages": _vm.errorMessages('apiKey')
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.project.apiKey,
      callback: function ($$v) {
        _vm.$set(_vm.project, "apiKey", $$v);
      },
      expression: "project.apiKey"
    }
  })], 1), _c('fieldset', {
    staticClass: "vp-projectForm__fieldGroup__description vp-form-control vp-field-group"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('general.field.description')))]), _c('vp-text-editor', {
    attrs: {
      "error": _vm.hasError('description'),
      "error-messages": _vm.errorMessages('description')
    },
    on: {
      "input": _vm.onUpdate
    },
    model: {
      value: _vm.project.description,
      callback: function ($$v) {
        _vm.$set(_vm.project, "description", $$v);
      },
      expression: "project.description"
    }
  })], 1)])], 1), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "secondary",
      "depressed": ""
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")])], 1)], 1) : _vm._e()], 1);
};
var _templatevue_type_template_id_42dfbe94_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/project-form/_template.html?vue&type=template&id=42dfbe94&external

;// CONCATENATED MODULE: ./src/model/entity/organisation/project-user.ts



class ProjectUser {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get projectId() {
    return this.dto.project.substring('/projects/'.length);
  }
  set projectId(projectId) {
    this.dto.project = `/projects/${projectId}`;
  }
  get user() {
    return new User(this.dto.user);
  }
  set user(user) {
    this.dto.user = structuredClone(user.dto);
  }
  get userId() {
    return this.dto.user.id;
  }
  set userId(userId) {
    this.dto.user.id = userId;
  }
  get owner() {
    return this.dto.owner;
  }
  set owner(owner) {
    this.dto.owner = owner;
  }
  get admin() {
    return this.dto.admin;
  }
  set admin(admin) {
    this.dto.admin = admin;
  }
  get inherited() {
    return this.dto.inherited;
  }
  set inherited(inherited) {
    this.dto.inherited = inherited;
  }
  get params() {
    const data = {
      project: this.dto.project,
      user: `/users/${this.userId}`,
      owner: this.dto.owner,
      admin: this.dto.admin
    };
    return data;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/organisation/project.ts




class Project {
  constructor(dto) {
    this.dto = Object.assign({}, dto);
  }
  get id() {
    return this.dto.id;
  }
  set id(id) {
    this.dto.id = id;
  }
  get user() {
    if (!this.dto.user) {
      return null;
    }
    return this.dto.user.replace('/users/', '');
  }
  set user(user) {
    this.dto.user = user;
  }
  get title() {
    return this.dto.title;
  }
  set title(title) {
    this.dto.title = title;
  }
  get description() {
    return this.dto.description;
  }
  set description(description) {
    this.dto.description = description;
  }
  get apiKey() {
    return this.dto.apiKey;
  }
  set apiKey(apiKey) {
    this.dto.apiKey = apiKey;
  }
  get dateCreated() {
    return (0,external_date_fns_namespaceObject.parseISO)(this.dto.dateCreated);
  }
  set dateCreated(dateCreated) {
    this.dto.dateCreated = (0,external_date_fns_namespaceObject.formatISO)(dateCreated);
  }
  get dateUpdated() {
    return (0,external_date_fns_namespaceObject.parseISO)(this.dto.dateUpdated);
  }
  set dateUpdated(dateUpdated) {
    this.dto.dateUpdated = (0,external_date_fns_namespaceObject.formatISO)(dateUpdated);
  }
  get members() {
    return this.dto.members;
  }
  set members(members) {
    this.dto.members = members;
  }
  get projectUsers() {
    const projectUsers = [];
    for (const projectUserDto of this.dto.projectUsers) {
      if (projectUserDto.inherited) {
        continue;
      }
      projectUsers.push(new ProjectUser(projectUserDto));
    }
    return projectUsers;
  }
  set projectUsers(projectUsers) {
    this.dto.projectUsers = [];
    for (const projectUser of projectUsers) {
      this.dto.projectUsers.push(projectUser.dto);
    }
  }
  get teams() {
    const teams = [];
    for (const teamDto of this.dto.teams) {
      teams.push(new Team(teamDto));
    }
    return teams;
  }
  set teams(teams) {
    this.dto.teams = [];
    for (const team of teams) {
      this.dto.teams.push(team.dto);
    }
  }
  get tags() {
    return this.dto.tags;
  }
  set tags(tags) {
    this.dto.tags = tags;
  }
  get params() {
    const data = {
      title: this.title,
      description: this.description,
      apiKey: this.apiKey,
      tags: this.tags,
      projectUsers: [],
      teams: []
    };
    if (this.user) {
      data.user = `/users/${this.user}`;
    }
    for (const projectMember of this.projectUsers) {
      data.projectUsers.push({
        project: `/projects/${this.dto.id}`,
        user: `/users/${projectMember.userId}`,
        owner: projectMember.owner,
        admin: projectMember.admin
      });
    }
    for (const team of this.teams) {
      data.teams.push(`/teams/${team.id}`);
    }
    return data;
  }
}
;// CONCATENATED MODULE: ./src/model/entity/organisation/project-dto.ts
class ProjectDto {
  constructor() {
    this.id = '';
    this.user = null;
    this.title = '';
    this.description = null;
    this.apiKey = null;
    this.dateCreated = '';
    this.dateUpdated = '';
    this.members = 0;
    this.projectUsers = [];
    this.teams = [];
    this.tags = [];
  }
}
;// CONCATENATED MODULE: ./src/model/validator/organisation/project-validator.ts


class ProjectValidator extends (abstract_validator_default()) {
  validate(item) {
    this.errors = {};
    this.validateTitle(item, this.errors);
    return this.errors;
  }
  validateTitle(project, validationErrors) {
    const errors = [];
    if (!this.isValidString(project.title)) {
      errors.push(this.i18n.t('general.validation.please_enter_title').toString());
    }
    if (errors.length > 0) {
      validationErrors.title = errors;
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project-form/_logic.ts?vue&type=script&lang=ts&external







let ProjectFormComponent = class ProjectFormComponent extends (0,external_vue_class_component_namespaceObject.mixins)(entity_form_mixin) {
  constructor() {
    super(...arguments);
    this.project = null;
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    if (this.value) {
      this.project = Object.assign(new Project(new ProjectDto()), this.value);
    }
  }
  onUpdate() {
    if (this.project) {
      this.$emit('input', this.project);
    }
  }
  get item() {
    var _a;
    return (_a = this.project) !== null && _a !== void 0 ? _a : new Project(new ProjectDto());
  }
  get validator() {
    return new ProjectValidator();
  }
  onSave() {
    this.save();
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ProjectFormComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ProjectFormComponent.prototype, "onValueChanged", null);
ProjectFormComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ProjectFormComponent);
/* harmony default export */ var project_form_logicvue_type_script_lang_ts_external = (ProjectFormComponent);
;// CONCATENATED MODULE: ./src/components/project-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_form_logicvue_type_script_lang_ts_external = (project_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(8492);
;// CONCATENATED MODULE: ./src/components/project-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project-form/index.vue



;


/* normalize component */

var project_form_component = normalizeComponent(
  components_project_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_42dfbe94_external_render,
  _templatevue_type_template_id_42dfbe94_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_form = (project_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project-index/_template.html?vue&type=template&id=40d9b66c&external
var _templatevue_type_template_id_40d9b66c_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vp-data-table', {
    attrs: {
      "report": _vm.projectsReport
    }
  });
};
var _templatevue_type_template_id_40d9b66c_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/model/service/organisation/report/project-report.ts


class ProjectReport extends AbstractDataTableReport {
  constructor(serviceContainer) {
    super(serviceContainer);
    this.title = 'Projects';
    this.serviceContainer = serviceContainer;
  }
  get filters() {
    return [{
      key: 'title',
      type: 'string',
      title: 'Title'
    }, {
      key: 'description',
      type: 'string',
      title: 'Description'
    }];
  }
  get columns() {
    return [{
      key: 'id',
      title: 'Id'
    }, {
      key: 'title',
      title: 'Title'
    }, {
      key: 'dateCreated',
      title: 'Created'
    }, {
      key: 'dateUpdated',
      title: 'Updated'
    }];
  }
  get defaultColumns() {
    return ['id', 'title', 'dateCreated', 'dateUpdated'];
  }
  get sortBys() {
    return [{
      key: 'title_asc',
      title: 'Title',
      order: [{
        key: 'title',
        descending: false
      }]
    }, {
      key: 'title_desc',
      title: 'Title desc',
      order: [{
        key: 'title',
        descending: true
      }]
    }, {
      key: 'created_asc',
      title: 'Created',
      order: [{
        key: 'dateCreated',
        descending: false
      }]
    }, {
      key: 'created_desc',
      title: 'Created desc',
      order: [{
        key: 'dateCreated',
        descending: true
      }]
    }];
  }
  loadResults(conditions) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const results = yield this.serviceContainer.projectService.findProjects(conditions);
      return results;
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project-index/_logic.ts?vue&type=script&lang=ts&external



let ProjectIndexComponent = class ProjectIndexComponent extends external_vue_property_decorator_namespaceObject.Vue {
  created() {
    this.projectsReport = new ProjectReport(this.$serviceContainer);
  }
};
ProjectIndexComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ProjectIndexComponent);
/* harmony default export */ var project_index_logicvue_type_script_lang_ts_external = (ProjectIndexComponent);
;// CONCATENATED MODULE: ./src/components/project-index/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_index_logicvue_type_script_lang_ts_external = (project_index_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project-index/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_index_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(5904);
;// CONCATENATED MODULE: ./src/components/project-index/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project-index/index.vue



;


/* normalize component */

var project_index_component = normalizeComponent(
  components_project_index_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_40d9b66c_external_render,
  _templatevue_type_template_id_40d9b66c_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_index = (project_index_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project/members/_template.html?vue&type=template&id=356879b1&external





var _templatevue_type_template_id_356879b1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-projectMembers"
  }, [_c('vp-data-table', {
    ref: "dataTable",
    staticClass: "vp-projectMembers__table",
    attrs: {
      "report": _vm.report,
      "disable-search": "",
      "disable-sort-by-selector": "",
      "disable-column-selector": ""
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function ({
        item
      }) {
        return [_vm._v(" " + _vm._s(item.user.fullName) + " ")];
      }
    }, {
      key: "item.owner",
      fn: function ({
        item
      }) {
        return [item.owner ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-check")]) : _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-close")])];
      }
    }, {
      key: "item.admin",
      fn: function ({
        item
      }) {
        return [item.admin ? _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-check")]) : _c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-close")])];
      }
    }, {
      key: "item.options",
      fn: function ({
        item
      }) {
        return [_c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onEditProjectMember(item);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-pencil")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('project.action.edit_member')))])]), _c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onDeleteProjectMember(item);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-delete")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('project.action.delete_member')))])])];
      }
    }])
  }), !this.readonly ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-projectMembers__btnCreate",
    on: {
      "click": _vm.onNewProjectMember
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('project.action.create_member')) + " ")]) : _vm._e(), _c('vp-dialog', {
    attrs: {
      "title": _vm.formTitle,
      "max-width": "600",
      "corner-close": ""
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formMode === 'create' ? _c('vp-project-member-create', {
    attrs: {
      "value": _vm.formProjectMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": _vm.onCancel,
      "save": _vm.onAddProjectMember
    }
  }) : _vm.formMode === 'edit' ? _c('vp-project-member-edit', {
    attrs: {
      "value": _vm.formProjectMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": _vm.onCancel,
      "save": _vm.onUpdateProjectMember
    }
  }) : _vm._e()], 1), _c('vp-dialog', {
    attrs: {
      "title": _vm.$t('project.action.delete_member'),
      "max-width": "600",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = false;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "color": "error"
          },
          on: {
            "click": _vm.onConfirmDelete
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.delete')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('project.message.delete_member_confirmation'))
    }
  })])], 1);
};
var _templatevue_type_template_id_356879b1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/project/members/_template.html?vue&type=template&id=356879b1&external

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project/member-create/_template.html?vue&type=template&id=51571e27&external
var _templatevue_type_template_id_51571e27_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-projectMemberCreate"
  }, [_vm.projectMember ? _c('vp-project-member-form', {
    attrs: {
      "projectMember": _vm.projectMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": projectMember => _vm.$emit('save', projectMember)
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_51571e27_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project/member-form/_template.html?vue&type=template&id=13608da2&external
var _templatevue_type_template_id_13608da2_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.form ? _c('vp-form', {
    staticClass: "form form--projectMember",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": _vm.onSave,
      "change:values": _vm.onFieldValuesChanged
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }) : _vm._e();
};
var _templatevue_type_template_id_13608da2_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/model/entity/organisation/project-user-dto.ts

class ProjectUserDto {
  constructor() {
    this.project = '';
    this.user = new UserDto();
    this.owner = false;
    this.admin = false;
    this.inherited = false;
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project/member-form/_logic.ts?vue&type=script&lang=ts&external






let ProjectMemberForm = class ProjectMemberForm extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.form = null;
    this.fieldValues = {};
  }
  created() {
    this.onProjectMemberChanged();
  }
  onProjectMemberChanged() {
    this.generateForm();
  }
  /**
   * Handles form saves
   *
   * @param form
   */
  onSave(form) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!this.projectMember) {
        return;
      }
      // Generate a project member from the form data
      const projectMember = this.generateProjectMember(form);
      // Load the user and add it to the entity
      const user = yield this.$serviceContainer.userService.loadUser(projectMember.userId);
      if (!user) {
        return;
      }
      projectMember.user = user;
      // Emit a save event with the project member
      this.$emit('save', projectMember);
    });
  }
  /**
   * Generates the form from the project member
   */
  generateForm() {
    if (!this.projectMember) {
      this.form = null;
      return;
    }
    const form = {
      items: [{
        title: this.$t('general.field.details').toString(),
        fields: [{
          key: 'user',
          type: 'string',
          title: this.$t('general.field.user').toString(),
          value: this.projectMember.userId,
          required: false,
          optionsCallback: search => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.userService.formOptionsCallback(search);
          }),
          titlesCallback: values => (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
            return this.$serviceContainer.userService.formTitlesCallback(values);
          })
        }, {
          key: 'owner',
          type: 'boolean',
          title: this.$t('general.field.owner').toString(),
          value: this.projectMember.owner,
          required: true
        }, {
          key: 'admin',
          type: 'boolean',
          title: this.$t('general.field.admin').toString(),
          value: this.projectMember.admin,
          required: true
        }],
        required: true
      }],
      stepper: true,
      saveButton: true,
      cancelButton: true
    };
    this.form = Object.assign({}, form);
  }
  /**
   * Generates the project member from the form
   */
  generateProjectMember(form) {
    if (!this.projectMember) {
      return new ProjectUser(new ProjectUserDto());
    }
    const projectMember = new ProjectUser(structuredClone(this.projectMember.dto));
    this.addFieldValues(projectMember, form.items);
    return projectMember;
  }
  /**
   * Adds field values from form items to the passed project member
   *
   * @param projectMember
   * @param items
   */
  addFieldValues(projectMember, items) {
    for (const item of items) {
      if (!('key' in item)) {
        this.addFieldValues(projectMember, item.fields);
        continue;
      }
      switch (item.key) {
        case 'user':
          projectMember.userId = item.value;
          break;
        case 'owner':
          projectMember.owner = item.value;
          break;
        case 'admin':
          projectMember.admin = item.value;
          break;
      }
    }
  }
  /**
   * Handles field value changes from the form
   *
   * @param fieldValues
   */
  onFieldValuesChanged(fieldValues) {
    this.fieldValues = Object.assign({}, structuredClone(fieldValues));
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ProjectMemberForm.prototype, "projectMember", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ProjectMemberForm.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('projectMember')], ProjectMemberForm.prototype, "onProjectMemberChanged", null);
ProjectMemberForm = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], ProjectMemberForm);
/* harmony default export */ var project_member_form_logicvue_type_script_lang_ts_external = (ProjectMemberForm);
;// CONCATENATED MODULE: ./src/components/project/member-form/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_member_form_logicvue_type_script_lang_ts_external = (project_member_form_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project/member-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_member_form_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(2328);
;// CONCATENATED MODULE: ./src/components/project/member-form/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project/member-form/index.vue



;


/* normalize component */

var project_member_form_component = normalizeComponent(
  components_project_member_form_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_13608da2_external_render,
  _templatevue_type_template_id_13608da2_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_member_form = (project_member_form_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project/member-create/_logic.ts?vue&type=script&lang=ts&external






let ProjectMemberCreateComponent = class ProjectMemberCreateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.projectMember = null;
  }
  get title() {
    return this.$t('project.action.create_member').toString();
  }
  created() {
    this.onProjectMemberChanged();
  }
  onProjectMemberChanged() {
    if (this.value) {
      this.projectMember = new ProjectUser(structuredClone(this.value.dto));
    } else {
      this.projectMember = null;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ProjectMemberCreateComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ProjectMemberCreateComponent.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ProjectMemberCreateComponent.prototype, "onProjectMemberChanged", null);
ProjectMemberCreateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-project-member-form': project_member_form
  }
})], ProjectMemberCreateComponent);
/* harmony default export */ var project_member_create_logicvue_type_script_lang_ts_external = (ProjectMemberCreateComponent);
;// CONCATENATED MODULE: ./src/components/project/member-create/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_member_create_logicvue_type_script_lang_ts_external = (project_member_create_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project/member-create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_member_create_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(552);
;// CONCATENATED MODULE: ./src/components/project/member-create/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project/member-create/index.vue



;


/* normalize component */

var project_member_create_component = normalizeComponent(
  components_project_member_create_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_51571e27_external_render,
  _templatevue_type_template_id_51571e27_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_member_create = (project_member_create_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project/member-edit/_template.html?vue&type=template&id=06dde1f5&external
var _templatevue_type_template_id_06dde1f5_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-projectMemberEdit"
  }, [_vm.projectMember ? _c('vp-project-member-form', {
    attrs: {
      "projectMember": _vm.projectMember,
      "saving": _vm.saving
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('cancel');
      },
      "save": projectMember => _vm.$emit('save', projectMember)
    }
  }) : _vm._e()], 1);
};
var _templatevue_type_template_id_06dde1f5_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project/member-edit/_logic.ts?vue&type=script&lang=ts&external






let _logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent = class ProjectMemberCreateComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.projectMember = null;
  }
  get title() {
    return this.$t('project.action.edit_member').toString();
  }
  created() {
    this.onProjectMemberChanged();
  }
  onProjectMemberChanged() {
    if (this.value) {
      this.projectMember = new ProjectUser(structuredClone(this.value.dto));
    } else {
      this.projectMember = null;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], _logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], _logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent.prototype, "saving", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], _logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent.prototype, "onProjectMemberChanged", null);
_logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-project-member-form': project_member_form
  }
})], _logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent);
/* harmony default export */ var project_member_edit_logicvue_type_script_lang_ts_external = (_logicvue_type_script_lang_ts_external_ProjectMemberCreateComponent);
;// CONCATENATED MODULE: ./src/components/project/member-edit/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_member_edit_logicvue_type_script_lang_ts_external = (project_member_edit_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project/member-edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_member_edit_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(7804);
;// CONCATENATED MODULE: ./src/components/project/member-edit/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project/member-edit/index.vue



;


/* normalize component */

var project_member_edit_component = normalizeComponent(
  components_project_member_edit_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_06dde1f5_external_render,
  _templatevue_type_template_id_06dde1f5_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_member_edit = (project_member_edit_component.exports);
;// CONCATENATED MODULE: ./src/model/service/organisation/report/project-members-report.ts



class ProjectMembersReport extends AbstractDataTableReport {
  constructor(serviceContainer, projectMembers, readonly = false) {
    super(serviceContainer);
    this.title = 'My Projects';
    this.projectMembers = [];
    this.readonly = false;
    this.serviceContainer = serviceContainer;
    this.projectMembers = projectMembers;
    this.readonly = readonly;
  }
  setProjectMembers(projectMembers) {
    this.projectMembers = projectMembers;
  }
  get columns() {
    const columns = [{
      key: 'name',
      title: this.i18n('general.field.name')
    }, {
      key: 'owner',
      title: this.i18n('general.field.owner'),
      width: 100,
      align: 'center'
    }, {
      key: 'admin',
      title: this.i18n('general.field.admin'),
      width: 100,
      align: 'center'
    }];
    if (!this.readonly) {
      columns.push({
        key: 'options',
        title: this.i18n('general.field.options'),
        width: 150
      });
    }
    return columns;
  }
  get defaultColumns() {
    const columns = ['name', 'owner', 'admin'];
    if (!this.readonly) {
      columns.push('options');
    }
    return columns;
  }
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Sort the project members
      this.projectMembers.sort((a, b) => a.user.fullName.localeCompare(b.user.fullName));
      // Return the results
      return {
        results: this.projectMembers,
        totalResults: this.projectMembers.length,
        page: 1,
        totalPages: 1,
        firstPage: null,
        lastPage: null,
        nextPage: null,
        previousPage: null
      };
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project/members/_logic.ts?vue&type=script&lang=ts&external










let ProjectMembersComponent = class ProjectMembersComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.projectMembers = [];
    this.saving = false;
    this.formDialog = false;
    this.formMode = 'create';
    this.formProjectMember = null;
    this.deleteDialog = false;
    this.deleteProjectMember = null;
  }
  get formTitle() {
    return this.$t(`project.action.${this.formMode}_member`).toString();
  }
  created() {
    this.onProjectMembersChanged();
    this.report = new ProjectMembersReport(this.$serviceContainer, this.projectMembers, this.readonly);
  }
  onProjectMembersChanged() {
    // Update the project members
    this.projectMembers = [...this.value];
    // Update the report
    if (this.report) {
      this.report.setProjectMembers(this.projectMembers);
    }
    // Reload the data table
    if (this.$refs.dataTable) {
      this.$refs.dataTable.reload();
    }
  }
  /**
   * Handles requests to create a new project member
   */
  onNewProjectMember() {
    this.formMode = 'create';
    this.formProjectMember = new ProjectUser(new ProjectUserDto());
    this.formProjectMember.projectId = this.project.id;
    this.formDialog = true;
  }
  /**
   * Handles adding a new project member
   *
   * @param projectMember
   */
  onAddProjectMember(projectMember) {
    this.saving = true;
    // Check for an existing member
    const existingMemberIndex = this.projectMembers.findIndex(member => member.userId === projectMember.userId);
    if (existingMemberIndex > -1) {
      // Update the existing project member
      this.projectMembers.splice(existingMemberIndex, 1, projectMember);
    } else {
      // Add the new project member
      this.projectMembers.push(projectMember);
    }
    // Notify the parent component of the change
    this.$emit('input', this.projectMembers);
    // Close the dialog
    this.formDialog = false;
    this.saving = false;
  }
  /**
   * Handles requests to edit a project member
   *
   * @param projectMember
   */
  onEditProjectMember(projectMember) {
    this.formMode = 'edit';
    this.formProjectMember = new ProjectUser(structuredClone(projectMember.dto));
    this.formDialog = true;
  }
  /**
   * Handles updating a project member
   *
   * @param projectMember
   */
  onUpdateProjectMember(projectMember) {
    this.saving = true;
    // Find the existing project member in the array
    const existingIndex = this.projectMembers.findIndex(x => x.userId === projectMember.userId);
    if (existingIndex === -1) {
      return;
    }
    // Replace the project member in the array
    const projectMembers = [...this.projectMembers];
    projectMembers.splice(existingIndex, 1, projectMember);
    // Notify the parent component of the change
    this.$emit('input', projectMembers);
    // Close the dialog
    this.formDialog = false;
    this.saving = false;
  }
  /**
   * Handles requests to delete a project member
   *
   * @param projectMember
   */
  onDeleteProjectMember(projectMember) {
    this.deleteProjectMember = projectMember;
    this.deleteDialog = true;
  }
  /**
   * Handles project deletion confirmation
   *
   * @returns
   */
  onConfirmDelete() {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!((_a = this.deleteProjectMember) === null || _a === void 0 ? void 0 : _a.userId)) {
        this.deleteDialog = false;
        return;
      }
      // Delete the project member
      const projectMembers = [...this.projectMembers];
      const index = projectMembers.findIndex(x => {
        var _a;
        return x.userId === ((_a = this.deleteProjectMember) === null || _a === void 0 ? void 0 : _a.userId);
      });
      if (index === -1) {
        return;
      }
      projectMembers.splice(index, 1);
      // Notify the parent component of the change
      this.$emit('input', projectMembers);
      this.deleteDialog = false;
      this.$refs.dataTable.reload();
    });
  }
  /**
   * Handles dialog cancel events
   */
  onCancel() {
    this.formDialog = false;
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], ProjectMembersComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ProjectMembersComponent.prototype, "project", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ProjectMembersComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ProjectMembersComponent.prototype, "onProjectMembersChanged", null);
ProjectMembersComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({
  components: {
    'vp-project-member-create': project_member_create,
    'vp-project-member-edit': project_member_edit
  }
})], ProjectMembersComponent);
/* harmony default export */ var project_members_logicvue_type_script_lang_ts_external = (ProjectMembersComponent);
;// CONCATENATED MODULE: ./src/components/project/members/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_members_logicvue_type_script_lang_ts_external = (project_members_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project/members/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_members_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(1224);
;// CONCATENATED MODULE: ./src/components/project/members/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project/members/index.vue



;


/* normalize component */

var project_members_component = normalizeComponent(
  components_project_members_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_356879b1_external_render,
  _templatevue_type_template_id_356879b1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_members = (project_members_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project-selector/_template.html?vue&type=template&id=6a5be8de&external


var _templatevue_type_template_id_6a5be8de_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete_namespaceObject.VAutocomplete, {
    staticClass: "vp-project-selector vp-form-control",
    attrs: {
      "label": _vm.$t('general.field.project'),
      "placeholder": _vm.$t('general.field.project'),
      "items": _vm.projects,
      "item-text": "title",
      "item-value": "id",
      "solo": "",
      "hide-details": "auto",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.projectId,
      callback: function ($$v) {
        _vm.projectId = $$v;
      },
      expression: "projectId"
    }
  });
};
var _templatevue_type_template_id_6a5be8de_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/project-selector/_template.html?vue&type=template&id=6a5be8de&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project-selector/_logic.ts?vue&type=script&lang=ts&external


let ProjectSelectorComponent = class ProjectSelectorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.projects = [];
    this.projectId = '';
  }
  created() {
    this.onProjectChanged();
    this.loadProjects();
  }
  onProjectChanged() {
    this.projectId = this.$project ? this.$project.id : '';
  }
  onUserChanged() {
    this.loadProjects();
  }
  /**
   * Loads available projects
   */
  loadProjects() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      try {
        const results = yield this.$serviceContainer.projectService.findProjects({
          itemsPerPage: this.limit
        });
        this.projects = results.results;
        // Select the first project if none currently selected
        if (!this.$project && this.projects.length > 0) {
          this.selectProject(this.projects[0].id);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
  /**
   * Handles updates from the component
   */
  onUpdate(projectId) {
    this.selectProject(projectId);
  }
  /**
   * Selects a new project
   *
   * @param projectId
   */
  selectProject(projectId) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Load the full version of the project
      const project = yield this.$serviceContainer.projectService.loadProject(projectId);
      // Emit an event with the newly selected project
      this.$emit('selected', project);
      // Update the current project
      if (!this.returnOnly) {
        this.$project = project;
      }
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ProjectSelectorComponent.prototype, "returnOnly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Number,
  default: 100
})], ProjectSelectorComponent.prototype, "limit", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('$project')], ProjectSelectorComponent.prototype, "onProjectChanged", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('$user')], ProjectSelectorComponent.prototype, "onUserChanged", null);
ProjectSelectorComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], ProjectSelectorComponent);
/* harmony default export */ var project_selector_logicvue_type_script_lang_ts_external = (ProjectSelectorComponent);
;// CONCATENATED MODULE: ./src/components/project-selector/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_project_selector_logicvue_type_script_lang_ts_external = (project_selector_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project-selector/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var project_selector_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(6228);
;// CONCATENATED MODULE: ./src/components/project-selector/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project-selector/index.vue



;


/* normalize component */

var project_selector_component = normalizeComponent(
  components_project_selector_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_6a5be8de_external_render,
  _templatevue_type_template_id_6a5be8de_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var project_selector = (project_selector_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/project/teams/_template.html?vue&type=template&id=44eb030e&external





var _templatevue_type_template_id_44eb030e_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-projectTeams"
  }, [_c('vp-data-table', {
    ref: "dataTable",
    staticClass: "vp-projectTeams__table",
    attrs: {
      "report": _vm.report,
      "disable-search": "",
      "disable-sort-by-selector": "",
      "disable-column-selector": ""
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function ({
        item
      }) {
        return [_vm._v(" " + _vm._s(item.title) + " ")];
      }
    }, {
      key: "item.options",
      fn: function ({
        item
      }) {
        return [_c(VTooltip_namespaceObject.VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on,
              attrs
            }) {
              return [_c(VBtn_namespaceObject.VBtn, _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    return _vm.onDeleteTeam(item);
                  }
                }
              }, 'v-btn', attrs, false), on), [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-delete")])], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('project.action.delete_team')))])])];
      }
    }])
  }), _c('div', {
    staticClass: "vp-projectTeams__addTeam"
  }, [_c('vp-form-field', {
    staticClass: "vp-projectTeams__addTeam__teamField",
    attrs: {
      "value": _vm.teamField,
      "errors": {}
    },
    on: {
      "input": _vm.onTeamFieldChange
    }
  }), !this.readonly ? _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-projectTeams__addTeam__btnAdd",
    on: {
      "click": _vm.onAddTeam
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('project.action.add_team')) + " ")]) : _vm._e()], 1), _c('vp-dialog', {
    attrs: {
      "title": _vm.$t('project.action.delete_team'),
      "max-width": "600",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.deleteDialog = false;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.cancel')) + " ")]), _c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
          attrs: {
            "color": "error"
          },
          on: {
            "click": _vm.onConfirmDelete
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('general.action.delete')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('project.message.delete_team_confirmation'))
    }
  })])], 1);
};
var _templatevue_type_template_id_44eb030e_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/project/teams/_template.html?vue&type=template&id=44eb030e&external

;// CONCATENATED MODULE: ./src/model/service/organisation/report/project-teams-report.ts



class ProjectTeamsReport extends AbstractDataTableReport {
  constructor(serviceContainer, teams, readonly = false) {
    super(serviceContainer);
    this.title = 'Teams';
    this.teams = [];
    this.readonly = false;
    this.serviceContainer = serviceContainer;
    this.teams = teams;
    this.readonly = readonly;
  }
  setTeams(teams) {
    this.teams = teams;
  }
  get columns() {
    const columns = [{
      key: 'title',
      title: this.i18n('general.field.title')
    }];
    if (!this.readonly) {
      columns.push({
        key: 'options',
        title: this.i18n('general.field.options'),
        width: 150
      });
    }
    return columns;
  }
  get defaultColumns() {
    const columns = ['title'];
    if (!this.readonly) {
      columns.push('options');
    }
    return columns;
  }
  loadResults() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      // Sort the teams
      this.teams.sort((a, b) => a.title.localeCompare(b.title));
      // Return the results
      return {
        results: this.teams,
        totalResults: this.teams.length,
        page: 1,
        totalPages: 1,
        firstPage: null,
        lastPage: null,
        nextPage: null,
        previousPage: null
      };
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/project/teams/_logic.ts?vue&type=script&lang=ts&external




let ProjectTeamsComponent = class ProjectTeamsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.teams = [];
    this.saving = false;
    this.addTeam = null;
    this.deleteDialog = false;
    this.deleteTeam = null;
  }
  get teamField() {
    return {
      key: 'type',
      type: 'string',
      title: this.$t('project.field.team').toString(),
      required: false,
      value: null,
      optionsCallback: search => this.$serviceContainer.teamService.formOptionsCallback(search),
      titlesCallback: values => this.$serviceContainer.teamService.formTitlesCallback(values),
      dropdown: true,
      hideTitle: true
    };
  }
  created() {
    this.onTeamsChanged();
    this.report = new ProjectTeamsReport(this.$serviceContainer, this.teams, this.readonly);
  }
  onTeamsChanged() {
    // Update the teams
    this.teams = [...this.value];
    // Update the report
    if (this.report) {
      this.report.setTeams(this.teams);
    }
    // Reload the data table
    if (this.$refs.dataTable) {
      this.$refs.dataTable.reload();
    }
  }
  onTeamFieldChange(field) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      this.addTeam = null;
      if (!field.value) {
        return;
      }
      this.addTeam = yield this.$serviceContainer.teamService.loadTeam(field.value);
    });
  }
  /**
   * Handles adding a new team
   */
  onAddTeam() {
    if (!this.addTeam) {
      return;
    }
    this.saving = true;
    // Check for an existing team
    const existingTeam = this.teams.find(team => {
      var _a;
      return team.id === ((_a = this.addTeam) === null || _a === void 0 ? void 0 : _a.id);
    });
    if (existingTeam) {
      return;
    }
    // Add the new team
    this.teams.push(this.addTeam);
    // Notify the parent component of the change
    this.$emit('input', this.teams);
    this.saving = false;
  }
  /**
   * Handles requests to delete a team
   *
   * @param team
   */
  onDeleteTeam(team) {
    this.deleteTeam = team;
    this.deleteDialog = true;
  }
  /**
   * Handles project deletion confirmation
   *
   * @returns
   */
  onConfirmDelete() {
    var _a;
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (!((_a = this.deleteTeam) === null || _a === void 0 ? void 0 : _a.id)) {
        this.deleteDialog = false;
        return;
      }
      // Delete the team
      const teams = [...this.teams];
      const index = teams.findIndex(team => {
        var _a;
        return team.id === ((_a = this.deleteTeam) === null || _a === void 0 ? void 0 : _a.id);
      });
      if (index === -1) {
        return;
      }
      teams.splice(index, 1);
      // Notify the parent component of the change
      this.$emit('input', teams);
      this.deleteDialog = false;
      this.$refs.dataTable.reload();
    });
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Array,
  default: () => []
})], ProjectTeamsComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ProjectTeamsComponent.prototype, "readonly", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ProjectTeamsComponent.prototype, "onTeamsChanged", null);
ProjectTeamsComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], ProjectTeamsComponent);
/* harmony default export */ var teams_logicvue_type_script_lang_ts_external = (ProjectTeamsComponent);
;// CONCATENATED MODULE: ./src/components/project/teams/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var project_teams_logicvue_type_script_lang_ts_external = (teams_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/project/teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var teams_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(5572);
;// CONCATENATED MODULE: ./src/components/project/teams/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/project/teams/index.vue



;


/* normalize component */

var teams_component = normalizeComponent(
  project_teams_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_44eb030e_external_render,
  _templatevue_type_template_id_44eb030e_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var teams = (teams_component.exports);
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/reorder-icons/_template.html?vue&type=template&id=245bb4ae&external



var _templatevue_type_template_id_245bb4ae_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-reorder-icons"
  }, [_c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.moveDown
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-down")])], 1), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.moveUp
    }
  }, [_c(VIcon_namespaceObject.VIcon, [_vm._v("mdi-chevron-up")])], 1)], 1);
};
var _templatevue_type_template_id_245bb4ae_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/reorder-icons/_template.html?vue&type=template&id=245bb4ae&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/reorder-icons/_logic.ts?vue&type=script&lang=ts&external


let ReorderIconsComponent = class ReorderIconsComponent extends external_vue_property_decorator_namespaceObject.Vue {
  moveUp() {
    this.$emit('move-up');
  }
  moveDown() {
    this.$emit('move-down');
  }
};
ReorderIconsComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], ReorderIconsComponent);
/* harmony default export */ var reorder_icons_logicvue_type_script_lang_ts_external = (ReorderIconsComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/reorder-icons/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_reorder_icons_logicvue_type_script_lang_ts_external = (reorder_icons_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/reorder-icons/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var reorder_icons_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(8420);
;// CONCATENATED MODULE: ./src/components/mapping-tool/reorder-icons/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/reorder-icons/index.vue



;


/* normalize component */

var reorder_icons_component = normalizeComponent(
  mapping_tool_reorder_icons_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_245bb4ae_external_render,
  _templatevue_type_template_id_245bb4ae_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var reorder_icons = (reorder_icons_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VRadioGroup"
var VRadioGroup_namespaceObject = require("vuetify/lib/components/VRadioGroup");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/settings-editor/_template.html?vue&type=template&id=5cf624e5&external













var _templatevue_type_template_id_5cf624e5_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-settings"
  }, [_c(VCard_namespaceObject.VCard, {
    staticClass: "vp-card vp-card--primary"
  }, [_vm.title ? _c(VCard_namespaceObject.VCardTitle, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c(VCard_namespaceObject.VCardText, [_c(VForm_namespaceObject.VForm, {
    staticClass: "vp-settings__form vp-field-group",
    attrs: {
      "value": _vm.valid
    }
  }, _vm._l(_vm.settings, function (setting) {
    return _c('fieldset', {
      staticClass: "vp-settings__form__fieldset vp-form-control vp-form-control--thin vp-field-group vp-field-group--details vp-field-group--flex flex-grow-1"
    }, [_c('legend', [_vm._v(_vm._s(setting.key))]), setting.type === 'boolean' ? _c(VRadioGroup_namespaceObject.VRadioGroup, {
      staticClass: "vp-form-control vp-form-control flex-grow-1",
      attrs: {
        "row": "",
        "hide-details": "auto",
        "disabled": _vm.inherited[setting.key],
        "error": _vm.hasError(setting.key),
        "error-messages": _vm.errorMessages(setting.key)
      },
      on: {
        "change": function ($event) {
          return _vm.onUpdate(setting.key);
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_c('div', {
            staticClass: "mr-2"
          }, [_vm._v(_vm._s(setting.key))])];
        },
        proxy: true
      }], null, true),
      model: {
        value: setting.value,
        callback: function ($$v) {
          _vm.$set(setting, "value", $$v);
        },
        expression: "setting.value"
      }
    }, [_c('div', {
      staticClass: "vp-radios"
    }, [_c(VRadioGroup_namespaceObject.VRadio, {
      attrs: {
        "label": _vm.$t('general.action.yes'),
        "value": true
      }
    }), _c(VRadioGroup_namespaceObject.VRadio, {
      attrs: {
        "label": _vm.$t('general.action.no'),
        "value": false
      }
    })], 1)]) : _c(VTextField_namespaceObject.VTextField, {
      staticClass: "vp-form-control",
      attrs: {
        "label": setting.key,
        "placeholder": setting.key,
        "filled": "",
        "hide-details": "auto",
        "disabled": _vm.inherited[setting.key],
        "error": _vm.hasError(setting.key),
        "error-messages": _vm.errorMessages(setting.key)
      },
      on: {
        "change": function ($event) {
          return _vm.onUpdate(setting.key);
        }
      },
      model: {
        value: setting.value,
        callback: function ($$v) {
          _vm.$set(setting, "value", $$v);
        },
        expression: "setting.value"
      }
    }), _vm.nullable ? _c(VCheckbox_namespaceObject.VCheckbox, {
      staticClass: "vp-form-control",
      attrs: {
        "label": _vm.$t('general.field.inherit'),
        "hide-details": "auto"
      },
      on: {
        "change": function ($event) {
          return _vm.onInheritedToggled(setting.key);
        }
      },
      model: {
        value: _vm.inherited[setting.key],
        callback: function ($$v) {
          _vm.$set(_vm.inherited, setting.key, $$v);
        },
        expression: "inherited[setting.key]"
      }
    }) : _vm._e()], 1);
  }), 0)], 1), _c(VDivider_namespaceObject.VDivider), _c(VCard_namespaceObject.VCardActions, [_c(VGrid_namespaceObject.VSpacer), _c(VBtn_namespaceObject.VBtn, {
    staticClass: "vp-btn",
    attrs: {
      "color": "secondary",
      "depressed": ""
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('general.action.save')) + " ")])], 1)], 1)], 1);
};
var _templatevue_type_template_id_5cf624e5_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/settings-editor/_template.html?vue&type=template&id=5cf624e5&external

;// CONCATENATED MODULE: ./src/model/validator/metadata/settings-validator.ts


class SettingsValidator extends (abstract_validator_default()) {
  constructor(nullable) {
    super();
    this.nullable = nullable;
  }
  validate(item) {
    this.errors = {};
    this.validateSettings(item, this.errors);
    return this.errors;
  }
  validateSettings(settings, validationErrors) {
    for (const setting of settings) {
      const errors = [];
      switch (setting.type) {
        case 'boolean':
          if (typeof setting.value !== 'boolean' && (!this.nullable || setting.value !== null)) {
            errors.push(this.i18n.t('general.validation.value_must_be_boolean').toString());
          }
          break;
        case 'decimal':
          if ((typeof setting.value !== 'string' || isNaN(setting.value) && isNaN(parseFloat(setting.value))) && (!this.nullable || setting.value !== null)) {
            errors.push(this.i18n.t('general.validation.value_must_be_decimal').toString());
          }
          break;
        case 'integer':
          if ((typeof setting.value !== 'number' || !Number.isInteger(setting.value)) && (!this.nullable || setting.value !== null)) {
            errors.push(this.i18n.t('general.validation.value_must_be_integer').toString());
          }
          break;
        case 'string':
          if (typeof setting.value !== 'string' && (!this.nullable || setting.value !== null)) {
            errors.push(this.i18n.t('general.validation.value_must_be_string').toString());
          }
          break;
      }
      if (errors.length > 0) {
        validationErrors[setting.key] = errors;
      }
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/settings-editor/_logic.ts?vue&type=script&lang=ts&external






let SettingsEditorComponent = class SettingsEditorComponent extends (0,external_vue_class_component_namespaceObject.mixins)(entity_form_mixin) {
  constructor() {
    super(...arguments);
    this.settings = [];
    this.inherited = {};
  }
  created() {
    this.onValueChanged();
  }
  onValueChanged() {
    if (this.value) {
      this.settings = this.value.slice();
      const inherited = {};
      if (this.nullable) {
        for (const setting of this.settings) {
          inherited[setting.key] = setting.value === null;
        }
      }
      this.inherited = Object.assign({}, inherited);
    }
  }
  onUpdate(key) {
    // Cast the setting's value appropriately so that validation works properly
    const index = (0,external_lodash_namespaceObject.findIndex)(this.settings, {
      key
    });
    if (index >= 0) {
      this.settings[index].value = this.castValue(this.settings[index].value, this.settings[index].type, this.nullable);
    }
    // Trigger an input update
    this.$emit('input', this.settings);
  }
  onInheritedToggled(key) {
    for (const setting of this.settings) {
      if (setting.key !== key) {
        continue;
      }
      setting.value = this.inherited[key] ? null : this.castValue(null, setting.type);
      break;
    }
    this.onUpdate(key);
  }
  get item() {
    return this.settings;
  }
  get validator() {
    return new SettingsValidator(this.nullable);
  }
  onSave() {
    this.save();
  }
  /**
   * Casts a value to the correct metadata type
   *
   * @param value
   * @param type
   * @returns
   */
  castValue(value, type, nullable = false) {
    if (nullable && value === null) {
      return value;
    }
    switch (type) {
      case 'boolean':
        return this.castBoolean(value);
      case 'decimal':
        return this.castDecimal(value);
      case 'integer':
        return this.castInteger(value);
      case 'string':
        return value === null ? '' : `${value}`;
      default:
        return `${value}`;
    }
  }
  /**
   * Casts a value to a boolean
   *
   * @param value
   * @returns
   */
  castBoolean(value) {
    switch (typeof value) {
      case 'boolean':
        return value;
      case 'number':
        return value === 1;
      case 'string':
        return !!(value === 'true' || value === '1');
      default:
        return false;
    }
  }
  /**
   * Casts a value to a decimal string
   *
   * @param value
   * @returns
   */
  castDecimal(value) {
    switch (typeof value) {
      case 'boolean':
        return value ? '1' : '0';
      case 'number':
        return value.toString();
      case 'string':
        return value;
      default:
        return '0';
    }
  }
  /**
   * Casts a value to an integer number
   *
   * @param value
   * @returns
   */
  castInteger(value) {
    switch (typeof value) {
      case 'boolean':
        return value ? 1 : 0;
      case 'number':
        return value;
      case 'string':
        return parseInt(value);
      default:
        return 0;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SettingsEditorComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], SettingsEditorComponent.prototype, "title", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], SettingsEditorComponent.prototype, "nullable", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], SettingsEditorComponent.prototype, "onValueChanged", null);
SettingsEditorComponent = (0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Component)({})], SettingsEditorComponent);
/* harmony default export */ var settings_editor_logicvue_type_script_lang_ts_external = (SettingsEditorComponent);
;// CONCATENATED MODULE: ./src/components/settings-editor/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var components_settings_editor_logicvue_type_script_lang_ts_external = (settings_editor_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/settings-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var settings_editor_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(2712);
;// CONCATENATED MODULE: ./src/components/settings-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/settings-editor/index.vue



;


/* normalize component */

var settings_editor_component = normalizeComponent(
  components_settings_editor_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_5cf624e5_external_render,
  _templatevue_type_template_id_5cf624e5_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var settings_editor = (settings_editor_component.exports);
;// CONCATENATED MODULE: external "vuetify/lib/components/VCombobox"
var VCombobox_namespaceObject = require("vuetify/lib/components/VCombobox");
;// CONCATENATED MODULE: external "vuetify/lib/components/VSelect"
var VSelect_namespaceObject = require("vuetify/lib/components/VSelect");
;// CONCATENATED MODULE: ./node_modules/vuetify-loader/lib/loader.js??ruleSet[1].rules[0].use!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[5]!./src/components/mapping-tool/value-settings-editor/_template.html?vue&type=template&id=72c40ea1&external




var _templatevue_type_template_id_72c40ea1_external_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vp-value-settings-editor"
  }, [_c('div', {
    staticClass: "vp-value-settings-editor__fieldGroup",
    class: _vm.actionField
  }, [_c('section', {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes",
    class: {
      'vp-value-settings-editor__fieldGroup__valueTypes--rule': _vm.showValueRule
    }
  }, [_c(VSelect_namespaceObject.VSelect, {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes__type",
    class: {
      'vp-value-settings-editor__fieldGroup__valueTypes__type--rule': _vm.showValueRule
    },
    attrs: {
      "items": _vm.valueTypes,
      "label": _vm.$t('mapping.field.value_type'),
      "placeholder": _vm.$t('mapping.field.value_type'),
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": ""
    },
    model: {
      value: _vm.valueType,
      callback: function ($$v) {
        _vm.valueType = $$v;
      },
      expression: "valueType"
    }
  }), _vm.showValueColumn ? _c(VAutocomplete_namespaceObject.VAutocomplete, {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes__column",
    attrs: {
      "items": _vm.sourceDataFields,
      "label": _vm.$t('mapping.action.choose_column'),
      "placeholder": _vm.$t('mapping.action.choose_column'),
      "error": _vm.error,
      "error-messages": _vm.errorMessages,
      "persistent-placeholder": "",
      "solo": "",
      "dense": "",
      "flat": "",
      "auto-select-first": "",
      "menu-props": {
        contentClass: 'vp-menu'
      }
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.valueColumn,
      callback: function ($$v) {
        _vm.valueColumn = $$v;
      },
      expression: "valueColumn"
    }
  }) : _vm._e(), _vm.showValue ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes__value",
    attrs: {
      "items": _vm.valueStringTypes,
      "label": _vm.$t('general.field.value'),
      "placeholder": _vm.$t('general.field.value'),
      "error": _vm.error,
      "error-messages": _vm.errorMessages,
      "solo": "",
      "dense": "",
      "flat": ""
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.valueString,
      callback: function ($$v) {
        _vm.valueString = $$v;
      },
      expression: "valueString"
    }
  }) : _vm._e(), _vm.showValueRule ? _c('vp-nested-rule', {
    attrs: {
      "data-source-id": _vm.dataSourceId,
      "mappable-fields": _vm.mappableFields,
      "data-source-rules": _vm.dataSourceRules,
      "source-data-fields": _vm.sourceDataFields,
      "field": null
    },
    on: {
      "changed": _vm.onValueRuleChanged,
      "save-nested-rule": _vm.saveValueRule
    },
    model: {
      value: _vm.valueRule,
      callback: function ($$v) {
        _vm.valueRule = $$v;
      },
      expression: "valueRule"
    }
  }) : _vm._e()], 1), _vm.showAdditionalColumn ? _c('section', [_vm.showSeparator ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes__separator",
    attrs: {
      "items": _vm.valueStringTypes,
      "label": _vm.$t('mapping.field.separator'),
      "placeholder": _vm.$t('mapping.field.separator'),
      "solo": "",
      "dense": "",
      "flat": ""
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.separator,
      callback: function ($$v) {
        _vm.separator = $$v;
      },
      expression: "separator"
    }
  }) : _vm._e(), _vm.showWith ? _c(VCombobox_namespaceObject.VCombobox, {
    staticClass: "vp-value-settings-editor__fieldGroup__valueTypes__with",
    attrs: {
      "items": _vm.valueStringTypes,
      "label": _vm.$t('mapping.field.with'),
      "placeholder": _vm.$t('mapping.field.with'),
      "solo": "",
      "dense": "",
      "flat": ""
    },
    on: {
      "change": _vm.onUpdate
    },
    model: {
      value: _vm.withString,
      callback: function ($$v) {
        _vm.withString = $$v;
      },
      expression: "withString"
    }
  }) : _vm._e()], 1) : _vm._e()])]);
};
var _templatevue_type_template_id_72c40ea1_external_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/mapping-tool/value-settings-editor/_template.html?vue&type=template&id=72c40ea1&external

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/mapping-tool/value-settings-editor/_logic.ts?vue&type=script&lang=ts&external




let ValueSettingsEditorComponent = class ValueSettingsEditorComponent extends external_vue_property_decorator_namespaceObject.Vue {
  constructor() {
    super(...arguments);
    this.valueSettings = null;
    this.valueRule = null;
    this.valueType = 'column';
  }
  created() {
    if (this.value) {
      this.valueSettings = Object.assign({}, this.value);
      this.readValueType();
      this.loadValueRule();
    }
  }
  onValueUpdated() {
    if (this.value) {
      this.valueSettings = Object.assign({}, this.value);
      this.readValueType();
    } else {
      this.valueSettings = null;
    }
  }
  onUpdate() {
    this.$emit('input', this.valueSettings);
  }
  readValueType() {
    if (!this.valueSettings) {
      return;
    }
    if ('value' in this.valueSettings) {
      this.valueType = 'value';
    } else if ('valueRuleId' in this.valueSettings) {
      this.valueType = 'rule';
    }
  }
  loadValueRule() {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      if (this.valueRuleId) {
        this.valueRule = yield this.$serviceContainer.mappingService.ruleService.loadRule(this.valueRuleId);
      } else {
        this.valueRule = null;
      }
    });
  }
  get valueTypes() {
    return [{
      text: this.$t('mapping.type.column').toString(),
      value: 'column'
    }, {
      text: this.$t('mapping.type.value').toString(),
      value: 'value'
    }, {
      text: this.$t('mapping.type.rule').toString(),
      value: 'rule'
    }];
  }
  get valueStringTypes() {
    return [{
      text: this.$t('mapping.values.empty').toString(),
      value: ''
    }, {
      text: this.$t('mapping.values.space').toString(),
      value: ' '
    }, {
      text: this.$t('mapping.values.new_line').toString(),
      value: '\n'
    }, {
      text: this.$t('mapping.values.tab').toString(),
      value: '\t'
    }, {
      text: this.$t('mapping.values.arrow').toString(),
      value: '->'
    }];
  }
  get showValueColumn() {
    return this.valueType === 'column';
  }
  get showValue() {
    return this.valueType === 'value';
  }
  get showValueRule() {
    return this.valueType === 'rule';
  }
  get showAdditionalColumn() {
    if (this.showSeparator || this.showWith) {
      return true;
    } else {
      return false;
    }
  }
  get actionField() {
    if (this.showSeparator || this.showWith) {
      return 'vp-value-settings-editor__fieldGroup--actionField';
    } else {
      return '';
    }
  }
  get valueColumn() {
    if (!this.valueSettings) {
      return null;
    }
    if (!('valueColumn' in this.valueSettings)) {
      return null;
    }
    return this.valueSettings.valueColumn;
  }
  set valueColumn(valueColumn) {
    var _a, _b;
    if (valueColumn === undefined) {
      return;
    }
    this.valueSettings = this.buildValueSettings(null, null, valueColumn, (_a = this.getSelectedItemValue(this.separator)) !== null && _a !== void 0 ? _a : null, (_b = this.getSelectedItemValue(this.withString)) !== null && _b !== void 0 ? _b : null);
    this.onUpdate();
  }
  getValueStyleType(string) {
    for (const valueType of this.valueStringTypes) {
      if (string === valueType.value) {
        return valueType;
      }
    }
    return string;
  }
  getSelectedItemValue(value) {
    if (typeof value === 'object' && value !== null) {
      value = value === null || value === void 0 ? void 0 : value.value;
    }
    if (typeof value === 'number') {
      value = value.toString();
    }
    return value;
  }
  get valueString() {
    if (!this.valueSettings) {
      return null;
    }
    if (!('value' in this.valueSettings)) {
      return null;
    }
    return this.getValueStyleType(this.valueSettings.value);
  }
  set valueString(value) {
    var _a, _b;
    value = this.getSelectedItemValue(value);
    if (value === undefined) {
      return;
    }
    this.valueSettings = this.buildValueSettings(value, null, null, (_a = this.getSelectedItemValue(this.separator)) !== null && _a !== void 0 ? _a : null, (_b = this.getSelectedItemValue(this.withString)) !== null && _b !== void 0 ? _b : null);
    this.onUpdate();
  }
  get valueRuleId() {
    if (!this.valueSettings) {
      return null;
    }
    if (!('valueRuleId' in this.valueSettings)) {
      return null;
    }
    return this.valueSettings.valueRuleId;
  }
  set valueRuleId(valueRuleId) {
    var _a, _b;
    if (valueRuleId === undefined) {
      return;
    }
    this.valueSettings = this.buildValueSettings(null, valueRuleId, null, (_a = this.getSelectedItemValue(this.separator)) !== null && _a !== void 0 ? _a : null, (_b = this.getSelectedItemValue(this.withString)) !== null && _b !== void 0 ? _b : null);
    this.onUpdate();
  }
  get separator() {
    if (!this.valueSettings) {
      return undefined;
    }
    if (!('separator' in this.valueSettings)) {
      return undefined;
    }
    return this.getValueStyleType(this.valueSettings.separator);
  }
  set separator(separator) {
    if (!this.valueSettings) {
      return;
    }
    separator = this.getSelectedItemValue(separator);
    if (separator === undefined) {
      return;
    }
    if (separator === null && 'separator' in this.valueSettings) {
      delete this.valueSettings.separator;
    } else {
      this.valueSettings.separator = separator;
    }
    this.onUpdate();
  }
  get withString() {
    if (!this.valueSettings) {
      return undefined;
    }
    if (!('with' in this.valueSettings)) {
      return undefined;
    }
    return this.getValueStyleType(this.valueSettings.with);
  }
  set withString(withValue) {
    if (!this.valueSettings) {
      return;
    }
    withValue = this.getSelectedItemValue(withValue);
    if (withValue === undefined) {
      return;
    }
    if (withValue === null && 'with' in this.valueSettings) {
      delete this.valueSettings.with;
    } else {
      this.valueSettings.with = withValue;
    }
    this.onUpdate();
  }
  buildValueSettings(value, valueRuleId, valueColumn, separator, withValue) {
    const valueSettings = {};
    if (value !== null) {
      valueSettings.value = value;
    }
    if (valueRuleId !== null) {
      valueSettings.valueRuleId = valueRuleId;
    }
    if (valueColumn !== null) {
      valueSettings.valueColumn = valueColumn;
    }
    if (separator !== null) {
      valueSettings.separator = separator;
    }
    if (withValue !== null) {
      valueSettings.with = withValue;
    }
    return valueSettings;
  }
  saveValueRule(valueRule) {
    return (0,external_tslib_namespaceObject.__awaiter)(this, void 0, void 0, function* () {
      const savedValueRule = yield this.$serviceContainer.mappingService.ruleService.saveRule(valueRule);
      if (this.dataSourceRules.some(e => e.id === (savedValueRule === null || savedValueRule === void 0 ? void 0 : savedValueRule.id))) {
        // Update the existing rule
        this.dataSourceRules.splice(this.dataSourceRules.findIndex(e => e.id === (savedValueRule === null || savedValueRule === void 0 ? void 0 : savedValueRule.id)), 1, savedValueRule);
      } else {
        // Add to the array of rules if it doesn't already exist
        this.dataSourceRules.push(savedValueRule);
      }
      this.onValueRuleChanged(savedValueRule);
    });
  }
  onValueRuleChanged(valueRule) {
    this.valueRule = valueRule;
    if (this.valueRule) {
      this.valueRuleId = this.valueRule.id;
    } else {
      this.valueSettings = null;
    }
    this.onUpdate();
  }
  onValueTypeChange() {
    if (this.valueSettings) {
      if (this.valueType in this.valueSettings) {
        return;
      } else if (this.valueType === 'rule' && 'valueRuleId' in this.valueSettings) {
        return;
      }
    }
    switch (this.valueType) {
      case 'value':
        this.valueString = null;
        break;
      case 'rule':
        this.valueRuleId = '';
        break;
      case 'column':
        this.valueColumn = '';
        break;
    }
  }
};
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "value", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "dataSourceId", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "mappableFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "dataSourceRules", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "sourceDataFields", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "error", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)()], ValueSettingsEditorComponent.prototype, "errorMessages", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ValueSettingsEditorComponent.prototype, "showSeparator", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Prop)({
  type: Boolean,
  default: false
})], ValueSettingsEditorComponent.prototype, "showWith", void 0);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('value')], ValueSettingsEditorComponent.prototype, "onValueUpdated", null);
(0,external_tslib_namespaceObject.__decorate)([(0,external_vue_property_decorator_namespaceObject.Watch)('valueType')], ValueSettingsEditorComponent.prototype, "onValueTypeChange", null);
ValueSettingsEditorComponent = (0,external_tslib_namespaceObject.__decorate)([external_vue_property_decorator_namespaceObject.Component], ValueSettingsEditorComponent);
/* harmony default export */ var value_settings_editor_logicvue_type_script_lang_ts_external = (ValueSettingsEditorComponent);
;// CONCATENATED MODULE: ./src/components/mapping-tool/value-settings-editor/_logic.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var mapping_tool_value_settings_editor_logicvue_type_script_lang_ts_external = (value_settings_editor_logicvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./src/components/mapping-tool/value-settings-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external
var value_settings_editor_stylesvue_type_style_index_0_prod_lang_scss_external = __webpack_require__(8248);
;// CONCATENATED MODULE: ./src/components/mapping-tool/value-settings-editor/_styles.scss?vue&type=style&index=0&prod&lang=scss&external

;// CONCATENATED MODULE: ./src/components/mapping-tool/value-settings-editor/index.vue



;


/* normalize component */

var value_settings_editor_component = normalizeComponent(
  mapping_tool_value_settings_editor_logicvue_type_script_lang_ts_external,
  _templatevue_type_template_id_72c40ea1_external_render,
  _templatevue_type_template_id_72c40ea1_external_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var value_settings_editor = (value_settings_editor_component.exports);
;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_namespaceObject);
;// CONCATENATED MODULE: ./src/i18n/translations/messages.ts
const messages = {
  en: {
    authentication: {
      action: {
        forgot_your_password: 'Forgotten Your Password',
        login: 'Log In',
        logout: 'Log Out',
        new_user: 'New User',
        reset_password: 'Reset Password',
        sign_in: 'Sign In',
        sign_in_google: 'Sign in with Google',
        sign_out_google: 'Sign Out',
        sign_up: 'Sign Up'
      },
      error: {
        login_failed_invalid_details: 'Login failed - invalid details',
        login_failed_server_error: 'Login failed - server error',
        password_reset_failed: 'Password reset failed - please try again',
        profile_update_failed: 'Profile update failed - please try again',
        registration_failed: 'Registration failed - please try again'
      },
      field: {
        email: 'Email Address',
        first_name: 'First Name',
        last_name: 'Last Name',
        password: 'Password',
        password_confirm: 'Confirm Password',
        password_current: 'Current Password',
        password_new: 'New Password',
        register_terms: 'I agree to the terms & conditions',
        username: 'Username or Email Address'
      },
      message: {
        forgot_password_content: 'Please enter your email address, you will then receive an email message with instructions on how to reset your password.',
        forgot_password_heading: 'Forgotten Your Password',
        login_heading: 'Login',
        password_reset_request_received: 'Password reset instructions have been sent to your email',
        password_reset_successful: 'Your password has been reset - please login',
        profile_updated_successfully: 'Profile updated successfully',
        register_content: 'Please enter your details below to sign up',
        register_heading: 'Get Started',
        registration_successful: 'Registration successful - please login',
        reset_password_content: 'Please enter your new password.',
        reset_password_heading: 'Reset Your Password',
        session_expired: 'Your session has expired'
      },
      validation: {
        password_mismatch: 'Passwords do not match'
      }
    },
    general: {
      action: {
        add: 'Add',
        add_rule: 'Add Rule',
        close: 'Close',
        delete: 'Delete',
        edit: 'Edit',
        save: 'Save',
        select: 'Choose'
      },
      error: {
        error_deleting: 'Error deleting',
        error_loading: 'Error loading',
        failed_saving_server_error: 'Error saving - please check your details and try again'
      },
      field: {
        admin: 'Admin',
        basic_details: 'Basic details',
        date_created: 'Date created',
        date_updated: 'Date updated',
        description: 'Description',
        details: 'Details',
        id: 'Id',
        inherit: 'Inherit',
        members: 'Members',
        name: 'Name',
        options: 'Options',
        owner: 'Owner',
        position: 'Position',
        project: 'Project',
        title: 'Title',
        user: 'User',
        users: 'Users',
        value: 'Value'
      },
      message: {
        deleted_successfully: 'Deleted successfully',
        saved_successfully: 'Saved successfully',
        welcome_back_name: 'Welcome back {name}!'
      },
      validation: {
        please_enter_title: 'Please enter a title.',
        value_must_be_boolean: 'Value must be of type boolean',
        value_must_be_decimal: 'Value must be of type decimal',
        value_must_be_integer: 'Value must be of type integer',
        value_must_be_string: 'Value must be of type string'
      }
    },
    profile: {
      message: {
        oauth_login_active: 'You are currently logged in via an OAuth provider',
        oauth_login_synced: 'Your profile data will be kept up-to-date automatically'
      }
    },
    project: {
      action: {
        add_team: 'Add Team',
        create: 'New Project',
        create_member: 'Add Project Member',
        delete: 'Delete Project',
        delete_member: 'Remove Project Member',
        delete_team: 'Remove Team',
        edit: 'Edit Project',
        edit_member: 'Edit Project Member',
        leave_project: 'Leave Project',
        view: 'View Project'
      },
      field: {
        api_key: 'API Key',
        team: 'Team'
      },
      message: {
        delete_confirmation: `
                    <p>Are you sure you want to delete this project?</p>
                    <p>This action cannot be undone.</p>
                `,
        delete_member_confirmation: `
                    <p>Are you sure you want to remove this project member?</p>
                `,
        delete_team_confirmation: `
                    <p>Are you sure you want to remove this team?</p>
                `,
        leave_project_confirmation: `
                    <p>Are you sure you want to leave this project?</p>
                `,
        left_project_successfully: 'You have left the project successfully',
        only_owners_can_delete: 'Only project owners can delete the project',
        project: 'Project'
      },
      error: {
        error_leaving_project: 'Error leaving project - please try again'
      }
    },
    mapping: {
      action: {
        choose_column_placeholder: 'Choose Data Source',
        choose_column: 'Data Source',
        confirm: 'Are you sure?',
        if: 'If',
        then: 'Then',
        view_more: 'View More'
      },
      type: {
        condition: 'Condition',
        action: 'Action',
        rule: 'Rule',
        column: 'Column',
        value: 'Value'
      },
      values: {
        new_line: 'New Line',
        tab: 'Tab',
        space: 'Space',
        arrow: 'Arrow',
        empty: 'Empty'
      },
      field: {
        operator: 'Operator',
        property: 'Property',
        separator: 'Separator',
        type: 'Type',
        value_type: 'Value Type',
        with: 'With'
      },
      message: {
        mapped_data: 'Mapped Data',
        mapping_rules: 'Mapping Rules',
        raw_data: 'Raw Data',
        results: 'Results',
        viewing: 'Viewing'
      },
      rules: {
        editing: 'Editing',
        conditions_actions: 'Conditions & Actions',
        select: 'Select a rule'
      },
      error: {
        delete_single_condition: 'At least one condition is required',
        delete_single_action: 'At least one action is required'
      },
      validation: {
        action_invalid: 'Action {index} is not valid',
        action_required: 'At least one action is required',
        condition_invalid: 'Condition {index} is not valid',
        condition_required: 'At least one condition is required',
        first_action_type: 'The first action must be a take',
        please_add_rule: 'Please enter a value',
        please_enter_value: 'Please enter a value',
        please_select_column: 'Please select a column',
        please_select_type: 'Please select a type',
        please_select_operator: 'Please select an operator'
      }
    },
    team: {
      action: {
        create: 'New Team',
        create_member: 'New Team Member',
        delete: 'Delete Team',
        delete_member: 'Delete Team Member',
        edit: 'Edit Team',
        edit_member: 'Edit Team Member',
        edit_sub_team: 'Edit Sub Team',
        leave_team: 'Leave Team',
        view: 'View Team',
        view_sub_team: 'View Sub Team'
      },
      field: {
        members: 'Members',
        members_count: 'Members ({count})',
        parent_team: 'Parent Team',
        sub_teams: 'Sub Teams',
        sub_teams_count: 'Sub Teams ({count})'
      },
      message: {
        delete_confirmation: `
                    <p>Are you sure you want to delete this team?</p>
                    <p>This action cannot be undone.</p>
                `,
        delete_member_confirmation: `
                    <p>Are you sure you want to delete this team member?</p>
                `,
        leave_team_confirmation: `
                    <p>Are you sure you want to leave this team?</p>
                `,
        left_team_successfully: 'You have left the team successfully',
        no_sub_teams: 'This team does not have any children',
        only_owners_can_delete: 'Only team owners can delete the team',
        please_create_team_first: 'Sub teams can only be added once the team has first been created'
      },
      error: {
        error_leaving_team: 'Error leaving team - please try again'
      }
    }
  }
};
/* harmony default export */ var translations_messages = (messages);
;// CONCATENATED MODULE: ./src/library.ts






















// Define all the components to export
const components = {
  AccountWidgetComponent: account_widget,
  LoginComponent: login,
  MappingToolComponent: tool,
  MappingRuleComponent: mapping_rule,
  MappableFieldComponent: mappable_field,
  MappingRuleDialogComponent: rule_dialog,
  MappingRuleFormComponent: rule_form,
  MappingConditionFormComponent: condition_form,
  MappingActionFormComponent: action_form,
  MyTeamsComponent: my_teams,
  NestedRuleComponent: nested_rule,
  ValueSettingsEditorComponent: value_settings_editor,
  ReorderIconsComponent: reorder_icons,
  ProfileFormComponent: profile_form,
  ProjectFormComponent: project_form,
  ProjectIndexComponent: project_index,
  ProjectMembersComponent: project_members,
  ProjectSelectorComponent: project_selector,
  ProjectTeamsComponent: teams,
  SettingsEditorComponent: settings_editor,
  messages: translations_messages
};
// Define html tags to components
const componentTags = {
  'vp-account-widget': account_widget,
  'vp-login': login,
  'vp-mapping-tool': tool,
  'vp-mapping-rule': mapping_rule,
  'vp-mappable-field': mappable_field,
  'vp-rule-dialog': rule_dialog,
  'vp-mapping-rule-form': rule_form,
  'vp-condition-form': condition_form,
  'vp-action-form': action_form,
  'vp-my-teams': my_teams,
  'vp-nested-rule': nested_rule,
  'vp-value-settings-editor': value_settings_editor,
  'vp-reorder-icons': reorder_icons,
  'vp-profile-form': profile_form,
  'vp-project-form': project_form,
  'vp-project-index': project_index,
  'vp-project-members': project_members,
  'vp-project-selector': project_selector,
  'vp-project-teams': teams,
  'vp-settings-editor': settings_editor
};
// Register each component globally in Vue so it can be used anywhere
for (const tag in componentTags) {
  external_vue_default().component(tag, componentTags[tag]);
}
/* harmony default export */ var library = (components);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (library);


}();
module.exports = __webpack_exports__["default"];
/******/ })()
;
//# sourceMappingURL=vue-js-micro-service-components.common.js.map